//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class BaseAPI {
  constructor(protected configuration: Configuration) {}

  getBaseUrl(prefix: string, baseUrl: string) {
    const finalBaseUrl = baseUrl || this.configuration.basePath || BASE_PATH;

    return `${finalBaseUrl}${prefix}`;
  }

  async transformOptions(options: RequestInit): Promise<RequestInit> {
    if (options.headers) {
      let apiKey: string;
      if (this.configuration.apiKeyPromise) {
        apiKey = await this.configuration.apiKeyPromise();
      } else {
        apiKey = this.configuration.apiKey;
      }
      (options.headers as any)["authorization"] = apiKey;
      if (this.configuration.headers) {
        options.headers = {
          ...options.headers,
          ...this.configuration.headers,
        };
      }
      for (const middleware of this.configuration.middlewares) {
        options = (await middleware.pre(options)) || options;
      }
    }

    return Promise.resolve(options);
  }

  async transformResult(
    url: string,
    response: Response,
    processor: (response: Response) => Promise<any>
  ): Promise<any> {
    // is there middlware in configuration
    for (const middleware of this.configuration.middlewares) {
      response = (await middleware.post(response)) || response;
    }

    return processor(response);
  }
}

export interface IActionApi {

    searchIds(searchQuery: SearchQueryOfActionSearchCriteria): Promise<number[]>;

    baseSearch(searchQuery: SearchQueryOfActionSearchCriteria): Promise<PaginatedResultsOfActionGridDto>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]>;
}

export class ActionApi extends BaseAPI implements IActionApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    searchIds(searchQuery: SearchQueryOfActionSearchCriteria): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Action/search-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchIds(_response));
        });
    }

    protected processSearchIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfActionSearchCriteria): Promise<PaginatedResultsOfActionGridDto> {
        let url_ = this.baseUrl + "/api/Action/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfActionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfActionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfActionGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Action/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Action/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IAzureMemberApi {

    getAzureMember(id: number): Promise<AzureMemberDetailDto>;

    getAzureMemberProfile(id: number): Promise<AzureUserDto>;

    searchIds(searchQuery: SearchQueryOfAzureMemberSearchCriteria): Promise<number[]>;

    baseSearch(searchQuery: SearchQueryOfAzureMemberSearchCriteria): Promise<PaginatedResultsOfAzureMemberGridDto>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]>;
}

export class AzureMemberApi extends BaseAPI implements IAzureMemberApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAzureMember(id: number): Promise<AzureMemberDetailDto> {
        let url_ = this.baseUrl + "/api/AzureMember/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAzureMember(_response));
        });
    }

    protected processGetAzureMember(response: Response): Promise<AzureMemberDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AzureMemberDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AzureMemberDetailDto>(null as any);
    }

    getAzureMemberProfile(id: number): Promise<AzureUserDto> {
        let url_ = this.baseUrl + "/api/AzureMember/{id}/azure-profile";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAzureMemberProfile(_response));
        });
    }

    protected processGetAzureMemberProfile(response: Response): Promise<AzureUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AzureUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AzureUserDto>(null as any);
    }

    searchIds(searchQuery: SearchQueryOfAzureMemberSearchCriteria): Promise<number[]> {
        let url_ = this.baseUrl + "/api/AzureMember/search-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchIds(_response));
        });
    }

    protected processSearchIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfAzureMemberSearchCriteria): Promise<PaginatedResultsOfAzureMemberGridDto> {
        let url_ = this.baseUrl + "/api/AzureMember/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfAzureMemberGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfAzureMemberGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfAzureMemberGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/AzureMember/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/AzureMember/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IBeneficiaryCompanyApi {

    getDisplayName(id: number): Promise<string>;

    getBeneficiaryCompany(id: number): Promise<SiegeSocialDto>;

    getBeneficiaryCompanyLieuxFormation(id: number): Promise<HopeViewLieuFormationDto[]>;

    searchIds(searchQuery: SearchQueryOfBeneficiaryCompanySearchCriteria): Promise<number[]>;

    baseSearch(searchQuery: SearchQueryOfBeneficiaryCompanySearchCriteria): Promise<PaginatedResultsOfBeneficiaryCompanyGridDto>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]>;
}

export class BeneficiaryCompanyApi extends BaseAPI implements IBeneficiaryCompanyApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getDisplayName(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/BeneficiaryCompany/display-name/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getBeneficiaryCompany(id: number): Promise<SiegeSocialDto> {
        let url_ = this.baseUrl + "/api/BeneficiaryCompany/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBeneficiaryCompany(_response));
        });
    }

    protected processGetBeneficiaryCompany(response: Response): Promise<SiegeSocialDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SiegeSocialDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SiegeSocialDto>(null as any);
    }

    getBeneficiaryCompanyLieuxFormation(id: number): Promise<HopeViewLieuFormationDto[]> {
        let url_ = this.baseUrl + "/api/BeneficiaryCompany/{id}/lieuxformation";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBeneficiaryCompanyLieuxFormation(_response));
        });
    }

    protected processGetBeneficiaryCompanyLieuxFormation(response: Response): Promise<HopeViewLieuFormationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HopeViewLieuFormationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HopeViewLieuFormationDto[]>(null as any);
    }

    searchIds(searchQuery: SearchQueryOfBeneficiaryCompanySearchCriteria): Promise<number[]> {
        let url_ = this.baseUrl + "/api/BeneficiaryCompany/search-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchIds(_response));
        });
    }

    protected processSearchIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfBeneficiaryCompanySearchCriteria): Promise<PaginatedResultsOfBeneficiaryCompanyGridDto> {
        let url_ = this.baseUrl + "/api/BeneficiaryCompany/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfBeneficiaryCompanyGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfBeneficiaryCompanyGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfBeneficiaryCompanyGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/BeneficiaryCompany/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/BeneficiaryCompany/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IBeneficiaryPersonApi {

    getBeneficiaryPerson(id: number): Promise<EditBeneficiaryPersonDto>;

    saveBeneficiaryPerson(dto: EditBeneficiaryPersonDto): Promise<EditBeneficiaryPersonDto>;

    getDisplayName(id: number): Promise<string>;

    getBicFromAccount(account: string): Promise<string>;

    getPersonneSuivi(idapprenant: number): Promise<ApprenantSuiviDto[]>;

    getIdpersonneForSelector(dto: PersonneFormeIdsDto): Promise<number | null>;

    searchBeneficiaryForSuivi(dto: SearchBeneficiaryDto): Promise<BeneficiarySearchReturnDto>;

    searchIds(searchQuery: SearchQueryOfBeneficiaryPersonSearchCriteria): Promise<number[]>;

    baseSearch(searchQuery: SearchQueryOfBeneficiaryPersonSearchCriteria): Promise<PaginatedResultsOfBeneficiaryPersonGridDto>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]>;
}

export class BeneficiaryPersonApi extends BaseAPI implements IBeneficiaryPersonApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getBeneficiaryPerson(id: number): Promise<EditBeneficiaryPersonDto> {
        let url_ = this.baseUrl + "/api/BeneficiaryPerson/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBeneficiaryPerson(_response));
        });
    }

    protected processGetBeneficiaryPerson(response: Response): Promise<EditBeneficiaryPersonDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditBeneficiaryPersonDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditBeneficiaryPersonDto>(null as any);
    }

    saveBeneficiaryPerson(dto: EditBeneficiaryPersonDto): Promise<EditBeneficiaryPersonDto> {
        let url_ = this.baseUrl + "/api/BeneficiaryPerson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveBeneficiaryPerson(_response));
        });
    }

    protected processSaveBeneficiaryPerson(response: Response): Promise<EditBeneficiaryPersonDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditBeneficiaryPersonDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditBeneficiaryPersonDto>(null as any);
    }

    getDisplayName(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/BeneficiaryPerson/{id}/display-name";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getBicFromAccount(account: string): Promise<string> {
        let url_ = this.baseUrl + "/api/BeneficiaryPerson/bic-from-account/{account}";
        if (account === undefined || account === null)
            throw new Error("The parameter 'account' must be defined.");
        url_ = url_.replace("{account}", encodeURIComponent("" + account));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBicFromAccount(_response));
        });
    }

    protected processGetBicFromAccount(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getPersonneSuivi(idapprenant: number): Promise<ApprenantSuiviDto[]> {
        let url_ = this.baseUrl + "/api/BeneficiaryPerson/apprenant/{idapprenant}/suivi";
        if (idapprenant === undefined || idapprenant === null)
            throw new Error("The parameter 'idapprenant' must be defined.");
        url_ = url_.replace("{idapprenant}", encodeURIComponent("" + idapprenant));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPersonneSuivi(_response));
        });
    }

    protected processGetPersonneSuivi(response: Response): Promise<ApprenantSuiviDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApprenantSuiviDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprenantSuiviDto[]>(null as any);
    }

    getIdpersonneForSelector(dto: PersonneFormeIdsDto): Promise<number | null> {
        let url_ = this.baseUrl + "/api/BeneficiaryPerson/idpersonne-for-selector";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIdpersonneForSelector(_response));
        });
    }

    protected processGetIdpersonneForSelector(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    searchBeneficiaryForSuivi(dto: SearchBeneficiaryDto): Promise<BeneficiarySearchReturnDto> {
        let url_ = this.baseUrl + "/api/BeneficiaryPerson/search-for-suivi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchBeneficiaryForSuivi(_response));
        });
    }

    protected processSearchBeneficiaryForSuivi(response: Response): Promise<BeneficiarySearchReturnDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BeneficiarySearchReturnDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BeneficiarySearchReturnDto>(null as any);
    }

    searchIds(searchQuery: SearchQueryOfBeneficiaryPersonSearchCriteria): Promise<number[]> {
        let url_ = this.baseUrl + "/api/BeneficiaryPerson/search-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchIds(_response));
        });
    }

    protected processSearchIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfBeneficiaryPersonSearchCriteria): Promise<PaginatedResultsOfBeneficiaryPersonGridDto> {
        let url_ = this.baseUrl + "/api/BeneficiaryPerson/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfBeneficiaryPersonGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfBeneficiaryPersonGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfBeneficiaryPersonGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/BeneficiaryPerson/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/BeneficiaryPerson/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IChatbotApi {

    ask(dto: AskRequestDto): Promise<AskResponseDto>;
}

export class ChatbotApi extends BaseAPI implements IChatbotApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    ask(dto: AskRequestDto): Promise<AskResponseDto> {
        let url_ = this.baseUrl + "/api/Chatbot/ask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAsk(_response));
        });
    }

    protected processAsk(response: Response): Promise<AskResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AskResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AskResponseDto>(null as any);
    }
}

export interface ICompletedActionApi {

    getCompletedAction(id: number): Promise<EditCompletedActionDto>;

    deleteCompletedAction(id: number): Promise<boolean>;

    saveCompletedAction(dto: EditCompletedActionDto): Promise<EditCompletedActionDto>;

    getDisplayName(id: number): Promise<string>;

    searchIds(searchQuery: SearchQueryOfCompletedActionSearchCriteria): Promise<number[]>;

    baseSearch(searchQuery: SearchQueryOfCompletedActionSearchCriteria): Promise<PaginatedResultsOfCompletedActionGridDto>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]>;
}

export class CompletedActionApi extends BaseAPI implements ICompletedActionApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getCompletedAction(id: number): Promise<EditCompletedActionDto> {
        let url_ = this.baseUrl + "/api/CompletedAction/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCompletedAction(_response));
        });
    }

    protected processGetCompletedAction(response: Response): Promise<EditCompletedActionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditCompletedActionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditCompletedActionDto>(null as any);
    }

    deleteCompletedAction(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/CompletedAction/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteCompletedAction(_response));
        });
    }

    protected processDeleteCompletedAction(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    saveCompletedAction(dto: EditCompletedActionDto): Promise<EditCompletedActionDto> {
        let url_ = this.baseUrl + "/api/CompletedAction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveCompletedAction(_response));
        });
    }

    protected processSaveCompletedAction(response: Response): Promise<EditCompletedActionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditCompletedActionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditCompletedActionDto>(null as any);
    }

    getDisplayName(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/CompletedAction/{id}/display-name";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    searchIds(searchQuery: SearchQueryOfCompletedActionSearchCriteria): Promise<number[]> {
        let url_ = this.baseUrl + "/api/CompletedAction/search-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchIds(_response));
        });
    }

    protected processSearchIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfCompletedActionSearchCriteria): Promise<PaginatedResultsOfCompletedActionGridDto> {
        let url_ = this.baseUrl + "/api/CompletedAction/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfCompletedActionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfCompletedActionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfCompletedActionGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/CompletedAction/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/CompletedAction/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IGlobalSearchApi {

    search(filter: string | null | undefined): Promise<GlobalSearchRowDto[]>;
}

export class GlobalSearchApi extends BaseAPI implements IGlobalSearchApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    search(filter: string | null | undefined): Promise<GlobalSearchRowDto[]> {
        let url_ = this.baseUrl + "/api/GlobalSearch/search?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        });
    }

    protected processSearch(response: Response): Promise<GlobalSearchRowDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlobalSearchRowDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlobalSearchRowDto[]>(null as any);
    }
}

export interface IHopeViewApi {

    getPersonneMainData(idpersonne: number): Promise<HopeViewPersonneMainDataDto>;

    getPersonneSignaletique(idpersonne: number): Promise<HopeViewSignaletiquePersonneDto>;

    getPersonneSuivi(idpersonne: number, ids: HopeViewPersonneMainDataDto): Promise<HopeViewSuiviActionDto[]>;

    getPersonneInscriptions(idapprenant: number): Promise<HopeViewInscriptionDto[]>;

    getApprenantHoraires(idapprenant: number, selectedDate: Date): Promise<HopeViewHoraireDto[]>;

    getPersonneContrats(idapprenant: number): Promise<HopeViewContratDto[]>;

    getPersonneReprentants(idapprenant: number): Promise<HopeViewRepresentantDto[]>;

    getPersonneApprenants(idrepresentant: number): Promise<HopeViewApprenantDto[]>;

    getFormateurHoraires(idformateur: number, selectedDate: Date): Promise<HopeViewHoraireDto[]>;

    getFormateurClasses(idformateur: number): Promise<HopeViewClasseDto[]>;

    getChefEntrepriseSiegesSociaux(idchefEntreprise: number): Promise<HopeViewSiegeSocialDto[]>;

    getTuteurLieuxFormation(idtuteur: number): Promise<HopeViewLieuFormationDto[]>;

    getContactSiegesSociaux(idcontact: number): Promise<HopeViewSiegeSocialDto[]>;

    getContactLieuxFormation(idcontact: number): Promise<HopeViewLieuFormationDto[]>;
}

export class HopeViewApi extends BaseAPI implements IHopeViewApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getPersonneMainData(idpersonne: number): Promise<HopeViewPersonneMainDataDto> {
        let url_ = this.baseUrl + "/api/HopeView/personne/{idpersonne}";
        if (idpersonne === undefined || idpersonne === null)
            throw new Error("The parameter 'idpersonne' must be defined.");
        url_ = url_.replace("{idpersonne}", encodeURIComponent("" + idpersonne));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPersonneMainData(_response));
        });
    }

    protected processGetPersonneMainData(response: Response): Promise<HopeViewPersonneMainDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HopeViewPersonneMainDataDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HopeViewPersonneMainDataDto>(null as any);
    }

    getPersonneSignaletique(idpersonne: number): Promise<HopeViewSignaletiquePersonneDto> {
        let url_ = this.baseUrl + "/api/HopeView/personne/{idpersonne}/signaletique";
        if (idpersonne === undefined || idpersonne === null)
            throw new Error("The parameter 'idpersonne' must be defined.");
        url_ = url_.replace("{idpersonne}", encodeURIComponent("" + idpersonne));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPersonneSignaletique(_response));
        });
    }

    protected processGetPersonneSignaletique(response: Response): Promise<HopeViewSignaletiquePersonneDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HopeViewSignaletiquePersonneDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HopeViewSignaletiquePersonneDto>(null as any);
    }

    getPersonneSuivi(idpersonne: number, ids: HopeViewPersonneMainDataDto): Promise<HopeViewSuiviActionDto[]> {
        let url_ = this.baseUrl + "/api/HopeView/personne/{idpersonne}/suivi";
        if (idpersonne === undefined || idpersonne === null)
            throw new Error("The parameter 'idpersonne' must be defined.");
        url_ = url_.replace("{idpersonne}", encodeURIComponent("" + idpersonne));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPersonneSuivi(_response));
        });
    }

    protected processGetPersonneSuivi(response: Response): Promise<HopeViewSuiviActionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HopeViewSuiviActionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HopeViewSuiviActionDto[]>(null as any);
    }

    getPersonneInscriptions(idapprenant: number): Promise<HopeViewInscriptionDto[]> {
        let url_ = this.baseUrl + "/api/HopeView/apprenant/{idapprenant}/inscriptions";
        if (idapprenant === undefined || idapprenant === null)
            throw new Error("The parameter 'idapprenant' must be defined.");
        url_ = url_.replace("{idapprenant}", encodeURIComponent("" + idapprenant));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPersonneInscriptions(_response));
        });
    }

    protected processGetPersonneInscriptions(response: Response): Promise<HopeViewInscriptionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HopeViewInscriptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HopeViewInscriptionDto[]>(null as any);
    }

    getApprenantHoraires(idapprenant: number, selectedDate: Date): Promise<HopeViewHoraireDto[]> {
        let url_ = this.baseUrl + "/api/HopeView/apprenant/{idapprenant}/horaires/{selectedDate}";
        if (idapprenant === undefined || idapprenant === null)
            throw new Error("The parameter 'idapprenant' must be defined.");
        url_ = url_.replace("{idapprenant}", encodeURIComponent("" + idapprenant));
        if (selectedDate === undefined || selectedDate === null)
            throw new Error("The parameter 'selectedDate' must be defined.");
        url_ = url_.replace("{selectedDate}", encodeURIComponent(selectedDate ? "" + selectedDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetApprenantHoraires(_response));
        });
    }

    protected processGetApprenantHoraires(response: Response): Promise<HopeViewHoraireDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HopeViewHoraireDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HopeViewHoraireDto[]>(null as any);
    }

    getPersonneContrats(idapprenant: number): Promise<HopeViewContratDto[]> {
        let url_ = this.baseUrl + "/api/HopeView/apprenant/{idapprenant}/contrats";
        if (idapprenant === undefined || idapprenant === null)
            throw new Error("The parameter 'idapprenant' must be defined.");
        url_ = url_.replace("{idapprenant}", encodeURIComponent("" + idapprenant));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPersonneContrats(_response));
        });
    }

    protected processGetPersonneContrats(response: Response): Promise<HopeViewContratDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HopeViewContratDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HopeViewContratDto[]>(null as any);
    }

    getPersonneReprentants(idapprenant: number): Promise<HopeViewRepresentantDto[]> {
        let url_ = this.baseUrl + "/api/HopeView/apprenant/{idapprenant}/representants";
        if (idapprenant === undefined || idapprenant === null)
            throw new Error("The parameter 'idapprenant' must be defined.");
        url_ = url_.replace("{idapprenant}", encodeURIComponent("" + idapprenant));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPersonneReprentants(_response));
        });
    }

    protected processGetPersonneReprentants(response: Response): Promise<HopeViewRepresentantDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HopeViewRepresentantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HopeViewRepresentantDto[]>(null as any);
    }

    getPersonneApprenants(idrepresentant: number): Promise<HopeViewApprenantDto[]> {
        let url_ = this.baseUrl + "/api/HopeView/representant/{idrepresentant}/apprenants";
        if (idrepresentant === undefined || idrepresentant === null)
            throw new Error("The parameter 'idrepresentant' must be defined.");
        url_ = url_.replace("{idrepresentant}", encodeURIComponent("" + idrepresentant));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPersonneApprenants(_response));
        });
    }

    protected processGetPersonneApprenants(response: Response): Promise<HopeViewApprenantDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HopeViewApprenantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HopeViewApprenantDto[]>(null as any);
    }

    getFormateurHoraires(idformateur: number, selectedDate: Date): Promise<HopeViewHoraireDto[]> {
        let url_ = this.baseUrl + "/api/HopeView/formateur/{idformateur}/horaires/{selectedDate}";
        if (idformateur === undefined || idformateur === null)
            throw new Error("The parameter 'idformateur' must be defined.");
        url_ = url_.replace("{idformateur}", encodeURIComponent("" + idformateur));
        if (selectedDate === undefined || selectedDate === null)
            throw new Error("The parameter 'selectedDate' must be defined.");
        url_ = url_.replace("{selectedDate}", encodeURIComponent(selectedDate ? "" + selectedDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFormateurHoraires(_response));
        });
    }

    protected processGetFormateurHoraires(response: Response): Promise<HopeViewHoraireDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HopeViewHoraireDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HopeViewHoraireDto[]>(null as any);
    }

    getFormateurClasses(idformateur: number): Promise<HopeViewClasseDto[]> {
        let url_ = this.baseUrl + "/api/HopeView/formateur/{idformateur}/classes";
        if (idformateur === undefined || idformateur === null)
            throw new Error("The parameter 'idformateur' must be defined.");
        url_ = url_.replace("{idformateur}", encodeURIComponent("" + idformateur));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFormateurClasses(_response));
        });
    }

    protected processGetFormateurClasses(response: Response): Promise<HopeViewClasseDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HopeViewClasseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HopeViewClasseDto[]>(null as any);
    }

    getChefEntrepriseSiegesSociaux(idchefEntreprise: number): Promise<HopeViewSiegeSocialDto[]> {
        let url_ = this.baseUrl + "/api/HopeView/chef-entreprise/{idchefEntreprise}/sieges-sociaux";
        if (idchefEntreprise === undefined || idchefEntreprise === null)
            throw new Error("The parameter 'idchefEntreprise' must be defined.");
        url_ = url_.replace("{idchefEntreprise}", encodeURIComponent("" + idchefEntreprise));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetChefEntrepriseSiegesSociaux(_response));
        });
    }

    protected processGetChefEntrepriseSiegesSociaux(response: Response): Promise<HopeViewSiegeSocialDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HopeViewSiegeSocialDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HopeViewSiegeSocialDto[]>(null as any);
    }

    getTuteurLieuxFormation(idtuteur: number): Promise<HopeViewLieuFormationDto[]> {
        let url_ = this.baseUrl + "/api/HopeView/tuteur/{idtuteur}/lieux-formation";
        if (idtuteur === undefined || idtuteur === null)
            throw new Error("The parameter 'idtuteur' must be defined.");
        url_ = url_.replace("{idtuteur}", encodeURIComponent("" + idtuteur));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTuteurLieuxFormation(_response));
        });
    }

    protected processGetTuteurLieuxFormation(response: Response): Promise<HopeViewLieuFormationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HopeViewLieuFormationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HopeViewLieuFormationDto[]>(null as any);
    }

    getContactSiegesSociaux(idcontact: number): Promise<HopeViewSiegeSocialDto[]> {
        let url_ = this.baseUrl + "/api/HopeView/contact/{idcontact}/sieges-sociaux";
        if (idcontact === undefined || idcontact === null)
            throw new Error("The parameter 'idcontact' must be defined.");
        url_ = url_.replace("{idcontact}", encodeURIComponent("" + idcontact));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetContactSiegesSociaux(_response));
        });
    }

    protected processGetContactSiegesSociaux(response: Response): Promise<HopeViewSiegeSocialDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HopeViewSiegeSocialDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HopeViewSiegeSocialDto[]>(null as any);
    }

    getContactLieuxFormation(idcontact: number): Promise<HopeViewLieuFormationDto[]> {
        let url_ = this.baseUrl + "/api/HopeView/contact/{idcontact}/lieux-formation";
        if (idcontact === undefined || idcontact === null)
            throw new Error("The parameter 'idcontact' must be defined.");
        url_ = url_.replace("{idcontact}", encodeURIComponent("" + idcontact));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetContactLieuxFormation(_response));
        });
    }

    protected processGetContactLieuxFormation(response: Response): Promise<HopeViewLieuFormationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HopeViewLieuFormationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HopeViewLieuFormationDto[]>(null as any);
    }
}

export interface IInboxApi {

    search(criterias: InboxSearchCriteria): Promise<InboxRowDto[]>;

    counts(criterias: InboxCountsCriteria): Promise<InboxStepCountDto[]>;

    searchByIdbeneficiary(row: InboxRowDto): Promise<InboxRowDto[]>;

    saveInboxArchive(dto: InboxRowDto): Promise<FileResponse>;
}

export class InboxApi extends BaseAPI implements IInboxApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    search(criterias: InboxSearchCriteria): Promise<InboxRowDto[]> {
        let url_ = this.baseUrl + "/api/Inbox/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criterias);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        });
    }

    protected processSearch(response: Response): Promise<InboxRowDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InboxRowDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InboxRowDto[]>(null as any);
    }

    counts(criterias: InboxCountsCriteria): Promise<InboxStepCountDto[]> {
        let url_ = this.baseUrl + "/api/Inbox/counts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criterias);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCounts(_response));
        });
    }

    protected processCounts(response: Response): Promise<InboxStepCountDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InboxStepCountDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InboxStepCountDto[]>(null as any);
    }

    searchByIdbeneficiary(row: InboxRowDto): Promise<InboxRowDto[]> {
        let url_ = this.baseUrl + "/api/Inbox/search-by-idbeneficiary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(row);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchByIdbeneficiary(_response));
        });
    }

    protected processSearchByIdbeneficiary(response: Response): Promise<InboxRowDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InboxRowDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InboxRowDto[]>(null as any);
    }

    saveInboxArchive(dto: InboxRowDto): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Inbox/save-inbox-archive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveInboxArchive(_response));
        });
    }

    protected processSaveInboxArchive(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IInstituteManagementApi {

    getInstituteManagement(id: number): Promise<EditInstituteManagementDto>;

    saveInstituteManagement(dto: EditInstituteManagementDto): Promise<EditInstituteManagementDto>;

    getDisplayName(id: number): Promise<string>;

    searchIds(searchQuery: SearchQueryOfInstituteManagementSearchCriteria): Promise<number[]>;

    baseSearch(searchQuery: SearchQueryOfInstituteManagementSearchCriteria): Promise<PaginatedResultsOfInstituteManagementGridDto>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]>;
}

export class InstituteManagementApi extends BaseAPI implements IInstituteManagementApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getInstituteManagement(id: number): Promise<EditInstituteManagementDto> {
        let url_ = this.baseUrl + "/api/InstituteManagement/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetInstituteManagement(_response));
        });
    }

    protected processGetInstituteManagement(response: Response): Promise<EditInstituteManagementDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditInstituteManagementDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditInstituteManagementDto>(null as any);
    }

    saveInstituteManagement(dto: EditInstituteManagementDto): Promise<EditInstituteManagementDto> {
        let url_ = this.baseUrl + "/api/InstituteManagement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveInstituteManagement(_response));
        });
    }

    protected processSaveInstituteManagement(response: Response): Promise<EditInstituteManagementDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditInstituteManagementDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditInstituteManagementDto>(null as any);
    }

    getDisplayName(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/InstituteManagement/{id}/display-name";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    searchIds(searchQuery: SearchQueryOfInstituteManagementSearchCriteria): Promise<number[]> {
        let url_ = this.baseUrl + "/api/InstituteManagement/search-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchIds(_response));
        });
    }

    protected processSearchIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfInstituteManagementSearchCriteria): Promise<PaginatedResultsOfInstituteManagementGridDto> {
        let url_ = this.baseUrl + "/api/InstituteManagement/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfInstituteManagementGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfInstituteManagementGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfInstituteManagementGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/InstituteManagement/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/InstituteManagement/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface INavFavouriteApi {

    saveNavFavourite(dto: NavFavouriteDto): Promise<NavFavouriteDto>;

    deleteNavFavourite(id: number): Promise<FileResponse>;
}

export class NavFavouriteApi extends BaseAPI implements INavFavouriteApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    saveNavFavourite(dto: NavFavouriteDto): Promise<NavFavouriteDto> {
        let url_ = this.baseUrl + "/api/NavFavourite/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveNavFavourite(_response));
        });
    }

    protected processSaveNavFavourite(response: Response): Promise<NavFavouriteDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NavFavouriteDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NavFavouriteDto>(null as any);
    }

    deleteNavFavourite(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/NavFavourite/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteNavFavourite(_response));
        });
    }

    protected processDeleteNavFavourite(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface INotificationPreferenceApi {

    getAll(): Promise<NotificationPreferenceDto[]>;

    save(dto: NotificationPreferenceDto): Promise<NotificationPreferenceDto>;
}

export class NotificationPreferenceApi extends BaseAPI implements INotificationPreferenceApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<NotificationPreferenceDto[]> {
        let url_ = this.baseUrl + "/api/NotificationPreference";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<NotificationPreferenceDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationPreferenceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationPreferenceDto[]>(null as any);
    }

    save(dto: NotificationPreferenceDto): Promise<NotificationPreferenceDto> {
        let url_ = this.baseUrl + "/api/NotificationPreference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<NotificationPreferenceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationPreferenceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationPreferenceDto>(null as any);
    }
}

export interface IOtherPartnerApi {

    getOtherPartner(id: number): Promise<EditOtherPartnerDto>;

    saveOtherPartner(dto: EditOtherPartnerDto): Promise<EditOtherPartnerDto>;

    getDisplayName(id: number): Promise<string>;

    searchIds(searchQuery: SearchQueryOfOtherPartnerSearchCriteria): Promise<number[]>;

    baseSearch(searchQuery: SearchQueryOfOtherPartnerSearchCriteria): Promise<PaginatedResultsOfOtherPartnerGridDto>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]>;
}

export class OtherPartnerApi extends BaseAPI implements IOtherPartnerApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getOtherPartner(id: number): Promise<EditOtherPartnerDto> {
        let url_ = this.baseUrl + "/api/OtherPartner/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetOtherPartner(_response));
        });
    }

    protected processGetOtherPartner(response: Response): Promise<EditOtherPartnerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditOtherPartnerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditOtherPartnerDto>(null as any);
    }

    saveOtherPartner(dto: EditOtherPartnerDto): Promise<EditOtherPartnerDto> {
        let url_ = this.baseUrl + "/api/OtherPartner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveOtherPartner(_response));
        });
    }

    protected processSaveOtherPartner(response: Response): Promise<EditOtherPartnerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditOtherPartnerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditOtherPartnerDto>(null as any);
    }

    getDisplayName(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/OtherPartner/{id}/display-name";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    searchIds(searchQuery: SearchQueryOfOtherPartnerSearchCriteria): Promise<number[]> {
        let url_ = this.baseUrl + "/api/OtherPartner/search-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchIds(_response));
        });
    }

    protected processSearchIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfOtherPartnerSearchCriteria): Promise<PaginatedResultsOfOtherPartnerGridDto> {
        let url_ = this.baseUrl + "/api/OtherPartner/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfOtherPartnerGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfOtherPartnerGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfOtherPartnerGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/OtherPartner/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/OtherPartner/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IReferentialApi {

    roles(): Promise<ReferentialItemDto[]>;

    actions(alreadyUsedActionIds: number[]): Promise<ReferentialItemDto[]>;

    authorizationCodes(): Promise<ReferentialItemDto[]>;

    variables(): Promise<ReferentialItemDto[]>;

    categoriesReponseType(): Promise<string[]>;

    metiers(): Promise<ReferentialItemDto[]>;

    metiersByStade(idstade: number | undefined): Promise<ReferentialItemDto[]>;

    stades(): Promise<ReferentialItemDto[]>;

    completedActions(): Promise<ReferentialItemDto[]>;

    codesPostaux(): Promise<ReferentialItemDto[]>;

    categoriesWorkRule(): Promise<string[]>;

    reponsesTypes(): Promise<ReferentialItemDto[]>;

    requestObjects(): Promise<ReferentialItemDto[]>;

    recipientGroups(): Promise<ReferentialItemDto[]>;

    genders(): Promise<ReferentialItemDto[]>;

    countries(): Promise<ReferentialItemDto[]>;

    cities(countryCode: string | null | undefined): Promise<ReferentialItemDto[]>;

    nationalities(genderCode: string | null | undefined): Promise<ReferentialItemDto[]>;

    phoneTypes(): Promise<ReferentialItemDto[]>;

    emailTypes(): Promise<ReferentialItemDto[]>;

    addressTypes(): Promise<ReferentialItemDto[]>;

    postalCodes(): Promise<FcbCodePostalDto[]>;

    formes(): Promise<ReferentialItemDto[]>;

    siegesSociauxSuggest(): Promise<ReferentialItemDto[]>;

    typesSuiviAction(): Promise<ReferentialItemDto[]>;

    typesSuivi(): Promise<ReferentialItemDto[]>;

    sousTypesSuivi(idtypeSuivi: number | null | undefined): Promise<ReferentialItemDto[]>;

    suiviPriorites(): Promise<ReferentialItemDto[]>;

    otherPartners(): Promise<ReferentialItemDto[]>;

    instituteManagements(): Promise<ReferentialItemDto[]>;

    allActivePostalCodes(): Promise<ReferentialItemDto[]>;

    codesPostauxCentres(): Promise<ReferentialItemDto[]>;

    codesPostauxServices(): Promise<ReferentialItemDto[]>;

    modes(): Promise<ReferentialItemDto[]>;

    services(): Promise<ReferentialItemDto[]>;
}

export class ReferentialApi extends BaseAPI implements IReferentialApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    roles(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRoles(_response));
        });
    }

    protected processRoles(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    actions(alreadyUsedActionIds: number[]): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/actions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alreadyUsedActionIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processActions(_response));
        });
    }

    protected processActions(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    authorizationCodes(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/authorizationCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAuthorizationCodes(_response));
        });
    }

    protected processAuthorizationCodes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    variables(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/variables";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVariables(_response));
        });
    }

    protected processVariables(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    categoriesReponseType(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Referential/categories-reponse-type";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCategoriesReponseType(_response));
        });
    }

    protected processCategoriesReponseType(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    metiers(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/metiers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMetiers(_response));
        });
    }

    protected processMetiers(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    metiersByStade(idstade: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/metiers-by-stade?";
        if (idstade === null)
            throw new Error("The parameter 'idstade' cannot be null.");
        else if (idstade !== undefined)
            url_ += "idstade=" + encodeURIComponent("" + idstade) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMetiersByStade(_response));
        });
    }

    protected processMetiersByStade(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    stades(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/stades";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStades(_response));
        });
    }

    protected processStades(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    completedActions(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/completed-actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCompletedActions(_response));
        });
    }

    protected processCompletedActions(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    codesPostaux(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/codes-postaux";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCodesPostaux(_response));
        });
    }

    protected processCodesPostaux(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    categoriesWorkRule(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Referential/categories-work-rule";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCategoriesWorkRule(_response));
        });
    }

    protected processCategoriesWorkRule(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    reponsesTypes(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/reponses-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReponsesTypes(_response));
        });
    }

    protected processReponsesTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    requestObjects(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/request-objects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequestObjects(_response));
        });
    }

    protected processRequestObjects(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    recipientGroups(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/recipient-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRecipientGroups(_response));
        });
    }

    protected processRecipientGroups(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    genders(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/genders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenders(_response));
        });
    }

    protected processGenders(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    countries(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCountries(_response));
        });
    }

    protected processCountries(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    cities(countryCode: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/cities?";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCities(_response));
        });
    }

    protected processCities(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    nationalities(genderCode: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/nationalities?";
        if (genderCode !== undefined && genderCode !== null)
            url_ += "genderCode=" + encodeURIComponent("" + genderCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNationalities(_response));
        });
    }

    protected processNationalities(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    phoneTypes(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/phone-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPhoneTypes(_response));
        });
    }

    protected processPhoneTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    emailTypes(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/email-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEmailTypes(_response));
        });
    }

    protected processEmailTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    addressTypes(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/address-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddressTypes(_response));
        });
    }

    protected processAddressTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    postalCodes(): Promise<FcbCodePostalDto[]> {
        let url_ = this.baseUrl + "/api/Referential/postal-codes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPostalCodes(_response));
        });
    }

    protected processPostalCodes(response: Response): Promise<FcbCodePostalDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FcbCodePostalDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FcbCodePostalDto[]>(null as any);
    }

    formes(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/formes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFormes(_response));
        });
    }

    protected processFormes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    siegesSociauxSuggest(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/sieges-sociaux-suggest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSiegesSociauxSuggest(_response));
        });
    }

    protected processSiegesSociauxSuggest(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    typesSuiviAction(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/types-suivi-action";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTypesSuiviAction(_response));
        });
    }

    protected processTypesSuiviAction(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    typesSuivi(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/types-suivi";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTypesSuivi(_response));
        });
    }

    protected processTypesSuivi(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    sousTypesSuivi(idtypeSuivi: number | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/sous-types-suivi?";
        if (idtypeSuivi !== undefined && idtypeSuivi !== null)
            url_ += "idtypeSuivi=" + encodeURIComponent("" + idtypeSuivi) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSousTypesSuivi(_response));
        });
    }

    protected processSousTypesSuivi(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    suiviPriorites(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/suivi-priorites";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSuiviPriorites(_response));
        });
    }

    protected processSuiviPriorites(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    otherPartners(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/other-partners";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOtherPartners(_response));
        });
    }

    protected processOtherPartners(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    instituteManagements(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/institute-management";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInstituteManagements(_response));
        });
    }

    protected processInstituteManagements(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    allActivePostalCodes(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/all-active-postal-codes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAllActivePostalCodes(_response));
        });
    }

    protected processAllActivePostalCodes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    codesPostauxCentres(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/codes-postaux-centres";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCodesPostauxCentres(_response));
        });
    }

    protected processCodesPostauxCentres(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    codesPostauxServices(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/codes-postaux-services";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCodesPostauxServices(_response));
        });
    }

    protected processCodesPostauxServices(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    modes(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/modes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processModes(_response));
        });
    }

    protected processModes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    services(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/services";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processServices(_response));
        });
    }

    protected processServices(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IReponseTypeApi {

    getReponseType(id: number): Promise<EditReponseTypeDto>;

    deleteReponseType(id: number): Promise<FileResponse>;

    saveReponseType(dto: EditReponseTypeDto): Promise<EditReponseTypeDto>;

    deleteReponseTypes(ids: number[]): Promise<FileResponse>;

    saveMultipleReponseType(dto: EditMultipleReponseTypeDto): Promise<EditMultipleReponseTypeDto>;

    getDisplayName(id: number): Promise<string>;

    duplicateReponseType(id: number): Promise<EditReponseTypeDto>;

    searchIds(searchQuery: SearchQueryOfReponseTypeSearchCriteria): Promise<number[]>;

    baseSearch(searchQuery: SearchQueryOfReponseTypeSearchCriteria): Promise<PaginatedResultsOfReponseTypeGridDto>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]>;
}

export class ReponseTypeApi extends BaseAPI implements IReponseTypeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getReponseType(id: number): Promise<EditReponseTypeDto> {
        let url_ = this.baseUrl + "/api/ReponseType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReponseType(_response));
        });
    }

    protected processGetReponseType(response: Response): Promise<EditReponseTypeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditReponseTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditReponseTypeDto>(null as any);
    }

    deleteReponseType(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReponseType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteReponseType(_response));
        });
    }

    protected processDeleteReponseType(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveReponseType(dto: EditReponseTypeDto): Promise<EditReponseTypeDto> {
        let url_ = this.baseUrl + "/api/ReponseType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveReponseType(_response));
        });
    }

    protected processSaveReponseType(response: Response): Promise<EditReponseTypeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditReponseTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditReponseTypeDto>(null as any);
    }

    deleteReponseTypes(ids: number[]): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReponseType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteReponseTypes(_response));
        });
    }

    protected processDeleteReponseTypes(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveMultipleReponseType(dto: EditMultipleReponseTypeDto): Promise<EditMultipleReponseTypeDto> {
        let url_ = this.baseUrl + "/api/ReponseType/save-multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveMultipleReponseType(_response));
        });
    }

    protected processSaveMultipleReponseType(response: Response): Promise<EditMultipleReponseTypeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditMultipleReponseTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditMultipleReponseTypeDto>(null as any);
    }

    getDisplayName(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/ReponseType/{id}/display-name";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    duplicateReponseType(id: number): Promise<EditReponseTypeDto> {
        let url_ = this.baseUrl + "/api/ReponseType/{id}/duplicate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDuplicateReponseType(_response));
        });
    }

    protected processDuplicateReponseType(response: Response): Promise<EditReponseTypeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditReponseTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditReponseTypeDto>(null as any);
    }

    searchIds(searchQuery: SearchQueryOfReponseTypeSearchCriteria): Promise<number[]> {
        let url_ = this.baseUrl + "/api/ReponseType/search-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchIds(_response));
        });
    }

    protected processSearchIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfReponseTypeSearchCriteria): Promise<PaginatedResultsOfReponseTypeGridDto> {
        let url_ = this.baseUrl + "/api/ReponseType/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfReponseTypeGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfReponseTypeGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfReponseTypeGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/ReponseType/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/ReponseType/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IRequestObjectApi {

    getRequestObject(id: number): Promise<EditRequestObjectDto>;

    deleteRequestObject(id: number): Promise<FileResponse>;

    saveRequestObject(dto: EditRequestObjectDto): Promise<EditRequestObjectDto>;

    getDisplayName(id: number): Promise<string>;

    searchIds(searchQuery: SearchQueryOfRequestObjectSearchCriteria): Promise<number[]>;

    baseSearch(searchQuery: SearchQueryOfRequestObjectSearchCriteria): Promise<PaginatedResultsOfRequestObjectGridDto>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]>;
}

export class RequestObjectApi extends BaseAPI implements IRequestObjectApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getRequestObject(id: number): Promise<EditRequestObjectDto> {
        let url_ = this.baseUrl + "/api/RequestObject/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRequestObject(_response));
        });
    }

    protected processGetRequestObject(response: Response): Promise<EditRequestObjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditRequestObjectDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditRequestObjectDto>(null as any);
    }

    deleteRequestObject(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/RequestObject/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteRequestObject(_response));
        });
    }

    protected processDeleteRequestObject(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveRequestObject(dto: EditRequestObjectDto): Promise<EditRequestObjectDto> {
        let url_ = this.baseUrl + "/api/RequestObject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveRequestObject(_response));
        });
    }

    protected processSaveRequestObject(response: Response): Promise<EditRequestObjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditRequestObjectDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditRequestObjectDto>(null as any);
    }

    getDisplayName(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/RequestObject/{id}/display-name";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    searchIds(searchQuery: SearchQueryOfRequestObjectSearchCriteria): Promise<number[]> {
        let url_ = this.baseUrl + "/api/RequestObject/search-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchIds(_response));
        });
    }

    protected processSearchIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfRequestObjectSearchCriteria): Promise<PaginatedResultsOfRequestObjectGridDto> {
        let url_ = this.baseUrl + "/api/RequestObject/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfRequestObjectGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfRequestObjectGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfRequestObjectGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/RequestObject/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/RequestObject/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ISuiviApi {

    get(id: number): Promise<EditSuiviDto>;

    getDisplayName(id: number): Promise<string>;

    saveSuivi(dto: EditSuiviDto): Promise<EditSuiviDto>;

    customObserverItem(dto: EditSuiviDto): Promise<string>;

    searchIds(searchQuery: SearchQueryOfSuiviSearchCriteria): Promise<number[]>;

    baseSearch(searchQuery: SearchQueryOfSuiviSearchCriteria): Promise<PaginatedResultsOfSuiviGridDto>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]>;
}

export class SuiviApi extends BaseAPI implements ISuiviApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(id: number): Promise<EditSuiviDto> {
        let url_ = this.baseUrl + "/api/Suivi/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<EditSuiviDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditSuiviDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditSuiviDto>(null as any);
    }

    getDisplayName(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/Suivi/display-name/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    saveSuivi(dto: EditSuiviDto): Promise<EditSuiviDto> {
        let url_ = this.baseUrl + "/api/Suivi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveSuivi(_response));
        });
    }

    protected processSaveSuivi(response: Response): Promise<EditSuiviDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditSuiviDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditSuiviDto>(null as any);
    }

    customObserverItem(dto: EditSuiviDto): Promise<string> {
        let url_ = this.baseUrl + "/api/Suivi/custom-observer-item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCustomObserverItem(_response));
        });
    }

    protected processCustomObserverItem(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    searchIds(searchQuery: SearchQueryOfSuiviSearchCriteria): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Suivi/search-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchIds(_response));
        });
    }

    protected processSearchIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfSuiviSearchCriteria): Promise<PaginatedResultsOfSuiviGridDto> {
        let url_ = this.baseUrl + "/api/Suivi/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfSuiviGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfSuiviGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfSuiviGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Suivi/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Suivi/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ISuiviStatisticsApi {

    export(searchQuery: SearchQueryOfSuiviStatisticsSearchCriteria): Promise<FileResponse>;

    searchIds(searchQuery: SearchQueryOfSuiviStatisticsSearchCriteria): Promise<number[]>;

    baseSearch(searchQuery: SearchQueryOfSuiviStatisticsSearchCriteria): Promise<PaginatedResultsOfSuiviStatisticsGridDto>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]>;
}

export class SuiviStatisticsApi extends BaseAPI implements ISuiviStatisticsApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    export(searchQuery: SearchQueryOfSuiviStatisticsSearchCriteria): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/SuiviStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    searchIds(searchQuery: SearchQueryOfSuiviStatisticsSearchCriteria): Promise<number[]> {
        let url_ = this.baseUrl + "/api/SuiviStatistics/search-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchIds(_response));
        });
    }

    protected processSearchIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfSuiviStatisticsSearchCriteria): Promise<PaginatedResultsOfSuiviStatisticsGridDto> {
        let url_ = this.baseUrl + "/api/SuiviStatistics/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfSuiviStatisticsGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfSuiviStatisticsGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfSuiviStatisticsGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/SuiviStatistics/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/SuiviStatistics/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ISystemApi {

    get(): Promise<SystemInfoDto>;

    getExposedTypes(): Promise<ExposedTypes>;

    geFrontendSettings(): Promise<FrontendSettings>;
}

export class SystemApi extends BaseAPI implements ISystemApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(): Promise<SystemInfoDto> {
        let url_ = this.baseUrl + "/api/System";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<SystemInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemInfoDto>(null as any);
    }

    getExposedTypes(): Promise<ExposedTypes> {
        let url_ = this.baseUrl + "/api/System/exposed-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetExposedTypes(_response));
        });
    }

    protected processGetExposedTypes(response: Response): Promise<ExposedTypes> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExposedTypes.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExposedTypes>(null as any);
    }

    geFrontendSettings(): Promise<FrontendSettings> {
        let url_ = this.baseUrl + "/api/System/fe-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGeFrontendSettings(_response));
        });
    }

    protected processGeFrontendSettings(response: Response): Promise<FrontendSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FrontendSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FrontendSettings>(null as any);
    }
}

export interface IUserApi {

    getUser(id: number): Promise<EditUserDto>;

    deleteUser(id: number): Promise<FileResponse>;

    getSecteurs(id: number): Promise<UserSecteurDto[]>;

    getMetiers(id: number): Promise<UserMetierDto[]>;

    saveUserMetier(id: number, dto: UserMetierDto): Promise<UserMetierDto>;

    getMetierLocalites(id: number, idmetier: number): Promise<MetierLocaliteDto[]>;

    saveUserMetierLocalite(id: number, idmetier: number, dto: MetierLocaliteDto): Promise<MetierLocaliteDto>;

    getApprenants(id: number): Promise<UserApprenantDto[]>;

    getSiegeSociaux(id: number): Promise<UserSiegeSocialDto[]>;

    saveUser(dto: EditUserDto): Promise<EditUserDto>;

    getDisplayName(id: number): Promise<string>;

    profile(): Promise<UserProfileDto>;

    getDisplayNames(ids: number[]): Promise<DisplayNameDto[]>;

    azureProfile(): Promise<AzureUserDto>;

    azureProfileById(userId: number): Promise<AzureUserDto>;

    azureTeam(): Promise<AzureUserDto[]>;

    azureProfilePicture(oid: string): Promise<string>;

    defaultAvailability(): Promise<AvailabilityDto[]>;

    availability(iduser: number, day: Date): Promise<UserAvailabilityDto[]>;

    saveAvailability(dto: UserAvailabilityDto): Promise<FileResponse>;

    searchIds(searchQuery: SearchQueryOfUserSearchCriteria): Promise<number[]>;

    baseSearch(searchQuery: SearchQueryOfUserSearchCriteria): Promise<PaginatedResultsOfUserGridDto>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]>;
}

export class UserApi extends BaseAPI implements IUserApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getUser(id: number): Promise<EditUserDto> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUser(_response));
        });
    }

    protected processGetUser(response: Response): Promise<EditUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditUserDto>(null as any);
    }

    deleteUser(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteUser(_response));
        });
    }

    protected processDeleteUser(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSecteurs(id: number): Promise<UserSecteurDto[]> {
        let url_ = this.baseUrl + "/api/User/{id}/secteurs";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSecteurs(_response));
        });
    }

    protected processGetSecteurs(response: Response): Promise<UserSecteurDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserSecteurDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSecteurDto[]>(null as any);
    }

    getMetiers(id: number): Promise<UserMetierDto[]> {
        let url_ = this.baseUrl + "/api/User/{id}/metiers";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMetiers(_response));
        });
    }

    protected processGetMetiers(response: Response): Promise<UserMetierDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserMetierDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserMetierDto[]>(null as any);
    }

    saveUserMetier(id: number, dto: UserMetierDto): Promise<UserMetierDto> {
        let url_ = this.baseUrl + "/api/User/{id}/metier";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveUserMetier(_response));
        });
    }

    protected processSaveUserMetier(response: Response): Promise<UserMetierDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserMetierDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserMetierDto>(null as any);
    }

    getMetierLocalites(id: number, idmetier: number): Promise<MetierLocaliteDto[]> {
        let url_ = this.baseUrl + "/api/User/{id}/metiers/{idmetier}/localites";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (idmetier === undefined || idmetier === null)
            throw new Error("The parameter 'idmetier' must be defined.");
        url_ = url_.replace("{idmetier}", encodeURIComponent("" + idmetier));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMetierLocalites(_response));
        });
    }

    protected processGetMetierLocalites(response: Response): Promise<MetierLocaliteDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MetierLocaliteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MetierLocaliteDto[]>(null as any);
    }

    saveUserMetierLocalite(id: number, idmetier: number, dto: MetierLocaliteDto): Promise<MetierLocaliteDto> {
        let url_ = this.baseUrl + "/api/User/{id}/metiers/{idmetier}/localite";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (idmetier === undefined || idmetier === null)
            throw new Error("The parameter 'idmetier' must be defined.");
        url_ = url_.replace("{idmetier}", encodeURIComponent("" + idmetier));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveUserMetierLocalite(_response));
        });
    }

    protected processSaveUserMetierLocalite(response: Response): Promise<MetierLocaliteDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetierLocaliteDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MetierLocaliteDto>(null as any);
    }

    getApprenants(id: number): Promise<UserApprenantDto[]> {
        let url_ = this.baseUrl + "/api/User/{id}/apprenants";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetApprenants(_response));
        });
    }

    protected processGetApprenants(response: Response): Promise<UserApprenantDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserApprenantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserApprenantDto[]>(null as any);
    }

    getSiegeSociaux(id: number): Promise<UserSiegeSocialDto[]> {
        let url_ = this.baseUrl + "/api/User/{id}/sieges-sociaux";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSiegeSociaux(_response));
        });
    }

    protected processGetSiegeSociaux(response: Response): Promise<UserSiegeSocialDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserSiegeSocialDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSiegeSocialDto[]>(null as any);
    }

    saveUser(dto: EditUserDto): Promise<EditUserDto> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveUser(_response));
        });
    }

    protected processSaveUser(response: Response): Promise<EditUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditUserDto>(null as any);
    }

    getDisplayName(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/User/display-name/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    profile(): Promise<UserProfileDto> {
        let url_ = this.baseUrl + "/api/User/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProfile(_response));
        });
    }

    protected processProfile(response: Response): Promise<UserProfileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfileDto>(null as any);
    }

    getDisplayNames(ids: number[]): Promise<DisplayNameDto[]> {
        let url_ = this.baseUrl + "/api/User/display-names";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayNames(_response));
        });
    }

    protected processGetDisplayNames(response: Response): Promise<DisplayNameDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DisplayNameDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto[]>(null as any);
    }

    azureProfile(): Promise<AzureUserDto> {
        let url_ = this.baseUrl + "/api/User/azure-profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAzureProfile(_response));
        });
    }

    protected processAzureProfile(response: Response): Promise<AzureUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AzureUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AzureUserDto>(null as any);
    }

    azureProfileById(userId: number): Promise<AzureUserDto> {
        let url_ = this.baseUrl + "/api/User/{userId}/azure-profile";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAzureProfileById(_response));
        });
    }

    protected processAzureProfileById(response: Response): Promise<AzureUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AzureUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AzureUserDto>(null as any);
    }

    azureTeam(): Promise<AzureUserDto[]> {
        let url_ = this.baseUrl + "/api/User/azure-team";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAzureTeam(_response));
        });
    }

    protected processAzureTeam(response: Response): Promise<AzureUserDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AzureUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AzureUserDto[]>(null as any);
    }

    azureProfilePicture(oid: string): Promise<string> {
        let url_ = this.baseUrl + "/api/User/azure-profile-picture/{oid}";
        if (oid === undefined || oid === null)
            throw new Error("The parameter 'oid' must be defined.");
        url_ = url_.replace("{oid}", encodeURIComponent("" + oid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAzureProfilePicture(_response));
        });
    }

    protected processAzureProfilePicture(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    defaultAvailability(): Promise<AvailabilityDto[]> {
        let url_ = this.baseUrl + "/api/User/default-availability";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDefaultAvailability(_response));
        });
    }

    protected processDefaultAvailability(response: Response): Promise<AvailabilityDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailabilityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailabilityDto[]>(null as any);
    }

    availability(iduser: number, day: Date): Promise<UserAvailabilityDto[]> {
        let url_ = this.baseUrl + "/api/User/{iduser}/availability/{day}";
        if (iduser === undefined || iduser === null)
            throw new Error("The parameter 'iduser' must be defined.");
        url_ = url_.replace("{iduser}", encodeURIComponent("" + iduser));
        if (day === undefined || day === null)
            throw new Error("The parameter 'day' must be defined.");
        url_ = url_.replace("{day}", encodeURIComponent(day ? "" + day.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailability(_response));
        });
    }

    protected processAvailability(response: Response): Promise<UserAvailabilityDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAvailabilityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAvailabilityDto[]>(null as any);
    }

    saveAvailability(dto: UserAvailabilityDto): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/save-availability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveAvailability(_response));
        });
    }

    protected processSaveAvailability(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    searchIds(searchQuery: SearchQueryOfUserSearchCriteria): Promise<number[]> {
        let url_ = this.baseUrl + "/api/User/search-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchIds(_response));
        });
    }

    protected processSearchIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfUserSearchCriteria): Promise<PaginatedResultsOfUserGridDto> {
        let url_ = this.baseUrl + "/api/User/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfUserGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfUserGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfUserGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/User/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/User/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IWorkRuleApi {

    getDisplayName(id: number): Promise<string>;

    getWorkRule(id: number): Promise<EditWorkRuleDto>;

    deleteWorkRule(id: number): Promise<FileResponse>;

    saveWorkRule(dto: EditWorkRuleDto): Promise<EditWorkRuleDto>;

    deleteWorkRules(ids: number[]): Promise<FileResponse>;

    findWorkRuleForSuivi(dto: EditSuiviDto): Promise<SuiviWorkRuleDto>;

    saveMultipleWorkRule(dto: EditMultipleWorkRuleDto): Promise<EditMultipleWorkRuleDto>;

    duplicateWorkRule(id: number): Promise<EditWorkRuleDto>;

    customObserverItem(dto: EditWorkRuleDto): Promise<string>;

    searchIds(searchQuery: SearchQueryOfWorkRuleSearchCriteria): Promise<number[]>;

    baseSearch(searchQuery: SearchQueryOfWorkRuleSearchCriteria): Promise<PaginatedResultsOfWorkRuleGridDto>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]>;
}

export class WorkRuleApi extends BaseAPI implements IWorkRuleApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getDisplayName(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/WorkRule/{id}/display-name";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getWorkRule(id: number): Promise<EditWorkRuleDto> {
        let url_ = this.baseUrl + "/api/WorkRule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWorkRule(_response));
        });
    }

    protected processGetWorkRule(response: Response): Promise<EditWorkRuleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditWorkRuleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditWorkRuleDto>(null as any);
    }

    deleteWorkRule(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/WorkRule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteWorkRule(_response));
        });
    }

    protected processDeleteWorkRule(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveWorkRule(dto: EditWorkRuleDto): Promise<EditWorkRuleDto> {
        let url_ = this.baseUrl + "/api/WorkRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveWorkRule(_response));
        });
    }

    protected processSaveWorkRule(response: Response): Promise<EditWorkRuleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditWorkRuleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditWorkRuleDto>(null as any);
    }

    deleteWorkRules(ids: number[]): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/WorkRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteWorkRules(_response));
        });
    }

    protected processDeleteWorkRules(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    findWorkRuleForSuivi(dto: EditSuiviDto): Promise<SuiviWorkRuleDto> {
        let url_ = this.baseUrl + "/api/WorkRule/find-for-suivi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFindWorkRuleForSuivi(_response));
        });
    }

    protected processFindWorkRuleForSuivi(response: Response): Promise<SuiviWorkRuleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SuiviWorkRuleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SuiviWorkRuleDto>(null as any);
    }

    saveMultipleWorkRule(dto: EditMultipleWorkRuleDto): Promise<EditMultipleWorkRuleDto> {
        let url_ = this.baseUrl + "/api/WorkRule/save-multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveMultipleWorkRule(_response));
        });
    }

    protected processSaveMultipleWorkRule(response: Response): Promise<EditMultipleWorkRuleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditMultipleWorkRuleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditMultipleWorkRuleDto>(null as any);
    }

    duplicateWorkRule(id: number): Promise<EditWorkRuleDto> {
        let url_ = this.baseUrl + "/api/WorkRule/{id}/duplicate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDuplicateWorkRule(_response));
        });
    }

    protected processDuplicateWorkRule(response: Response): Promise<EditWorkRuleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditWorkRuleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditWorkRuleDto>(null as any);
    }

    customObserverItem(dto: EditWorkRuleDto): Promise<string> {
        let url_ = this.baseUrl + "/api/WorkRule/custom-observer-item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCustomObserverItem(_response));
        });
    }

    protected processCustomObserverItem(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    searchIds(searchQuery: SearchQueryOfWorkRuleSearchCriteria): Promise<number[]> {
        let url_ = this.baseUrl + "/api/WorkRule/search-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchIds(_response));
        });
    }

    protected processSearchIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfWorkRuleSearchCriteria): Promise<PaginatedResultsOfWorkRuleGridDto> {
        let url_ = this.baseUrl + "/api/WorkRule/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfWorkRuleGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfWorkRuleGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfWorkRuleGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/WorkRule/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/WorkRule/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IHealthCheckApi {

    getHealthCheck(): Promise<HealthCheckViewModel>;

    getStartupHealthCheck(): Promise<HealthCheckViewModel>;

    getReadyHealthCheck(): Promise<HealthCheckViewModel>;

    getLiveHealthCheck(): Promise<HealthCheckViewModel>;
}

export class HealthCheckApi extends BaseAPI implements IHealthCheckApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getHealthCheck(): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHealthCheck(_response));
        });
    }

    protected processGetHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }

    getStartupHealthCheck(): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc/startup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStartupHealthCheck(_response));
        });
    }

    protected processGetStartupHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }

    getReadyHealthCheck(): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc/ready";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReadyHealthCheck(_response));
        });
    }

    protected processGetReadyHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }

    getLiveHealthCheck(): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc/live";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLiveHealthCheck(_response));
        });
    }

    protected processGetLiveHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }
}

export interface IApiKeyApi {

    getApiKey(clientName: string | null | undefined): Promise<ClientApiKey>;
}

export class ApiKeyApi extends BaseAPI implements IApiKeyApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getApiKey(clientName: string | null | undefined): Promise<ClientApiKey> {
        let url_ = this.baseUrl + "/apikey?";
        if (clientName !== undefined && clientName !== null)
            url_ += "clientName=" + encodeURIComponent("" + clientName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetApiKey(_response));
        });
    }

    protected processGetApiKey(response: Response): Promise<ClientApiKey> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientApiKey.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientApiKey>(null as any);
    }
}

export class SearchQueryOfActionSearchCriteria implements ISearchQueryOfActionSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: ActionSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfActionSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? ActionSearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfActionSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfActionSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfActionSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfActionSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfActionSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: ActionSearchCriteria | undefined;
}

export abstract class AbstractSearchExpression implements IAbstractSearchExpression {
    expressionOperator?: string | undefined;

    protected _discriminator: string;

    constructor(data?: IAbstractSearchExpression) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "AbstractSearchExpression";
    }

    init(_data?: any) {
        if (_data) {
            this.expressionOperator = _data["expressionOperator"];
        }
    }

    static fromJS(data: any): AbstractSearchExpression {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "condition") {
            let result = new ConditionSearchExpression();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "group") {
            let result = new GroupSearchExpression();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'AbstractSearchExpression' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["expressionOperator"] = this.expressionOperator;
        return data;
    }

    clone(): AbstractSearchExpression {
        throw new Error("The abstract class 'AbstractSearchExpression' cannot be instantiated.");
    }
}

export interface IAbstractSearchExpression {
    expressionOperator?: string | undefined;
}

export class ConditionSearchExpression extends AbstractSearchExpression implements IConditionSearchExpression {
    field?: string | undefined;
    value?: string | undefined;

    constructor(data?: IConditionSearchExpression) {
        super(data);
        this._discriminator = "condition";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.field = _data["field"];
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ConditionSearchExpression {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionSearchExpression();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): ConditionSearchExpression {
        const json = this.toJSON();
        let result = new ConditionSearchExpression();
        result.init(json);
        return result;
    }
}

export interface IConditionSearchExpression extends IAbstractSearchExpression {
    field?: string | undefined;
    value?: string | undefined;
}

export class GroupSearchExpression extends AbstractSearchExpression implements IGroupSearchExpression {
    expressions?: AbstractSearchExpression[] | undefined;

    constructor(data?: IGroupSearchExpression) {
        super(data);
        this._discriminator = "group";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["expressions"])) {
                this.expressions = [] as any;
                for (let item of _data["expressions"])
                    this.expressions!.push(AbstractSearchExpression.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GroupSearchExpression {
        data = typeof data === 'object' ? data : {};
        let result = new GroupSearchExpression();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expressions)) {
            data["expressions"] = [];
            for (let item of this.expressions)
                data["expressions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): GroupSearchExpression {
        const json = this.toJSON();
        let result = new GroupSearchExpression();
        result.init(json);
        return result;
    }
}

export interface IGroupSearchExpression extends IAbstractSearchExpression {
    expressions?: AbstractSearchExpression[] | undefined;
}

export class Searchable implements ISearchable {
    filter?: string | undefined;

    constructor(data?: ISearchable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): Searchable {
        data = typeof data === 'object' ? data : {};
        let result = new Searchable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data;
    }

    clone(): Searchable {
        const json = this.toJSON();
        let result = new Searchable();
        result.init(json);
        return result;
    }
}

export interface ISearchable {
    filter?: string | undefined;
}

export class PaginatedSearchable extends Searchable implements IPaginatedSearchable {
    sortKey?: string[] | undefined;
    aggregateKeys?: AggregateKeyInfo[] | undefined;
    skip?: number | undefined;
    take?: number | undefined;

    constructor(data?: IPaginatedSearchable) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sortKey"])) {
                this.sortKey = [] as any;
                for (let item of _data["sortKey"])
                    this.sortKey!.push(item);
            }
            if (Array.isArray(_data["aggregateKeys"])) {
                this.aggregateKeys = [] as any;
                for (let item of _data["aggregateKeys"])
                    this.aggregateKeys!.push(AggregateKeyInfo.fromJS(item));
            }
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static override fromJS(data: any): PaginatedSearchable {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedSearchable();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sortKey)) {
            data["sortKey"] = [];
            for (let item of this.sortKey)
                data["sortKey"].push(item);
        }
        if (Array.isArray(this.aggregateKeys)) {
            data["aggregateKeys"] = [];
            for (let item of this.aggregateKeys)
                data["aggregateKeys"].push(item.toJSON());
        }
        data["skip"] = this.skip;
        data["take"] = this.take;
        super.toJSON(data);
        return data;
    }

    clone(): PaginatedSearchable {
        const json = this.toJSON();
        let result = new PaginatedSearchable();
        result.init(json);
        return result;
    }
}

export interface IPaginatedSearchable extends ISearchable {
    sortKey?: string[] | undefined;
    aggregateKeys?: AggregateKeyInfo[] | undefined;
    skip?: number | undefined;
    take?: number | undefined;
}

export class ActionSearchCriteria extends PaginatedSearchable implements IActionSearchCriteria {
    recent?: boolean;
    destinataire?: number;

    constructor(data?: IActionSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.recent = _data["recent"];
            this.destinataire = _data["destinataire"];
        }
    }

    static override fromJS(data: any): ActionSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new ActionSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recent"] = this.recent;
        data["destinataire"] = this.destinataire;
        super.toJSON(data);
        return data;
    }

    clone(): ActionSearchCriteria {
        const json = this.toJSON();
        let result = new ActionSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface IActionSearchCriteria extends IPaginatedSearchable {
    recent?: boolean;
    destinataire?: number;
}

export class AggregateKeyInfo implements IAggregateKeyInfo {
    key?: string | undefined;
    aggregateType?: EAggregateType;
    text?: string | undefined;

    constructor(data?: IAggregateKeyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.aggregateType = _data["aggregateType"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): AggregateKeyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AggregateKeyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["aggregateType"] = this.aggregateType;
        data["text"] = this.text;
        return data;
    }

    clone(): AggregateKeyInfo {
        const json = this.toJSON();
        let result = new AggregateKeyInfo();
        result.init(json);
        return result;
    }
}

export interface IAggregateKeyInfo {
    key?: string | undefined;
    aggregateType?: EAggregateType;
    text?: string | undefined;
}

export enum EAggregateType {
    Sum = "Sum",
    Avg = "Avg",
    Min = "Min",
    Max = "Max",
}

export class PaginatedResultsOfActionGridDto implements IPaginatedResultsOfActionGridDto {
    totalCount?: number;
    results?: ActionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ActionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfActionGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfActionGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfActionGridDto {
    totalCount?: number;
    results?: ActionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class ActionGridDto implements IActionGridDto {
    idsuivi?: number;
    demande?: string | undefined;
    expediteur?: string | undefined;
    collaborateur?: string | undefined;
    titre?: string | undefined;
    action?: string | undefined;
    creationDate?: Date;
    dateEcheance?: Date | undefined;
    prio?: string | undefined;
    apprenant?: string | undefined;
    formateur?: string | undefined;
    representant?: string | undefined;
    chefEntreprise?: string | undefined;
    tuteur?: string | undefined;
    contact?: string | undefined;
    beneficiary?: string | undefined;

    constructor(data?: IActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idsuivi = _data["idsuivi"];
            this.demande = _data["demande"];
            this.expediteur = _data["expediteur"];
            this.collaborateur = _data["collaborateur"];
            this.titre = _data["titre"];
            this.action = _data["action"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.dateEcheance = _data["dateEcheance"] ? new Date(_data["dateEcheance"].toString()) : <any>undefined;
            this.prio = _data["prio"];
            this.apprenant = _data["apprenant"];
            this.formateur = _data["formateur"];
            this.representant = _data["representant"];
            this.chefEntreprise = _data["chefEntreprise"];
            this.tuteur = _data["tuteur"];
            this.contact = _data["contact"];
            this.beneficiary = _data["beneficiary"];
        }
    }

    static fromJS(data: any): ActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idsuivi"] = this.idsuivi;
        data["demande"] = this.demande;
        data["expediteur"] = this.expediteur;
        data["collaborateur"] = this.collaborateur;
        data["titre"] = this.titre;
        data["action"] = this.action;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["dateEcheance"] = this.dateEcheance ? this.dateEcheance.toISOString() : <any>undefined;
        data["prio"] = this.prio;
        data["apprenant"] = this.apprenant;
        data["formateur"] = this.formateur;
        data["representant"] = this.representant;
        data["chefEntreprise"] = this.chefEntreprise;
        data["tuteur"] = this.tuteur;
        data["contact"] = this.contact;
        data["beneficiary"] = this.beneficiary;
        return data;
    }

    clone(): ActionGridDto {
        const json = this.toJSON();
        let result = new ActionGridDto();
        result.init(json);
        return result;
    }
}

export interface IActionGridDto {
    idsuivi?: number;
    demande?: string | undefined;
    expediteur?: string | undefined;
    collaborateur?: string | undefined;
    titre?: string | undefined;
    action?: string | undefined;
    creationDate?: Date;
    dateEcheance?: Date | undefined;
    prio?: string | undefined;
    apprenant?: string | undefined;
    formateur?: string | undefined;
    representant?: string | undefined;
    chefEntreprise?: string | undefined;
    tuteur?: string | undefined;
    contact?: string | undefined;
    beneficiary?: string | undefined;
}

export class AggregateResult implements IAggregateResult {
    valueDouble?: number | undefined;
    valueDec?: number | undefined;
    valueFloat?: number | undefined;
    key?: string | undefined;
    text?: string | undefined;
    value?: number | undefined;

    constructor(data?: IAggregateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valueDouble = _data["valueDouble"];
            this.valueDec = _data["valueDec"];
            this.valueFloat = _data["valueFloat"];
            this.key = _data["key"];
            this.text = _data["text"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AggregateResult {
        data = typeof data === 'object' ? data : {};
        let result = new AggregateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valueDouble"] = this.valueDouble;
        data["valueDec"] = this.valueDec;
        data["valueFloat"] = this.valueFloat;
        data["key"] = this.key;
        data["text"] = this.text;
        data["value"] = this.value;
        return data;
    }

    clone(): AggregateResult {
        const json = this.toJSON();
        let result = new AggregateResult();
        result.init(json);
        return result;
    }
}

export interface IAggregateResult {
    valueDouble?: number | undefined;
    valueDec?: number | undefined;
    valueFloat?: number | undefined;
    key?: string | undefined;
    text?: string | undefined;
    value?: number | undefined;
}

export class FilterCriteriaInfo implements IFilterCriteriaInfo {
    criteria?: string | undefined;
    type?: ECriteriaType;
    searchModes?: string[] | undefined;
    defaultSearchMode?: string | undefined;
    listValues?: SelectItem[] | undefined;
    isMultipleOr?: boolean;

    constructor(data?: IFilterCriteriaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.criteria = _data["criteria"];
            this.type = _data["type"];
            if (Array.isArray(_data["searchModes"])) {
                this.searchModes = [] as any;
                for (let item of _data["searchModes"])
                    this.searchModes!.push(item);
            }
            this.defaultSearchMode = _data["defaultSearchMode"];
            if (Array.isArray(_data["listValues"])) {
                this.listValues = [] as any;
                for (let item of _data["listValues"])
                    this.listValues!.push(SelectItem.fromJS(item));
            }
            this.isMultipleOr = _data["isMultipleOr"];
        }
    }

    static fromJS(data: any): FilterCriteriaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FilterCriteriaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria;
        data["type"] = this.type;
        if (Array.isArray(this.searchModes)) {
            data["searchModes"] = [];
            for (let item of this.searchModes)
                data["searchModes"].push(item);
        }
        data["defaultSearchMode"] = this.defaultSearchMode;
        if (Array.isArray(this.listValues)) {
            data["listValues"] = [];
            for (let item of this.listValues)
                data["listValues"].push(item.toJSON());
        }
        data["isMultipleOr"] = this.isMultipleOr;
        return data;
    }

    clone(): FilterCriteriaInfo {
        const json = this.toJSON();
        let result = new FilterCriteriaInfo();
        result.init(json);
        return result;
    }
}

export interface IFilterCriteriaInfo {
    criteria?: string | undefined;
    type?: ECriteriaType;
    searchModes?: string[] | undefined;
    defaultSearchMode?: string | undefined;
    listValues?: SelectItem[] | undefined;
    isMultipleOr?: boolean;
}

export enum ECriteriaType {
    Text = "Text",
    List = "List",
    Date = "Date",
    Boolean = "Boolean",
    Numeric = "Numeric",
    Float = "Float",
}

export class SelectItem implements ISelectItem {
    idValue?: string | undefined;
    displayValue?: string | undefined;

    constructor(data?: ISelectItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idValue = _data["idValue"];
            this.displayValue = _data["displayValue"];
        }
    }

    static fromJS(data: any): SelectItem {
        data = typeof data === 'object' ? data : {};
        let result = new SelectItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idValue"] = this.idValue;
        data["displayValue"] = this.displayValue;
        return data;
    }

    clone(): SelectItem {
        const json = this.toJSON();
        let result = new SelectItem();
        result.init(json);
        return result;
    }
}

export interface ISelectItem {
    idValue?: string | undefined;
    displayValue?: string | undefined;
}

export class ReferentialItemDto extends SelectItem implements IReferentialItemDto {
    keyValue?: string | undefined;

    constructor(data?: IReferentialItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keyValue = _data["keyValue"];
        }
    }

    static override fromJS(data: any): ReferentialItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferentialItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyValue"] = this.keyValue;
        super.toJSON(data);
        return data;
    }

    clone(): ReferentialItemDto {
        const json = this.toJSON();
        let result = new ReferentialItemDto();
        result.init(json);
        return result;
    }
}

export interface IReferentialItemDto extends ISelectItem {
    keyValue?: string | undefined;
}

export class AzureMemberDetailDto implements IAzureMemberDetailDto {
    id?: number;
    iduser?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fonction?: string | undefined;
    departement?: string | undefined;
    email?: string | undefined;
    telephone?: string | undefined;

    constructor(data?: IAzureMemberDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.iduser = _data["iduser"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fonction = _data["fonction"];
            this.departement = _data["departement"];
            this.email = _data["email"];
            this.telephone = _data["telephone"];
        }
    }

    static fromJS(data: any): AzureMemberDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AzureMemberDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["iduser"] = this.iduser;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fonction"] = this.fonction;
        data["departement"] = this.departement;
        data["email"] = this.email;
        data["telephone"] = this.telephone;
        return data;
    }

    clone(): AzureMemberDetailDto {
        const json = this.toJSON();
        let result = new AzureMemberDetailDto();
        result.init(json);
        return result;
    }
}

export interface IAzureMemberDetailDto {
    id?: number;
    iduser?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fonction?: string | undefined;
    departement?: string | undefined;
    email?: string | undefined;
    telephone?: string | undefined;
}

export class AzureUserDto implements IAzureUserDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    displayName?: string | undefined;
    userPrincipalName?: string | undefined;
    mail?: string | undefined;
    identifier?: string | undefined;
    jobTitle?: string | undefined;
    department?: string | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    officeLocation?: string | undefined;
    postalCode?: string | undefined;
    photo?: string | undefined;
    manager?: AzureManagerDto | undefined;
    o365UserId?: string | undefined;
    accountEnabled?: boolean;
    smileUserId?: number | undefined;
    idpersonne?: number | undefined;

    constructor(data?: IAzureUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.displayName = _data["displayName"];
            this.userPrincipalName = _data["userPrincipalName"];
            this.mail = _data["mail"];
            this.identifier = _data["identifier"];
            this.jobTitle = _data["jobTitle"];
            this.department = _data["department"];
            this.mobile = _data["mobile"];
            this.phone = _data["phone"];
            this.officeLocation = _data["officeLocation"];
            this.postalCode = _data["postalCode"];
            this.photo = _data["photo"];
            this.manager = _data["manager"] ? AzureManagerDto.fromJS(_data["manager"]) : <any>undefined;
            this.o365UserId = _data["o365UserId"];
            this.accountEnabled = _data["accountEnabled"];
            this.smileUserId = _data["smileUserId"];
            this.idpersonne = _data["idpersonne"];
        }
    }

    static fromJS(data: any): AzureUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AzureUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["displayName"] = this.displayName;
        data["userPrincipalName"] = this.userPrincipalName;
        data["mail"] = this.mail;
        data["identifier"] = this.identifier;
        data["jobTitle"] = this.jobTitle;
        data["department"] = this.department;
        data["mobile"] = this.mobile;
        data["phone"] = this.phone;
        data["officeLocation"] = this.officeLocation;
        data["postalCode"] = this.postalCode;
        data["photo"] = this.photo;
        data["manager"] = this.manager ? this.manager.toJSON() : <any>undefined;
        data["o365UserId"] = this.o365UserId;
        data["accountEnabled"] = this.accountEnabled;
        data["smileUserId"] = this.smileUserId;
        data["idpersonne"] = this.idpersonne;
        return data;
    }

    clone(): AzureUserDto {
        const json = this.toJSON();
        let result = new AzureUserDto();
        result.init(json);
        return result;
    }
}

export interface IAzureUserDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    displayName?: string | undefined;
    userPrincipalName?: string | undefined;
    mail?: string | undefined;
    identifier?: string | undefined;
    jobTitle?: string | undefined;
    department?: string | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    officeLocation?: string | undefined;
    postalCode?: string | undefined;
    photo?: string | undefined;
    manager?: AzureManagerDto | undefined;
    o365UserId?: string | undefined;
    accountEnabled?: boolean;
    smileUserId?: number | undefined;
    idpersonne?: number | undefined;
}

export class AzureManagerDto implements IAzureManagerDto {
    displayName?: string | undefined;
    photo?: string | undefined;

    constructor(data?: IAzureManagerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.photo = _data["photo"];
        }
    }

    static fromJS(data: any): AzureManagerDto {
        data = typeof data === 'object' ? data : {};
        let result = new AzureManagerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["photo"] = this.photo;
        return data;
    }

    clone(): AzureManagerDto {
        const json = this.toJSON();
        let result = new AzureManagerDto();
        result.init(json);
        return result;
    }
}

export interface IAzureManagerDto {
    displayName?: string | undefined;
    photo?: string | undefined;
}

export class SearchQueryOfAzureMemberSearchCriteria implements ISearchQueryOfAzureMemberSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: AzureMemberSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfAzureMemberSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? AzureMemberSearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfAzureMemberSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfAzureMemberSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfAzureMemberSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfAzureMemberSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfAzureMemberSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: AzureMemberSearchCriteria | undefined;
}

export class AzureMemberSearchCriteria extends PaginatedSearchable implements IAzureMemberSearchCriteria {
    activeOnly?: boolean;
    fullNameFilter?: string | undefined;
    linkedUserOnly?: boolean;

    constructor(data?: IAzureMemberSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activeOnly = _data["activeOnly"];
            this.fullNameFilter = _data["fullNameFilter"];
            this.linkedUserOnly = _data["linkedUserOnly"];
        }
    }

    static override fromJS(data: any): AzureMemberSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new AzureMemberSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeOnly"] = this.activeOnly;
        data["fullNameFilter"] = this.fullNameFilter;
        data["linkedUserOnly"] = this.linkedUserOnly;
        super.toJSON(data);
        return data;
    }

    clone(): AzureMemberSearchCriteria {
        const json = this.toJSON();
        let result = new AzureMemberSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface IAzureMemberSearchCriteria extends IPaginatedSearchable {
    activeOnly?: boolean;
    fullNameFilter?: string | undefined;
    linkedUserOnly?: boolean;
}

export class PaginatedResultsOfAzureMemberGridDto implements IPaginatedResultsOfAzureMemberGridDto {
    totalCount?: number;
    results?: AzureMemberGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfAzureMemberGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AzureMemberGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfAzureMemberGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfAzureMemberGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfAzureMemberGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfAzureMemberGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfAzureMemberGridDto {
    totalCount?: number;
    results?: AzureMemberGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class AzureMemberGridDto implements IAzureMemberGridDto {
    id?: number;
    iduser?: number | undefined;
    idpersonne?: number | undefined;
    isActive?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    group?: string | undefined;
    fonction?: string | undefined;
    gsm?: string | undefined;
    email?: string | undefined;

    constructor(data?: IAzureMemberGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.iduser = _data["iduser"];
            this.idpersonne = _data["idpersonne"];
            this.isActive = _data["isActive"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.group = _data["group"];
            this.fonction = _data["fonction"];
            this.gsm = _data["gsm"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): AzureMemberGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new AzureMemberGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["iduser"] = this.iduser;
        data["idpersonne"] = this.idpersonne;
        data["isActive"] = this.isActive;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["group"] = this.group;
        data["fonction"] = this.fonction;
        data["gsm"] = this.gsm;
        data["email"] = this.email;
        return data;
    }

    clone(): AzureMemberGridDto {
        const json = this.toJSON();
        let result = new AzureMemberGridDto();
        result.init(json);
        return result;
    }
}

export interface IAzureMemberGridDto {
    id?: number;
    iduser?: number | undefined;
    idpersonne?: number | undefined;
    isActive?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    group?: string | undefined;
    fonction?: string | undefined;
    gsm?: string | undefined;
    email?: string | undefined;
}

export class SiegeSocialDto implements ISiegeSocialDto {
    idsiegeSocial?: number;
    denominationSociale?: string | undefined;
    codePostal?: string | undefined;
    gsm?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    localite?: string | undefined;
    commune?: string | undefined;
    numeroBce?: string | undefined;
    chefEntreprisePrincipal?: string | undefined;

    constructor(data?: ISiegeSocialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idsiegeSocial = _data["idsiegeSocial"];
            this.denominationSociale = _data["denominationSociale"];
            this.codePostal = _data["codePostal"];
            this.gsm = _data["gsm"];
            this.telephone = _data["telephone"];
            this.email = _data["email"];
            this.localite = _data["localite"];
            this.commune = _data["commune"];
            this.numeroBce = _data["numeroBce"];
            this.chefEntreprisePrincipal = _data["chefEntreprisePrincipal"];
        }
    }

    static fromJS(data: any): SiegeSocialDto {
        data = typeof data === 'object' ? data : {};
        let result = new SiegeSocialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idsiegeSocial"] = this.idsiegeSocial;
        data["denominationSociale"] = this.denominationSociale;
        data["codePostal"] = this.codePostal;
        data["gsm"] = this.gsm;
        data["telephone"] = this.telephone;
        data["email"] = this.email;
        data["localite"] = this.localite;
        data["commune"] = this.commune;
        data["numeroBce"] = this.numeroBce;
        data["chefEntreprisePrincipal"] = this.chefEntreprisePrincipal;
        return data;
    }

    clone(): SiegeSocialDto {
        const json = this.toJSON();
        let result = new SiegeSocialDto();
        result.init(json);
        return result;
    }
}

export interface ISiegeSocialDto {
    idsiegeSocial?: number;
    denominationSociale?: string | undefined;
    codePostal?: string | undefined;
    gsm?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    localite?: string | undefined;
    commune?: string | undefined;
    numeroBce?: string | undefined;
    chefEntreprisePrincipal?: string | undefined;
}

export class HopeViewLieuFormationDto implements IHopeViewLieuFormationDto {
    idlieuFormation?: number;
    idsiegeSocial?: number;
    nom?: string | undefined;
    contact?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    localite?: string | undefined;
    enseigne?: string | undefined;
    actif?: boolean | undefined;

    constructor(data?: IHopeViewLieuFormationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idlieuFormation = _data["idlieuFormation"];
            this.idsiegeSocial = _data["idsiegeSocial"];
            this.nom = _data["nom"];
            this.contact = _data["contact"];
            this.telephone = _data["telephone"];
            this.email = _data["email"];
            this.localite = _data["localite"];
            this.enseigne = _data["enseigne"];
            this.actif = _data["actif"];
        }
    }

    static fromJS(data: any): HopeViewLieuFormationDto {
        data = typeof data === 'object' ? data : {};
        let result = new HopeViewLieuFormationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idlieuFormation"] = this.idlieuFormation;
        data["idsiegeSocial"] = this.idsiegeSocial;
        data["nom"] = this.nom;
        data["contact"] = this.contact;
        data["telephone"] = this.telephone;
        data["email"] = this.email;
        data["localite"] = this.localite;
        data["enseigne"] = this.enseigne;
        data["actif"] = this.actif;
        return data;
    }

    clone(): HopeViewLieuFormationDto {
        const json = this.toJSON();
        let result = new HopeViewLieuFormationDto();
        result.init(json);
        return result;
    }
}

export interface IHopeViewLieuFormationDto {
    idlieuFormation?: number;
    idsiegeSocial?: number;
    nom?: string | undefined;
    contact?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    localite?: string | undefined;
    enseigne?: string | undefined;
    actif?: boolean | undefined;
}

export class SearchQueryOfBeneficiaryCompanySearchCriteria implements ISearchQueryOfBeneficiaryCompanySearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: BeneficiaryCompanySearchCriteria | undefined;

    constructor(data?: ISearchQueryOfBeneficiaryCompanySearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? BeneficiaryCompanySearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfBeneficiaryCompanySearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfBeneficiaryCompanySearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfBeneficiaryCompanySearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfBeneficiaryCompanySearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfBeneficiaryCompanySearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: BeneficiaryCompanySearchCriteria | undefined;
}

export class BeneficiaryCompanySearchCriteria extends PaginatedSearchable implements IBeneficiaryCompanySearchCriteria {

    constructor(data?: IBeneficiaryCompanySearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): BeneficiaryCompanySearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiaryCompanySearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): BeneficiaryCompanySearchCriteria {
        const json = this.toJSON();
        let result = new BeneficiaryCompanySearchCriteria();
        result.init(json);
        return result;
    }
}

export interface IBeneficiaryCompanySearchCriteria extends IPaginatedSearchable {
}

export class PaginatedResultsOfBeneficiaryCompanyGridDto implements IPaginatedResultsOfBeneficiaryCompanyGridDto {
    totalCount?: number;
    results?: BeneficiaryCompanyGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfBeneficiaryCompanyGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BeneficiaryCompanyGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfBeneficiaryCompanyGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfBeneficiaryCompanyGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfBeneficiaryCompanyGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfBeneficiaryCompanyGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfBeneficiaryCompanyGridDto {
    totalCount?: number;
    results?: BeneficiaryCompanyGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class BeneficiaryCompanyGridDto implements IBeneficiaryCompanyGridDto {
    idsiegeSocial?: number;
    denominationSociale?: string | undefined;
    codePostal?: string | undefined;
    gsm?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    localite?: string | undefined;
    commune?: string | undefined;
    numeroBce?: string | undefined;
    chefEntreprisePrincipal?: string | undefined;

    constructor(data?: IBeneficiaryCompanyGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idsiegeSocial = _data["idsiegeSocial"];
            this.denominationSociale = _data["denominationSociale"];
            this.codePostal = _data["codePostal"];
            this.gsm = _data["gsm"];
            this.telephone = _data["telephone"];
            this.email = _data["email"];
            this.localite = _data["localite"];
            this.commune = _data["commune"];
            this.numeroBce = _data["numeroBce"];
            this.chefEntreprisePrincipal = _data["chefEntreprisePrincipal"];
        }
    }

    static fromJS(data: any): BeneficiaryCompanyGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiaryCompanyGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idsiegeSocial"] = this.idsiegeSocial;
        data["denominationSociale"] = this.denominationSociale;
        data["codePostal"] = this.codePostal;
        data["gsm"] = this.gsm;
        data["telephone"] = this.telephone;
        data["email"] = this.email;
        data["localite"] = this.localite;
        data["commune"] = this.commune;
        data["numeroBce"] = this.numeroBce;
        data["chefEntreprisePrincipal"] = this.chefEntreprisePrincipal;
        return data;
    }

    clone(): BeneficiaryCompanyGridDto {
        const json = this.toJSON();
        let result = new BeneficiaryCompanyGridDto();
        result.init(json);
        return result;
    }
}

export interface IBeneficiaryCompanyGridDto {
    idsiegeSocial?: number;
    denominationSociale?: string | undefined;
    codePostal?: string | undefined;
    gsm?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    localite?: string | undefined;
    commune?: string | undefined;
    numeroBce?: string | undefined;
    chefEntreprisePrincipal?: string | undefined;
}

export class EditBeneficiaryPersonDto implements IEditBeneficiaryPersonDto {
    idpersonne?: number;
    nom?: string | undefined;
    prenom?: string | undefined;
    prenom2?: string | undefined;
    codesexe?: string | undefined;
    nationalite?: string | undefined;
    codePaysNaissance?: string | undefined;
    dateNaissance?: Date | undefined;
    localiteNaissance?: string | undefined;
    communeNaissance?: string | undefined;
    registreNational?: string | undefined;
    numeroIdentification?: string | undefined;
    photo?: string | undefined;
    idfichierPhoto?: number | undefined;
    dateDeces?: Date | undefined;
    remarque?: string | undefined;
    adresseDomicile?: AdresseDto | undefined;
    adresseCourrier?: AdresseDto | undefined;
    adresseAutre?: AdresseDto | undefined;
    compteBancaires?: CompteBancaireDto[] | undefined;
    telephones?: TelephoneDto[] | undefined;
    emails?: EmailDto[] | undefined;
    idaddressDoublons?: number[] | undefined;
    idaddressCourrierDoublons?: number[] | undefined;
    idaddressAutreDoublons?: number[] | undefined;
    idapprenant?: number | undefined;
    idformateur?: number | undefined;
    idrepresentant?: number | undefined;
    iduser?: number | undefined;
    idchefEntreprise?: number | undefined;
    idtuteur?: number | undefined;
    idconseillerPedagogique?: string | undefined;
    idcontact?: string | undefined;
    formeFromSuivi?: Forme | undefined;
    idsiegeSocial?: number | undefined;
    numeroBce?: string | undefined;
    denominationSociale?: string | undefined;
    idlieuFormation?: number | undefined;
    nomLieuFormation?: string | undefined;

    constructor(data?: IEditBeneficiaryPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idpersonne = _data["idpersonne"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.prenom2 = _data["prenom2"];
            this.codesexe = _data["codesexe"];
            this.nationalite = _data["nationalite"];
            this.codePaysNaissance = _data["codePaysNaissance"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : <any>undefined;
            this.localiteNaissance = _data["localiteNaissance"];
            this.communeNaissance = _data["communeNaissance"];
            this.registreNational = _data["registreNational"];
            this.numeroIdentification = _data["numeroIdentification"];
            this.photo = _data["photo"];
            this.idfichierPhoto = _data["idfichierPhoto"];
            this.dateDeces = _data["dateDeces"] ? new Date(_data["dateDeces"].toString()) : <any>undefined;
            this.remarque = _data["remarque"];
            this.adresseDomicile = _data["adresseDomicile"] ? AdresseDto.fromJS(_data["adresseDomicile"]) : <any>undefined;
            this.adresseCourrier = _data["adresseCourrier"] ? AdresseDto.fromJS(_data["adresseCourrier"]) : <any>undefined;
            this.adresseAutre = _data["adresseAutre"] ? AdresseDto.fromJS(_data["adresseAutre"]) : <any>undefined;
            if (Array.isArray(_data["compteBancaires"])) {
                this.compteBancaires = [] as any;
                for (let item of _data["compteBancaires"])
                    this.compteBancaires!.push(CompteBancaireDto.fromJS(item));
            }
            if (Array.isArray(_data["telephones"])) {
                this.telephones = [] as any;
                for (let item of _data["telephones"])
                    this.telephones!.push(TelephoneDto.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(EmailDto.fromJS(item));
            }
            if (Array.isArray(_data["idaddressDoublons"])) {
                this.idaddressDoublons = [] as any;
                for (let item of _data["idaddressDoublons"])
                    this.idaddressDoublons!.push(item);
            }
            if (Array.isArray(_data["idaddressCourrierDoublons"])) {
                this.idaddressCourrierDoublons = [] as any;
                for (let item of _data["idaddressCourrierDoublons"])
                    this.idaddressCourrierDoublons!.push(item);
            }
            if (Array.isArray(_data["idaddressAutreDoublons"])) {
                this.idaddressAutreDoublons = [] as any;
                for (let item of _data["idaddressAutreDoublons"])
                    this.idaddressAutreDoublons!.push(item);
            }
            this.idapprenant = _data["idapprenant"];
            this.idformateur = _data["idformateur"];
            this.idrepresentant = _data["idrepresentant"];
            this.iduser = _data["iduser"];
            this.idchefEntreprise = _data["idchefEntreprise"];
            this.idtuteur = _data["idtuteur"];
            this.idconseillerPedagogique = _data["idconseillerPedagogique"];
            this.idcontact = _data["idcontact"];
            this.formeFromSuivi = _data["formeFromSuivi"];
            this.idsiegeSocial = _data["idsiegeSocial"];
            this.numeroBce = _data["numeroBce"];
            this.denominationSociale = _data["denominationSociale"];
            this.idlieuFormation = _data["idlieuFormation"];
            this.nomLieuFormation = _data["nomLieuFormation"];
        }
    }

    static fromJS(data: any): EditBeneficiaryPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditBeneficiaryPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idpersonne"] = this.idpersonne;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["prenom2"] = this.prenom2;
        data["codesexe"] = this.codesexe;
        data["nationalite"] = this.nationalite;
        data["codePaysNaissance"] = this.codePaysNaissance;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : <any>undefined;
        data["localiteNaissance"] = this.localiteNaissance;
        data["communeNaissance"] = this.communeNaissance;
        data["registreNational"] = this.registreNational;
        data["numeroIdentification"] = this.numeroIdentification;
        data["photo"] = this.photo;
        data["idfichierPhoto"] = this.idfichierPhoto;
        data["dateDeces"] = this.dateDeces ? this.dateDeces.toISOString() : <any>undefined;
        data["remarque"] = this.remarque;
        data["adresseDomicile"] = this.adresseDomicile ? this.adresseDomicile.toJSON() : <any>undefined;
        data["adresseCourrier"] = this.adresseCourrier ? this.adresseCourrier.toJSON() : <any>undefined;
        data["adresseAutre"] = this.adresseAutre ? this.adresseAutre.toJSON() : <any>undefined;
        if (Array.isArray(this.compteBancaires)) {
            data["compteBancaires"] = [];
            for (let item of this.compteBancaires)
                data["compteBancaires"].push(item.toJSON());
        }
        if (Array.isArray(this.telephones)) {
            data["telephones"] = [];
            for (let item of this.telephones)
                data["telephones"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (Array.isArray(this.idaddressDoublons)) {
            data["idaddressDoublons"] = [];
            for (let item of this.idaddressDoublons)
                data["idaddressDoublons"].push(item);
        }
        if (Array.isArray(this.idaddressCourrierDoublons)) {
            data["idaddressCourrierDoublons"] = [];
            for (let item of this.idaddressCourrierDoublons)
                data["idaddressCourrierDoublons"].push(item);
        }
        if (Array.isArray(this.idaddressAutreDoublons)) {
            data["idaddressAutreDoublons"] = [];
            for (let item of this.idaddressAutreDoublons)
                data["idaddressAutreDoublons"].push(item);
        }
        data["idapprenant"] = this.idapprenant;
        data["idformateur"] = this.idformateur;
        data["idrepresentant"] = this.idrepresentant;
        data["iduser"] = this.iduser;
        data["idchefEntreprise"] = this.idchefEntreprise;
        data["idtuteur"] = this.idtuteur;
        data["idconseillerPedagogique"] = this.idconseillerPedagogique;
        data["idcontact"] = this.idcontact;
        data["formeFromSuivi"] = this.formeFromSuivi;
        data["idsiegeSocial"] = this.idsiegeSocial;
        data["numeroBce"] = this.numeroBce;
        data["denominationSociale"] = this.denominationSociale;
        data["idlieuFormation"] = this.idlieuFormation;
        data["nomLieuFormation"] = this.nomLieuFormation;
        return data;
    }

    clone(): EditBeneficiaryPersonDto {
        const json = this.toJSON();
        let result = new EditBeneficiaryPersonDto();
        result.init(json);
        return result;
    }
}

export interface IEditBeneficiaryPersonDto {
    idpersonne?: number;
    nom?: string | undefined;
    prenom?: string | undefined;
    prenom2?: string | undefined;
    codesexe?: string | undefined;
    nationalite?: string | undefined;
    codePaysNaissance?: string | undefined;
    dateNaissance?: Date | undefined;
    localiteNaissance?: string | undefined;
    communeNaissance?: string | undefined;
    registreNational?: string | undefined;
    numeroIdentification?: string | undefined;
    photo?: string | undefined;
    idfichierPhoto?: number | undefined;
    dateDeces?: Date | undefined;
    remarque?: string | undefined;
    adresseDomicile?: AdresseDto | undefined;
    adresseCourrier?: AdresseDto | undefined;
    adresseAutre?: AdresseDto | undefined;
    compteBancaires?: CompteBancaireDto[] | undefined;
    telephones?: TelephoneDto[] | undefined;
    emails?: EmailDto[] | undefined;
    idaddressDoublons?: number[] | undefined;
    idaddressCourrierDoublons?: number[] | undefined;
    idaddressAutreDoublons?: number[] | undefined;
    idapprenant?: number | undefined;
    idformateur?: number | undefined;
    idrepresentant?: number | undefined;
    iduser?: number | undefined;
    idchefEntreprise?: number | undefined;
    idtuteur?: number | undefined;
    idconseillerPedagogique?: string | undefined;
    idcontact?: string | undefined;
    formeFromSuivi?: Forme | undefined;
    idsiegeSocial?: number | undefined;
    numeroBce?: string | undefined;
    denominationSociale?: string | undefined;
    idlieuFormation?: number | undefined;
    nomLieuFormation?: string | undefined;
}

export class AdresseDto implements IAdresseDto {
    idadresse?: number;
    idpersonne?: number;
    adresse?: string | undefined;
    idcodePostal?: number | undefined;
    boite?: string | undefined;
    localite?: string | undefined;
    commune?: string | undefined;
    pays?: string | undefined;
    fullPays?: string | undefined;
    idtypeAdresse?: number;
    codePostalText?: string | undefined;
    codePostal?: string | undefined;
    typeAdresse?: string | undefined;

    constructor(data?: IAdresseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idadresse = _data["idadresse"];
            this.idpersonne = _data["idpersonne"];
            this.adresse = _data["adresse"];
            this.idcodePostal = _data["idcodePostal"];
            this.boite = _data["boite"];
            this.localite = _data["localite"];
            this.commune = _data["commune"];
            this.pays = _data["pays"];
            this.fullPays = _data["fullPays"];
            this.idtypeAdresse = _data["idtypeAdresse"];
            this.codePostalText = _data["codePostalText"];
            this.codePostal = _data["codePostal"];
            this.typeAdresse = _data["typeAdresse"];
        }
    }

    static fromJS(data: any): AdresseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdresseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idadresse"] = this.idadresse;
        data["idpersonne"] = this.idpersonne;
        data["adresse"] = this.adresse;
        data["idcodePostal"] = this.idcodePostal;
        data["boite"] = this.boite;
        data["localite"] = this.localite;
        data["commune"] = this.commune;
        data["pays"] = this.pays;
        data["fullPays"] = this.fullPays;
        data["idtypeAdresse"] = this.idtypeAdresse;
        data["codePostalText"] = this.codePostalText;
        data["codePostal"] = this.codePostal;
        data["typeAdresse"] = this.typeAdresse;
        return data;
    }

    clone(): AdresseDto {
        const json = this.toJSON();
        let result = new AdresseDto();
        result.init(json);
        return result;
    }
}

export interface IAdresseDto {
    idadresse?: number;
    idpersonne?: number;
    adresse?: string | undefined;
    idcodePostal?: number | undefined;
    boite?: string | undefined;
    localite?: string | undefined;
    commune?: string | undefined;
    pays?: string | undefined;
    fullPays?: string | undefined;
    idtypeAdresse?: number;
    codePostalText?: string | undefined;
    codePostal?: string | undefined;
    typeAdresse?: string | undefined;
}

export class CompteBancaireDto implements ICompteBancaireDto {
    idcompteBancaire?: number | undefined;
    idpersonne?: number | undefined;
    iban?: string | undefined;
    bic?: string | undefined;

    constructor(data?: ICompteBancaireDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idcompteBancaire = _data["idcompteBancaire"];
            this.idpersonne = _data["idpersonne"];
            this.iban = _data["iban"];
            this.bic = _data["bic"];
        }
    }

    static fromJS(data: any): CompteBancaireDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompteBancaireDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idcompteBancaire"] = this.idcompteBancaire;
        data["idpersonne"] = this.idpersonne;
        data["iban"] = this.iban;
        data["bic"] = this.bic;
        return data;
    }

    clone(): CompteBancaireDto {
        const json = this.toJSON();
        let result = new CompteBancaireDto();
        result.init(json);
        return result;
    }
}

export interface ICompteBancaireDto {
    idcompteBancaire?: number | undefined;
    idpersonne?: number | undefined;
    iban?: string | undefined;
    bic?: string | undefined;
}

export class TelephoneDto implements ITelephoneDto {
    idtelephone?: number | undefined;
    idpersonne?: number;
    numero?: string | undefined;
    idtypeTelephone?: number;
    typeTelephone?: string | undefined;

    constructor(data?: ITelephoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idtelephone = _data["idtelephone"];
            this.idpersonne = _data["idpersonne"];
            this.numero = _data["numero"];
            this.idtypeTelephone = _data["idtypeTelephone"];
            this.typeTelephone = _data["typeTelephone"];
        }
    }

    static fromJS(data: any): TelephoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new TelephoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idtelephone"] = this.idtelephone;
        data["idpersonne"] = this.idpersonne;
        data["numero"] = this.numero;
        data["idtypeTelephone"] = this.idtypeTelephone;
        data["typeTelephone"] = this.typeTelephone;
        return data;
    }

    clone(): TelephoneDto {
        const json = this.toJSON();
        let result = new TelephoneDto();
        result.init(json);
        return result;
    }
}

export interface ITelephoneDto {
    idtelephone?: number | undefined;
    idpersonne?: number;
    numero?: string | undefined;
    idtypeTelephone?: number;
    typeTelephone?: string | undefined;
}

export class EmailDto implements IEmailDto {
    idemail?: number | undefined;
    idpersonne?: number;
    adresseEmail?: string | undefined;
    idtypeEmail?: number;
    typeEmail?: string | undefined;

    constructor(data?: IEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idemail = _data["idemail"];
            this.idpersonne = _data["idpersonne"];
            this.adresseEmail = _data["adresseEmail"];
            this.idtypeEmail = _data["idtypeEmail"];
            this.typeEmail = _data["typeEmail"];
        }
    }

    static fromJS(data: any): EmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idemail"] = this.idemail;
        data["idpersonne"] = this.idpersonne;
        data["adresseEmail"] = this.adresseEmail;
        data["idtypeEmail"] = this.idtypeEmail;
        data["typeEmail"] = this.typeEmail;
        return data;
    }

    clone(): EmailDto {
        const json = this.toJSON();
        let result = new EmailDto();
        result.init(json);
        return result;
    }
}

export interface IEmailDto {
    idemail?: number | undefined;
    idpersonne?: number;
    adresseEmail?: string | undefined;
    idtypeEmail?: number;
    typeEmail?: string | undefined;
}

export enum Forme {
    Apprenant = "Apprenant",
    Formateur = "Formateur",
    Representant = "Representant",
    ChefEntreprise = "ChefEntreprise",
    Tuteur = "Tuteur",
    Contact = "Contact",
}

export class ApprenantSuiviDto implements IApprenantSuiviDto {
    idsuivi?: number | undefined;
    idservice?: number | undefined;
    service?: string | undefined;
    centre?: string | undefined;
    userService?: string | undefined;
    idencodeur?: number | undefined;
    encodeur?: string | undefined;
    idrealisateurSuivi?: number | undefined;
    realisateurSuivi?: string | undefined;
    fromHope?: boolean | undefined;
    dateSuivi?: Date | undefined;
    idapprenant?: number | undefined;
    nomApprenant?: string | undefined;
    prenomApprenant?: string | undefined;
    apprenant?: string | undefined;
    apprenantFullName?: string | undefined;
    idtypeSuivi?: number | undefined;
    typeSuivi?: string | undefined;
    idsousTypeSuivi?: number;
    sousTypeSuivi?: string | undefined;
    hiddenContent?: string | undefined;
    actionDateEcheance?: Date | undefined;
    actionDateRealisation?: Date | undefined;
    realisateurAction?: number | undefined;
    idcentre?: number | undefined;

    constructor(data?: IApprenantSuiviDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idsuivi = _data["idsuivi"];
            this.idservice = _data["idservice"];
            this.service = _data["service"];
            this.centre = _data["centre"];
            this.userService = _data["userService"];
            this.idencodeur = _data["idencodeur"];
            this.encodeur = _data["encodeur"];
            this.idrealisateurSuivi = _data["idrealisateurSuivi"];
            this.realisateurSuivi = _data["realisateurSuivi"];
            this.fromHope = _data["fromHope"];
            this.dateSuivi = _data["dateSuivi"] ? new Date(_data["dateSuivi"].toString()) : <any>undefined;
            this.idapprenant = _data["idapprenant"];
            this.nomApprenant = _data["nomApprenant"];
            this.prenomApprenant = _data["prenomApprenant"];
            this.apprenant = _data["apprenant"];
            this.apprenantFullName = _data["apprenantFullName"];
            this.idtypeSuivi = _data["idtypeSuivi"];
            this.typeSuivi = _data["typeSuivi"];
            this.idsousTypeSuivi = _data["idsousTypeSuivi"];
            this.sousTypeSuivi = _data["sousTypeSuivi"];
            this.hiddenContent = _data["hiddenContent"];
            this.actionDateEcheance = _data["actionDateEcheance"] ? new Date(_data["actionDateEcheance"].toString()) : <any>undefined;
            this.actionDateRealisation = _data["actionDateRealisation"] ? new Date(_data["actionDateRealisation"].toString()) : <any>undefined;
            this.realisateurAction = _data["realisateurAction"];
            this.idcentre = _data["idcentre"];
        }
    }

    static fromJS(data: any): ApprenantSuiviDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprenantSuiviDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idsuivi"] = this.idsuivi;
        data["idservice"] = this.idservice;
        data["service"] = this.service;
        data["centre"] = this.centre;
        data["userService"] = this.userService;
        data["idencodeur"] = this.idencodeur;
        data["encodeur"] = this.encodeur;
        data["idrealisateurSuivi"] = this.idrealisateurSuivi;
        data["realisateurSuivi"] = this.realisateurSuivi;
        data["fromHope"] = this.fromHope;
        data["dateSuivi"] = this.dateSuivi ? this.dateSuivi.toISOString() : <any>undefined;
        data["idapprenant"] = this.idapprenant;
        data["nomApprenant"] = this.nomApprenant;
        data["prenomApprenant"] = this.prenomApprenant;
        data["apprenant"] = this.apprenant;
        data["apprenantFullName"] = this.apprenantFullName;
        data["idtypeSuivi"] = this.idtypeSuivi;
        data["typeSuivi"] = this.typeSuivi;
        data["idsousTypeSuivi"] = this.idsousTypeSuivi;
        data["sousTypeSuivi"] = this.sousTypeSuivi;
        data["hiddenContent"] = this.hiddenContent;
        data["actionDateEcheance"] = this.actionDateEcheance ? this.actionDateEcheance.toISOString() : <any>undefined;
        data["actionDateRealisation"] = this.actionDateRealisation ? this.actionDateRealisation.toISOString() : <any>undefined;
        data["realisateurAction"] = this.realisateurAction;
        data["idcentre"] = this.idcentre;
        return data;
    }

    clone(): ApprenantSuiviDto {
        const json = this.toJSON();
        let result = new ApprenantSuiviDto();
        result.init(json);
        return result;
    }
}

export interface IApprenantSuiviDto {
    idsuivi?: number | undefined;
    idservice?: number | undefined;
    service?: string | undefined;
    centre?: string | undefined;
    userService?: string | undefined;
    idencodeur?: number | undefined;
    encodeur?: string | undefined;
    idrealisateurSuivi?: number | undefined;
    realisateurSuivi?: string | undefined;
    fromHope?: boolean | undefined;
    dateSuivi?: Date | undefined;
    idapprenant?: number | undefined;
    nomApprenant?: string | undefined;
    prenomApprenant?: string | undefined;
    apprenant?: string | undefined;
    apprenantFullName?: string | undefined;
    idtypeSuivi?: number | undefined;
    typeSuivi?: string | undefined;
    idsousTypeSuivi?: number;
    sousTypeSuivi?: string | undefined;
    hiddenContent?: string | undefined;
    actionDateEcheance?: Date | undefined;
    actionDateRealisation?: Date | undefined;
    realisateurAction?: number | undefined;
    idcentre?: number | undefined;
}

export class PersonneFormeIdsDto implements IPersonneFormeIdsDto {
    idapprenant?: number | undefined;
    idformateur?: number | undefined;
    idrepresentant?: number | undefined;
    idchefEntreprise?: number | undefined;
    idtuteur?: number | undefined;
    idcontact?: number | undefined;
    idpersonne?: number | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;

    constructor(data?: IPersonneFormeIdsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idapprenant = _data["idapprenant"];
            this.idformateur = _data["idformateur"];
            this.idrepresentant = _data["idrepresentant"];
            this.idchefEntreprise = _data["idchefEntreprise"];
            this.idtuteur = _data["idtuteur"];
            this.idcontact = _data["idcontact"];
            this.idpersonne = _data["idpersonne"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
        }
    }

    static fromJS(data: any): PersonneFormeIdsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonneFormeIdsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idapprenant"] = this.idapprenant;
        data["idformateur"] = this.idformateur;
        data["idrepresentant"] = this.idrepresentant;
        data["idchefEntreprise"] = this.idchefEntreprise;
        data["idtuteur"] = this.idtuteur;
        data["idcontact"] = this.idcontact;
        data["idpersonne"] = this.idpersonne;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        return data;
    }

    clone(): PersonneFormeIdsDto {
        const json = this.toJSON();
        let result = new PersonneFormeIdsDto();
        result.init(json);
        return result;
    }
}

export interface IPersonneFormeIdsDto {
    idapprenant?: number | undefined;
    idformateur?: number | undefined;
    idrepresentant?: number | undefined;
    idchefEntreprise?: number | undefined;
    idtuteur?: number | undefined;
    idcontact?: number | undefined;
    idpersonne?: number | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
}

export class BeneficiarySearchReturnDto implements IBeneficiarySearchReturnDto {
    results?: BeneficiarySearchGroupedResultDto[] | undefined;
    hasMore?: boolean;

    constructor(data?: IBeneficiarySearchReturnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BeneficiarySearchGroupedResultDto.fromJS(item));
            }
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): BeneficiarySearchReturnDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiarySearchReturnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["hasMore"] = this.hasMore;
        return data;
    }

    clone(): BeneficiarySearchReturnDto {
        const json = this.toJSON();
        let result = new BeneficiarySearchReturnDto();
        result.init(json);
        return result;
    }
}

export interface IBeneficiarySearchReturnDto {
    results?: BeneficiarySearchGroupedResultDto[] | undefined;
    hasMore?: boolean;
}

export class BeneficiarySearchGroupedResultDto implements IBeneficiarySearchGroupedResultDto {
    idpersonne?: number;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
    telephone?: string | undefined;
    gsm?: string | undefined;
    mail?: string | undefined;
    registreNational?: string | undefined;
    numeroBce?: string | undefined;
    denominationSociale?: string | undefined;
    idsiegeSocial?: number | undefined;
    formes?: BeneficiarySearchFormDto[] | undefined;
    defaultForme?: Forme | undefined;

    constructor(data?: IBeneficiarySearchGroupedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idpersonne = _data["idpersonne"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : <any>undefined;
            this.telephone = _data["telephone"];
            this.gsm = _data["gsm"];
            this.mail = _data["mail"];
            this.registreNational = _data["registreNational"];
            this.numeroBce = _data["numeroBce"];
            this.denominationSociale = _data["denominationSociale"];
            this.idsiegeSocial = _data["idsiegeSocial"];
            if (Array.isArray(_data["formes"])) {
                this.formes = [] as any;
                for (let item of _data["formes"])
                    this.formes!.push(BeneficiarySearchFormDto.fromJS(item));
            }
            this.defaultForme = _data["defaultForme"];
        }
    }

    static fromJS(data: any): BeneficiarySearchGroupedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiarySearchGroupedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idpersonne"] = this.idpersonne;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : <any>undefined;
        data["telephone"] = this.telephone;
        data["gsm"] = this.gsm;
        data["mail"] = this.mail;
        data["registreNational"] = this.registreNational;
        data["numeroBce"] = this.numeroBce;
        data["denominationSociale"] = this.denominationSociale;
        data["idsiegeSocial"] = this.idsiegeSocial;
        if (Array.isArray(this.formes)) {
            data["formes"] = [];
            for (let item of this.formes)
                data["formes"].push(item.toJSON());
        }
        data["defaultForme"] = this.defaultForme;
        return data;
    }

    clone(): BeneficiarySearchGroupedResultDto {
        const json = this.toJSON();
        let result = new BeneficiarySearchGroupedResultDto();
        result.init(json);
        return result;
    }
}

export interface IBeneficiarySearchGroupedResultDto {
    idpersonne?: number;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
    telephone?: string | undefined;
    gsm?: string | undefined;
    mail?: string | undefined;
    registreNational?: string | undefined;
    numeroBce?: string | undefined;
    denominationSociale?: string | undefined;
    idsiegeSocial?: number | undefined;
    formes?: BeneficiarySearchFormDto[] | undefined;
    defaultForme?: Forme | undefined;
}

export class BeneficiarySearchFormDto implements IBeneficiarySearchFormDto {
    forme?: Forme;
    idapprenant?: number | undefined;
    idformateur?: number | undefined;
    idrepresentant?: number | undefined;
    idchefEntreprise?: number | undefined;
    idtuteur?: number | undefined;
    idcontact?: number | undefined;
    idcentre?: number | undefined;
    idcodePostal?: number | undefined;
    idpri?: number | undefined;
    idstade?: number | undefined;
    idmetier?: number | undefined;

    constructor(data?: IBeneficiarySearchFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forme = _data["forme"];
            this.idapprenant = _data["idapprenant"];
            this.idformateur = _data["idformateur"];
            this.idrepresentant = _data["idrepresentant"];
            this.idchefEntreprise = _data["idchefEntreprise"];
            this.idtuteur = _data["idtuteur"];
            this.idcontact = _data["idcontact"];
            this.idcentre = _data["idcentre"];
            this.idcodePostal = _data["idcodePostal"];
            this.idpri = _data["idpri"];
            this.idstade = _data["idstade"];
            this.idmetier = _data["idmetier"];
        }
    }

    static fromJS(data: any): BeneficiarySearchFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiarySearchFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forme"] = this.forme;
        data["idapprenant"] = this.idapprenant;
        data["idformateur"] = this.idformateur;
        data["idrepresentant"] = this.idrepresentant;
        data["idchefEntreprise"] = this.idchefEntreprise;
        data["idtuteur"] = this.idtuteur;
        data["idcontact"] = this.idcontact;
        data["idcentre"] = this.idcentre;
        data["idcodePostal"] = this.idcodePostal;
        data["idpri"] = this.idpri;
        data["idstade"] = this.idstade;
        data["idmetier"] = this.idmetier;
        return data;
    }

    clone(): BeneficiarySearchFormDto {
        const json = this.toJSON();
        let result = new BeneficiarySearchFormDto();
        result.init(json);
        return result;
    }
}

export interface IBeneficiarySearchFormDto {
    forme?: Forme;
    idapprenant?: number | undefined;
    idformateur?: number | undefined;
    idrepresentant?: number | undefined;
    idchefEntreprise?: number | undefined;
    idtuteur?: number | undefined;
    idcontact?: number | undefined;
    idcentre?: number | undefined;
    idcodePostal?: number | undefined;
    idpri?: number | undefined;
    idstade?: number | undefined;
    idmetier?: number | undefined;
}

export class SearchBeneficiaryDto implements ISearchBeneficiaryDto {
    idpersonne?: number;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
    codesexe?: string | undefined;
    nationalite?: string | undefined;
    forme?: Forme;
    telephone?: string | undefined;
    gsm?: string | undefined;
    email?: string | undefined;
    registreNational?: string | undefined;
    adresse?: AdresseDto | undefined;
    numeroBce?: string | undefined;
    denominationSociale?: string | undefined;
    idsiegeSocial?: number | undefined;
    idlieuFormation?: number | undefined;
    nomLieuFormation?: string | undefined;
    idapprenant?: number | undefined;
    idformateur?: number | undefined;
    idrepresentant?: number | undefined;
    idchefEntreprise?: number | undefined;
    idtuteur?: number | undefined;
    idcontact?: number | undefined;

    constructor(data?: ISearchBeneficiaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idpersonne = _data["idpersonne"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : <any>undefined;
            this.codesexe = _data["codesexe"];
            this.nationalite = _data["nationalite"];
            this.forme = _data["forme"];
            this.telephone = _data["telephone"];
            this.gsm = _data["gsm"];
            this.email = _data["email"];
            this.registreNational = _data["registreNational"];
            this.adresse = _data["adresse"] ? AdresseDto.fromJS(_data["adresse"]) : <any>undefined;
            this.numeroBce = _data["numeroBce"];
            this.denominationSociale = _data["denominationSociale"];
            this.idsiegeSocial = _data["idsiegeSocial"];
            this.idlieuFormation = _data["idlieuFormation"];
            this.nomLieuFormation = _data["nomLieuFormation"];
            this.idapprenant = _data["idapprenant"];
            this.idformateur = _data["idformateur"];
            this.idrepresentant = _data["idrepresentant"];
            this.idchefEntreprise = _data["idchefEntreprise"];
            this.idtuteur = _data["idtuteur"];
            this.idcontact = _data["idcontact"];
        }
    }

    static fromJS(data: any): SearchBeneficiaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchBeneficiaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idpersonne"] = this.idpersonne;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : <any>undefined;
        data["codesexe"] = this.codesexe;
        data["nationalite"] = this.nationalite;
        data["forme"] = this.forme;
        data["telephone"] = this.telephone;
        data["gsm"] = this.gsm;
        data["email"] = this.email;
        data["registreNational"] = this.registreNational;
        data["adresse"] = this.adresse ? this.adresse.toJSON() : <any>undefined;
        data["numeroBce"] = this.numeroBce;
        data["denominationSociale"] = this.denominationSociale;
        data["idsiegeSocial"] = this.idsiegeSocial;
        data["idlieuFormation"] = this.idlieuFormation;
        data["nomLieuFormation"] = this.nomLieuFormation;
        data["idapprenant"] = this.idapprenant;
        data["idformateur"] = this.idformateur;
        data["idrepresentant"] = this.idrepresentant;
        data["idchefEntreprise"] = this.idchefEntreprise;
        data["idtuteur"] = this.idtuteur;
        data["idcontact"] = this.idcontact;
        return data;
    }

    clone(): SearchBeneficiaryDto {
        const json = this.toJSON();
        let result = new SearchBeneficiaryDto();
        result.init(json);
        return result;
    }
}

export interface ISearchBeneficiaryDto {
    idpersonne?: number;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
    codesexe?: string | undefined;
    nationalite?: string | undefined;
    forme?: Forme;
    telephone?: string | undefined;
    gsm?: string | undefined;
    email?: string | undefined;
    registreNational?: string | undefined;
    adresse?: AdresseDto | undefined;
    numeroBce?: string | undefined;
    denominationSociale?: string | undefined;
    idsiegeSocial?: number | undefined;
    idlieuFormation?: number | undefined;
    nomLieuFormation?: string | undefined;
    idapprenant?: number | undefined;
    idformateur?: number | undefined;
    idrepresentant?: number | undefined;
    idchefEntreprise?: number | undefined;
    idtuteur?: number | undefined;
    idcontact?: number | undefined;
}

export class SearchQueryOfBeneficiaryPersonSearchCriteria implements ISearchQueryOfBeneficiaryPersonSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: BeneficiaryPersonSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfBeneficiaryPersonSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? BeneficiaryPersonSearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfBeneficiaryPersonSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfBeneficiaryPersonSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfBeneficiaryPersonSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfBeneficiaryPersonSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfBeneficiaryPersonSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: BeneficiaryPersonSearchCriteria | undefined;
}

export class BeneficiaryPersonSearchCriteria extends PaginatedSearchable implements IBeneficiaryPersonSearchCriteria {

    constructor(data?: IBeneficiaryPersonSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): BeneficiaryPersonSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiaryPersonSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): BeneficiaryPersonSearchCriteria {
        const json = this.toJSON();
        let result = new BeneficiaryPersonSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface IBeneficiaryPersonSearchCriteria extends IPaginatedSearchable {
}

export class PaginatedResultsOfBeneficiaryPersonGridDto implements IPaginatedResultsOfBeneficiaryPersonGridDto {
    totalCount?: number;
    results?: BeneficiaryPersonGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfBeneficiaryPersonGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BeneficiaryPersonGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfBeneficiaryPersonGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfBeneficiaryPersonGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfBeneficiaryPersonGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfBeneficiaryPersonGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfBeneficiaryPersonGridDto {
    totalCount?: number;
    results?: BeneficiaryPersonGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class BeneficiaryPersonGridDto implements IBeneficiaryPersonGridDto {
    idpersonne?: number;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
    isApprenant?: boolean;
    isFormateur?: boolean;
    isRepresentant?: boolean;
    isUser?: boolean;
    isChefEntreprise?: boolean;
    isTuteur?: boolean;
    isConseillePedagogique?: boolean;
    isContact?: boolean;

    constructor(data?: IBeneficiaryPersonGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idpersonne = _data["idpersonne"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : <any>undefined;
            this.isApprenant = _data["isApprenant"];
            this.isFormateur = _data["isFormateur"];
            this.isRepresentant = _data["isRepresentant"];
            this.isUser = _data["isUser"];
            this.isChefEntreprise = _data["isChefEntreprise"];
            this.isTuteur = _data["isTuteur"];
            this.isConseillePedagogique = _data["isConseillePedagogique"];
            this.isContact = _data["isContact"];
        }
    }

    static fromJS(data: any): BeneficiaryPersonGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiaryPersonGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idpersonne"] = this.idpersonne;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : <any>undefined;
        data["isApprenant"] = this.isApprenant;
        data["isFormateur"] = this.isFormateur;
        data["isRepresentant"] = this.isRepresentant;
        data["isUser"] = this.isUser;
        data["isChefEntreprise"] = this.isChefEntreprise;
        data["isTuteur"] = this.isTuteur;
        data["isConseillePedagogique"] = this.isConseillePedagogique;
        data["isContact"] = this.isContact;
        return data;
    }

    clone(): BeneficiaryPersonGridDto {
        const json = this.toJSON();
        let result = new BeneficiaryPersonGridDto();
        result.init(json);
        return result;
    }
}

export interface IBeneficiaryPersonGridDto {
    idpersonne?: number;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
    isApprenant?: boolean;
    isFormateur?: boolean;
    isRepresentant?: boolean;
    isUser?: boolean;
    isChefEntreprise?: boolean;
    isTuteur?: boolean;
    isConseillePedagogique?: boolean;
    isContact?: boolean;
}

export class AskResponseDto implements IAskResponseDto {
    answer?: string | undefined;
    expired?: boolean;

    constructor(data?: IAskResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answer = _data["answer"];
            this.expired = _data["expired"];
        }
    }

    static fromJS(data: any): AskResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AskResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answer"] = this.answer;
        data["expired"] = this.expired;
        return data;
    }

    clone(): AskResponseDto {
        const json = this.toJSON();
        let result = new AskResponseDto();
        result.init(json);
        return result;
    }
}

export interface IAskResponseDto {
    answer?: string | undefined;
    expired?: boolean;
}

export class AskRequestDto implements IAskRequestDto {
    prompt?: string | undefined;
    refreshCache?: boolean;

    constructor(data?: IAskRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prompt = _data["prompt"];
            this.refreshCache = _data["refreshCache"];
        }
    }

    static fromJS(data: any): AskRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AskRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prompt"] = this.prompt;
        data["refreshCache"] = this.refreshCache;
        return data;
    }

    clone(): AskRequestDto {
        const json = this.toJSON();
        let result = new AskRequestDto();
        result.init(json);
        return result;
    }
}

export interface IAskRequestDto {
    prompt?: string | undefined;
    refreshCache?: boolean;
}

export class EditCompletedActionDto implements IEditCompletedActionDto {
    idcompletedAction?: number;
    libelle?: string | undefined;
    actif?: boolean;

    constructor(data?: IEditCompletedActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idcompletedAction = _data["idcompletedAction"];
            this.libelle = _data["libelle"];
            this.actif = _data["actif"];
        }
    }

    static fromJS(data: any): EditCompletedActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditCompletedActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idcompletedAction"] = this.idcompletedAction;
        data["libelle"] = this.libelle;
        data["actif"] = this.actif;
        return data;
    }

    clone(): EditCompletedActionDto {
        const json = this.toJSON();
        let result = new EditCompletedActionDto();
        result.init(json);
        return result;
    }
}

export interface IEditCompletedActionDto {
    idcompletedAction?: number;
    libelle?: string | undefined;
    actif?: boolean;
}

export class SearchQueryOfCompletedActionSearchCriteria implements ISearchQueryOfCompletedActionSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: CompletedActionSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfCompletedActionSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? CompletedActionSearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfCompletedActionSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfCompletedActionSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfCompletedActionSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfCompletedActionSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfCompletedActionSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: CompletedActionSearchCriteria | undefined;
}

export class CompletedActionSearchCriteria extends PaginatedSearchable implements ICompletedActionSearchCriteria {

    constructor(data?: ICompletedActionSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CompletedActionSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new CompletedActionSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): CompletedActionSearchCriteria {
        const json = this.toJSON();
        let result = new CompletedActionSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ICompletedActionSearchCriteria extends IPaginatedSearchable {
}

export class PaginatedResultsOfCompletedActionGridDto implements IPaginatedResultsOfCompletedActionGridDto {
    totalCount?: number;
    results?: CompletedActionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfCompletedActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CompletedActionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfCompletedActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfCompletedActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfCompletedActionGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfCompletedActionGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfCompletedActionGridDto {
    totalCount?: number;
    results?: CompletedActionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class CompletedActionGridDto implements ICompletedActionGridDto {
    idcompletedAction?: number;
    libelle?: string | undefined;
    actif?: boolean;

    constructor(data?: ICompletedActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idcompletedAction = _data["idcompletedAction"];
            this.libelle = _data["libelle"];
            this.actif = _data["actif"];
        }
    }

    static fromJS(data: any): CompletedActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompletedActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idcompletedAction"] = this.idcompletedAction;
        data["libelle"] = this.libelle;
        data["actif"] = this.actif;
        return data;
    }

    clone(): CompletedActionGridDto {
        const json = this.toJSON();
        let result = new CompletedActionGridDto();
        result.init(json);
        return result;
    }
}

export interface ICompletedActionGridDto {
    idcompletedAction?: number;
    libelle?: string | undefined;
    actif?: boolean;
}

export class GlobalSearchRowDto implements IGlobalSearchRowDto {
    type?: string | undefined;
    id?: number;
    nom?: string | undefined;
    prenom?: string | undefined;
    description?: string | undefined;
    date?: string | undefined;
    creationUser?: number | undefined;
    beneficiaryId?: number | undefined;

    constructor(data?: IGlobalSearchRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.description = _data["description"];
            this.date = _data["date"];
            this.creationUser = _data["creationUser"];
            this.beneficiaryId = _data["beneficiaryId"];
        }
    }

    static fromJS(data: any): GlobalSearchRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalSearchRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["description"] = this.description;
        data["date"] = this.date;
        data["creationUser"] = this.creationUser;
        data["beneficiaryId"] = this.beneficiaryId;
        return data;
    }

    clone(): GlobalSearchRowDto {
        const json = this.toJSON();
        let result = new GlobalSearchRowDto();
        result.init(json);
        return result;
    }
}

export interface IGlobalSearchRowDto {
    type?: string | undefined;
    id?: number;
    nom?: string | undefined;
    prenom?: string | undefined;
    description?: string | undefined;
    date?: string | undefined;
    creationUser?: number | undefined;
    beneficiaryId?: number | undefined;
}

export class HopeViewPersonneMainDataDto implements IHopeViewPersonneMainDataDto {
    displayName?: string | undefined;
    idapprenant?: number | undefined;
    idrepresentant?: number | undefined;
    idformateur?: number | undefined;
    idchefEntreprise?: number | undefined;
    idtuteur?: number | undefined;
    idcontact?: number | undefined;
    iduser?: number | undefined;

    constructor(data?: IHopeViewPersonneMainDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.idapprenant = _data["idapprenant"];
            this.idrepresentant = _data["idrepresentant"];
            this.idformateur = _data["idformateur"];
            this.idchefEntreprise = _data["idchefEntreprise"];
            this.idtuteur = _data["idtuteur"];
            this.idcontact = _data["idcontact"];
            this.iduser = _data["iduser"];
        }
    }

    static fromJS(data: any): HopeViewPersonneMainDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new HopeViewPersonneMainDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["idapprenant"] = this.idapprenant;
        data["idrepresentant"] = this.idrepresentant;
        data["idformateur"] = this.idformateur;
        data["idchefEntreprise"] = this.idchefEntreprise;
        data["idtuteur"] = this.idtuteur;
        data["idcontact"] = this.idcontact;
        data["iduser"] = this.iduser;
        return data;
    }

    clone(): HopeViewPersonneMainDataDto {
        const json = this.toJSON();
        let result = new HopeViewPersonneMainDataDto();
        result.init(json);
        return result;
    }
}

export interface IHopeViewPersonneMainDataDto {
    displayName?: string | undefined;
    idapprenant?: number | undefined;
    idrepresentant?: number | undefined;
    idformateur?: number | undefined;
    idchefEntreprise?: number | undefined;
    idtuteur?: number | undefined;
    idcontact?: number | undefined;
    iduser?: number | undefined;
}

export class HopeViewSignaletiquePersonneDto implements IHopeViewSignaletiquePersonneDto {
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
    telephones?: TelephoneDto[] | undefined;
    gsms?: TelephoneDto[] | undefined;
    emails?: EmailDto[] | undefined;
    registreNational?: string | undefined;
    numeroIdentification?: string | undefined;
    adresses?: AdresseDto[] | undefined;

    constructor(data?: IHopeViewSignaletiquePersonneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : <any>undefined;
            if (Array.isArray(_data["telephones"])) {
                this.telephones = [] as any;
                for (let item of _data["telephones"])
                    this.telephones!.push(TelephoneDto.fromJS(item));
            }
            if (Array.isArray(_data["gsms"])) {
                this.gsms = [] as any;
                for (let item of _data["gsms"])
                    this.gsms!.push(TelephoneDto.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(EmailDto.fromJS(item));
            }
            this.registreNational = _data["registreNational"];
            this.numeroIdentification = _data["numeroIdentification"];
            if (Array.isArray(_data["adresses"])) {
                this.adresses = [] as any;
                for (let item of _data["adresses"])
                    this.adresses!.push(AdresseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HopeViewSignaletiquePersonneDto {
        data = typeof data === 'object' ? data : {};
        let result = new HopeViewSignaletiquePersonneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : <any>undefined;
        if (Array.isArray(this.telephones)) {
            data["telephones"] = [];
            for (let item of this.telephones)
                data["telephones"].push(item.toJSON());
        }
        if (Array.isArray(this.gsms)) {
            data["gsms"] = [];
            for (let item of this.gsms)
                data["gsms"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        data["registreNational"] = this.registreNational;
        data["numeroIdentification"] = this.numeroIdentification;
        if (Array.isArray(this.adresses)) {
            data["adresses"] = [];
            for (let item of this.adresses)
                data["adresses"].push(item.toJSON());
        }
        return data;
    }

    clone(): HopeViewSignaletiquePersonneDto {
        const json = this.toJSON();
        let result = new HopeViewSignaletiquePersonneDto();
        result.init(json);
        return result;
    }
}

export interface IHopeViewSignaletiquePersonneDto {
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
    telephones?: TelephoneDto[] | undefined;
    gsms?: TelephoneDto[] | undefined;
    emails?: EmailDto[] | undefined;
    registreNational?: string | undefined;
    numeroIdentification?: string | undefined;
    adresses?: AdresseDto[] | undefined;
}

export class HopeViewSuiviActionDto implements IHopeViewSuiviActionDto {
    userFullName?: string | undefined;
    date?: Date | undefined;
    content?: string | undefined;
    contentHidden?: boolean;
    type?: HopeViewSuiviActionType;

    constructor(data?: IHopeViewSuiviActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userFullName = _data["userFullName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.content = _data["content"];
            this.contentHidden = _data["contentHidden"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): HopeViewSuiviActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new HopeViewSuiviActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userFullName"] = this.userFullName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["content"] = this.content;
        data["contentHidden"] = this.contentHidden;
        data["type"] = this.type;
        return data;
    }

    clone(): HopeViewSuiviActionDto {
        const json = this.toJSON();
        let result = new HopeViewSuiviActionDto();
        result.init(json);
        return result;
    }
}

export interface IHopeViewSuiviActionDto {
    userFullName?: string | undefined;
    date?: Date | undefined;
    content?: string | undefined;
    contentHidden?: boolean;
    type?: HopeViewSuiviActionType;
}

export enum HopeViewSuiviActionType {
    Suivi = "Suivi",
    Action = "Action",
    Realisation = "Realisation",
}

export class HopeViewInscriptionDto implements IHopeViewInscriptionDto {
    metier?: string | undefined;
    stade?: string | undefined;
    anneeScolaire?: string | undefined;
    dateInscription?: Date | undefined;
    statut?: string | undefined;
    nomClasse?: string | undefined;
    codeClasse?: string | undefined;
    typeCours?: string | undefined;
    centre?: string | undefined;

    constructor(data?: IHopeViewInscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metier = _data["metier"];
            this.stade = _data["stade"];
            this.anneeScolaire = _data["anneeScolaire"];
            this.dateInscription = _data["dateInscription"] ? new Date(_data["dateInscription"].toString()) : <any>undefined;
            this.statut = _data["statut"];
            this.nomClasse = _data["nomClasse"];
            this.codeClasse = _data["codeClasse"];
            this.typeCours = _data["typeCours"];
            this.centre = _data["centre"];
        }
    }

    static fromJS(data: any): HopeViewInscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new HopeViewInscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metier"] = this.metier;
        data["stade"] = this.stade;
        data["anneeScolaire"] = this.anneeScolaire;
        data["dateInscription"] = this.dateInscription ? this.dateInscription.toISOString() : <any>undefined;
        data["statut"] = this.statut;
        data["nomClasse"] = this.nomClasse;
        data["codeClasse"] = this.codeClasse;
        data["typeCours"] = this.typeCours;
        data["centre"] = this.centre;
        return data;
    }

    clone(): HopeViewInscriptionDto {
        const json = this.toJSON();
        let result = new HopeViewInscriptionDto();
        result.init(json);
        return result;
    }
}

export interface IHopeViewInscriptionDto {
    metier?: string | undefined;
    stade?: string | undefined;
    anneeScolaire?: string | undefined;
    dateInscription?: Date | undefined;
    statut?: string | undefined;
    nomClasse?: string | undefined;
    codeClasse?: string | undefined;
    typeCours?: string | undefined;
    centre?: string | undefined;
}

export class HopeViewHoraireDto implements IHopeViewHoraireDto {
    idclasse?: number;
    annee?: string | undefined;
    jourHeure?: Date | undefined;
    codeClasse?: string | undefined;
    nomClasse?: string | undefined;
    matiere?: string | undefined;
    local?: string | undefined;
    nomformateur?: string | undefined;
    visite?: boolean;
    duree?: number | undefined;
    matiereCode?: string | undefined;
    matiereNom?: string | undefined;

    constructor(data?: IHopeViewHoraireDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idclasse = _data["idclasse"];
            this.annee = _data["annee"];
            this.jourHeure = _data["jourHeure"] ? new Date(_data["jourHeure"].toString()) : <any>undefined;
            this.codeClasse = _data["codeClasse"];
            this.nomClasse = _data["nomClasse"];
            this.matiere = _data["matiere"];
            this.local = _data["local"];
            this.nomformateur = _data["nomformateur"];
            this.visite = _data["visite"];
            this.duree = _data["duree"];
            this.matiereCode = _data["matiereCode"];
            this.matiereNom = _data["matiereNom"];
        }
    }

    static fromJS(data: any): HopeViewHoraireDto {
        data = typeof data === 'object' ? data : {};
        let result = new HopeViewHoraireDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idclasse"] = this.idclasse;
        data["annee"] = this.annee;
        data["jourHeure"] = this.jourHeure ? this.jourHeure.toISOString() : <any>undefined;
        data["codeClasse"] = this.codeClasse;
        data["nomClasse"] = this.nomClasse;
        data["matiere"] = this.matiere;
        data["local"] = this.local;
        data["nomformateur"] = this.nomformateur;
        data["visite"] = this.visite;
        data["duree"] = this.duree;
        data["matiereCode"] = this.matiereCode;
        data["matiereNom"] = this.matiereNom;
        return data;
    }

    clone(): HopeViewHoraireDto {
        const json = this.toJSON();
        let result = new HopeViewHoraireDto();
        result.init(json);
        return result;
    }
}

export interface IHopeViewHoraireDto {
    idclasse?: number;
    annee?: string | undefined;
    jourHeure?: Date | undefined;
    codeClasse?: string | undefined;
    nomClasse?: string | undefined;
    matiere?: string | undefined;
    local?: string | undefined;
    nomformateur?: string | undefined;
    visite?: boolean;
    duree?: number | undefined;
    matiereCode?: string | undefined;
    matiereNom?: string | undefined;
}

export class HopeViewContratDto implements IHopeViewContratDto {
    metier?: string | undefined;
    stade?: string | undefined;
    service?: string | undefined;
    statut?: StatutContrat;
    dateDebut?: Date | undefined;
    dateFin?: Date | undefined;
    dateRupture?: Date | undefined;
    mainLieuFormation?: string | undefined;
    code?: string | undefined;

    constructor(data?: IHopeViewContratDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metier = _data["metier"];
            this.stade = _data["stade"];
            this.service = _data["service"];
            this.statut = _data["statut"];
            this.dateDebut = _data["dateDebut"] ? new Date(_data["dateDebut"].toString()) : <any>undefined;
            this.dateFin = _data["dateFin"] ? new Date(_data["dateFin"].toString()) : <any>undefined;
            this.dateRupture = _data["dateRupture"] ? new Date(_data["dateRupture"].toString()) : <any>undefined;
            this.mainLieuFormation = _data["mainLieuFormation"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): HopeViewContratDto {
        data = typeof data === 'object' ? data : {};
        let result = new HopeViewContratDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metier"] = this.metier;
        data["stade"] = this.stade;
        data["service"] = this.service;
        data["statut"] = this.statut;
        data["dateDebut"] = this.dateDebut ? this.dateDebut.toISOString() : <any>undefined;
        data["dateFin"] = this.dateFin ? this.dateFin.toISOString() : <any>undefined;
        data["dateRupture"] = this.dateRupture ? this.dateRupture.toISOString() : <any>undefined;
        data["mainLieuFormation"] = this.mainLieuFormation;
        data["code"] = this.code;
        return data;
    }

    clone(): HopeViewContratDto {
        const json = this.toJSON();
        let result = new HopeViewContratDto();
        result.init(json);
        return result;
    }
}

export interface IHopeViewContratDto {
    metier?: string | undefined;
    stade?: string | undefined;
    service?: string | undefined;
    statut?: StatutContrat;
    dateDebut?: Date | undefined;
    dateFin?: Date | undefined;
    dateRupture?: Date | undefined;
    mainLieuFormation?: string | undefined;
    code?: string | undefined;
}

export enum StatutContrat {
    EnCours = "EnCours",
    Termine = "Termine",
    Rompu = "Rompu",
    Suspendu = "Suspendu",
    NonDemarre = "NonDemarre",
    SansSuite = "SansSuite",
    NON_AGREE = "NON_AGREE",
    RET = "RET",
    TRANSFERT_CEFA = "TRANSFERT_CEFA",
}

export class HopeViewRepresentantDto implements IHopeViewRepresentantDto {
    id?: number;
    nom?: string | undefined;
    lien?: string | undefined;
    type?: string | undefined;
    idapprenant?: number | undefined;
    idrepresentant?: number | undefined;
    contactUrgence?: boolean;
    representantLegal?: boolean;

    constructor(data?: IHopeViewRepresentantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nom = _data["nom"];
            this.lien = _data["lien"];
            this.type = _data["type"];
            this.idapprenant = _data["idapprenant"];
            this.idrepresentant = _data["idrepresentant"];
            this.contactUrgence = _data["contactUrgence"];
            this.representantLegal = _data["representantLegal"];
        }
    }

    static fromJS(data: any): HopeViewRepresentantDto {
        data = typeof data === 'object' ? data : {};
        let result = new HopeViewRepresentantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nom"] = this.nom;
        data["lien"] = this.lien;
        data["type"] = this.type;
        data["idapprenant"] = this.idapprenant;
        data["idrepresentant"] = this.idrepresentant;
        data["contactUrgence"] = this.contactUrgence;
        data["representantLegal"] = this.representantLegal;
        return data;
    }

    clone(): HopeViewRepresentantDto {
        const json = this.toJSON();
        let result = new HopeViewRepresentantDto();
        result.init(json);
        return result;
    }
}

export interface IHopeViewRepresentantDto {
    id?: number;
    nom?: string | undefined;
    lien?: string | undefined;
    type?: string | undefined;
    idapprenant?: number | undefined;
    idrepresentant?: number | undefined;
    contactUrgence?: boolean;
    representantLegal?: boolean;
}

export class HopeViewApprenantDto implements IHopeViewApprenantDto {
    idapprenant?: number;
    nom?: string | undefined;
    prenom?: string | undefined;
    lienParenté?: string | undefined;

    constructor(data?: IHopeViewApprenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idapprenant = _data["idapprenant"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.lienParenté = _data["lienParenté"];
        }
    }

    static fromJS(data: any): HopeViewApprenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new HopeViewApprenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idapprenant"] = this.idapprenant;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["lienParenté"] = this.lienParenté;
        return data;
    }

    clone(): HopeViewApprenantDto {
        const json = this.toJSON();
        let result = new HopeViewApprenantDto();
        result.init(json);
        return result;
    }
}

export interface IHopeViewApprenantDto {
    idapprenant?: number;
    nom?: string | undefined;
    prenom?: string | undefined;
    lienParenté?: string | undefined;
}

export class HopeViewClasseDto implements IHopeViewClasseDto {
    idformateur?: number;
    idclasse?: number;
    codeClasse?: string | undefined;
    nomClasse?: string | undefined;
    codeMatiere?: string | undefined;
    nomMatiere?: string | undefined;
    dateDebut?: Date | undefined;
    dateFin?: Date | undefined;
    centre?: string | undefined;
    anneeScolaire?: string | undefined;

    constructor(data?: IHopeViewClasseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idformateur = _data["idformateur"];
            this.idclasse = _data["idclasse"];
            this.codeClasse = _data["codeClasse"];
            this.nomClasse = _data["nomClasse"];
            this.codeMatiere = _data["codeMatiere"];
            this.nomMatiere = _data["nomMatiere"];
            this.dateDebut = _data["dateDebut"] ? new Date(_data["dateDebut"].toString()) : <any>undefined;
            this.dateFin = _data["dateFin"] ? new Date(_data["dateFin"].toString()) : <any>undefined;
            this.centre = _data["centre"];
            this.anneeScolaire = _data["anneeScolaire"];
        }
    }

    static fromJS(data: any): HopeViewClasseDto {
        data = typeof data === 'object' ? data : {};
        let result = new HopeViewClasseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idformateur"] = this.idformateur;
        data["idclasse"] = this.idclasse;
        data["codeClasse"] = this.codeClasse;
        data["nomClasse"] = this.nomClasse;
        data["codeMatiere"] = this.codeMatiere;
        data["nomMatiere"] = this.nomMatiere;
        data["dateDebut"] = this.dateDebut ? this.dateDebut.toISOString() : <any>undefined;
        data["dateFin"] = this.dateFin ? this.dateFin.toISOString() : <any>undefined;
        data["centre"] = this.centre;
        data["anneeScolaire"] = this.anneeScolaire;
        return data;
    }

    clone(): HopeViewClasseDto {
        const json = this.toJSON();
        let result = new HopeViewClasseDto();
        result.init(json);
        return result;
    }
}

export interface IHopeViewClasseDto {
    idformateur?: number;
    idclasse?: number;
    codeClasse?: string | undefined;
    nomClasse?: string | undefined;
    codeMatiere?: string | undefined;
    nomMatiere?: string | undefined;
    dateDebut?: Date | undefined;
    dateFin?: Date | undefined;
    centre?: string | undefined;
    anneeScolaire?: string | undefined;
}

export class HopeViewSiegeSocialDto implements IHopeViewSiegeSocialDto {
    idsiegeSocial?: number;
    denominationSociale?: string | undefined;
    gsm?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    localite?: string | undefined;
    commune?: string | undefined;
    numeroBce?: string | undefined;
    chefEntreprisePrincipal?: string | undefined;

    constructor(data?: IHopeViewSiegeSocialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idsiegeSocial = _data["idsiegeSocial"];
            this.denominationSociale = _data["denominationSociale"];
            this.gsm = _data["gsm"];
            this.telephone = _data["telephone"];
            this.email = _data["email"];
            this.localite = _data["localite"];
            this.commune = _data["commune"];
            this.numeroBce = _data["numeroBce"];
            this.chefEntreprisePrincipal = _data["chefEntreprisePrincipal"];
        }
    }

    static fromJS(data: any): HopeViewSiegeSocialDto {
        data = typeof data === 'object' ? data : {};
        let result = new HopeViewSiegeSocialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idsiegeSocial"] = this.idsiegeSocial;
        data["denominationSociale"] = this.denominationSociale;
        data["gsm"] = this.gsm;
        data["telephone"] = this.telephone;
        data["email"] = this.email;
        data["localite"] = this.localite;
        data["commune"] = this.commune;
        data["numeroBce"] = this.numeroBce;
        data["chefEntreprisePrincipal"] = this.chefEntreprisePrincipal;
        return data;
    }

    clone(): HopeViewSiegeSocialDto {
        const json = this.toJSON();
        let result = new HopeViewSiegeSocialDto();
        result.init(json);
        return result;
    }
}

export interface IHopeViewSiegeSocialDto {
    idsiegeSocial?: number;
    denominationSociale?: string | undefined;
    gsm?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    localite?: string | undefined;
    commune?: string | undefined;
    numeroBce?: string | undefined;
    chefEntreprisePrincipal?: string | undefined;
}

export class InboxRowDto implements IInboxRowDto {
    id?: number;
    userFullName?: string | undefined;
    date?: Date | undefined;
    dateEcheance?: Date | undefined;
    title?: string | undefined;
    contentHidden?: boolean;
    type?: HopeViewSuiviActionType;
    apprenant?: string | undefined;
    idapprenant?: number | undefined;
    formateur?: string | undefined;
    idformateur?: number | undefined;
    representant?: string | undefined;
    idrepresentant?: number | undefined;
    chefEntreprise?: string | undefined;
    idchefEntreprise?: number | undefined;
    tuteur?: string | undefined;
    idtuteur?: number | undefined;
    contact?: string | undefined;
    idcontact?: number | undefined;
    service?: string | undefined;
    centre?: string | undefined;
    instituteManagement?: string | undefined;
    otherPartner?: string | undefined;
    idbeneficiary?: number | undefined;
    beneficiary?: string | undefined;

    constructor(data?: IInboxRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userFullName = _data["userFullName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.dateEcheance = _data["dateEcheance"] ? new Date(_data["dateEcheance"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.contentHidden = _data["contentHidden"];
            this.type = _data["type"];
            this.apprenant = _data["apprenant"];
            this.idapprenant = _data["idapprenant"];
            this.formateur = _data["formateur"];
            this.idformateur = _data["idformateur"];
            this.representant = _data["representant"];
            this.idrepresentant = _data["idrepresentant"];
            this.chefEntreprise = _data["chefEntreprise"];
            this.idchefEntreprise = _data["idchefEntreprise"];
            this.tuteur = _data["tuteur"];
            this.idtuteur = _data["idtuteur"];
            this.contact = _data["contact"];
            this.idcontact = _data["idcontact"];
            this.service = _data["service"];
            this.centre = _data["centre"];
            this.instituteManagement = _data["instituteManagement"];
            this.otherPartner = _data["otherPartner"];
            this.idbeneficiary = _data["idbeneficiary"];
            this.beneficiary = _data["beneficiary"];
        }
    }

    static fromJS(data: any): InboxRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new InboxRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userFullName"] = this.userFullName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dateEcheance"] = this.dateEcheance ? this.dateEcheance.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["contentHidden"] = this.contentHidden;
        data["type"] = this.type;
        data["apprenant"] = this.apprenant;
        data["idapprenant"] = this.idapprenant;
        data["formateur"] = this.formateur;
        data["idformateur"] = this.idformateur;
        data["representant"] = this.representant;
        data["idrepresentant"] = this.idrepresentant;
        data["chefEntreprise"] = this.chefEntreprise;
        data["idchefEntreprise"] = this.idchefEntreprise;
        data["tuteur"] = this.tuteur;
        data["idtuteur"] = this.idtuteur;
        data["contact"] = this.contact;
        data["idcontact"] = this.idcontact;
        data["service"] = this.service;
        data["centre"] = this.centre;
        data["instituteManagement"] = this.instituteManagement;
        data["otherPartner"] = this.otherPartner;
        data["idbeneficiary"] = this.idbeneficiary;
        data["beneficiary"] = this.beneficiary;
        return data;
    }

    clone(): InboxRowDto {
        const json = this.toJSON();
        let result = new InboxRowDto();
        result.init(json);
        return result;
    }
}

export interface IInboxRowDto {
    id?: number;
    userFullName?: string | undefined;
    date?: Date | undefined;
    dateEcheance?: Date | undefined;
    title?: string | undefined;
    contentHidden?: boolean;
    type?: HopeViewSuiviActionType;
    apprenant?: string | undefined;
    idapprenant?: number | undefined;
    formateur?: string | undefined;
    idformateur?: number | undefined;
    representant?: string | undefined;
    idrepresentant?: number | undefined;
    chefEntreprise?: string | undefined;
    idchefEntreprise?: number | undefined;
    tuteur?: string | undefined;
    idtuteur?: number | undefined;
    contact?: string | undefined;
    idcontact?: number | undefined;
    service?: string | undefined;
    centre?: string | undefined;
    instituteManagement?: string | undefined;
    otherPartner?: string | undefined;
    idbeneficiary?: number | undefined;
    beneficiary?: string | undefined;
}

export class InboxSearchCriteria implements IInboxSearchCriteria {
    archived?: boolean;
    step?: InboxStep;
    userId?: number | undefined;
    idpersonne?: number | undefined;
    skip?: number;
    take?: number;

    constructor(data?: IInboxSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.archived = _data["archived"];
            this.step = _data["step"];
            this.userId = _data["userId"];
            this.idpersonne = _data["idpersonne"];
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): InboxSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new InboxSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["archived"] = this.archived;
        data["step"] = this.step;
        data["userId"] = this.userId;
        data["idpersonne"] = this.idpersonne;
        data["skip"] = this.skip;
        data["take"] = this.take;
        return data;
    }

    clone(): InboxSearchCriteria {
        const json = this.toJSON();
        let result = new InboxSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface IInboxSearchCriteria {
    archived?: boolean;
    step?: InboxStep;
    userId?: number | undefined;
    idpersonne?: number | undefined;
    skip?: number;
    take?: number;
}

export enum InboxStep {
    Today = "Today",
    Yesterday = "Yesterday",
    ThisWeek = "ThisWeek",
    LastWeek = "LastWeek",
    TwoWeeksAgo = "TwoWeeksAgo",
    ThreeWeeksAgo = "ThreeWeeksAgo",
    ThisMonth = "ThisMonth",
    LastMonth = "LastMonth",
    ThisYear = "ThisYear",
    LastYear = "LastYear",
    Older = "Older",
}

export class InboxStepCountDto implements IInboxStepCountDto {
    step?: InboxStep;
    count?: number;

    constructor(data?: IInboxStepCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.step = _data["step"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): InboxStepCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new InboxStepCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step"] = this.step;
        data["count"] = this.count;
        return data;
    }

    clone(): InboxStepCountDto {
        const json = this.toJSON();
        let result = new InboxStepCountDto();
        result.init(json);
        return result;
    }
}

export interface IInboxStepCountDto {
    step?: InboxStep;
    count?: number;
}

export class InboxCountsCriteria implements IInboxCountsCriteria {
    archived?: boolean;
    userId?: number | undefined;
    idpersonne?: number | undefined;

    constructor(data?: IInboxCountsCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.archived = _data["archived"];
            this.userId = _data["userId"];
            this.idpersonne = _data["idpersonne"];
        }
    }

    static fromJS(data: any): InboxCountsCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new InboxCountsCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["archived"] = this.archived;
        data["userId"] = this.userId;
        data["idpersonne"] = this.idpersonne;
        return data;
    }

    clone(): InboxCountsCriteria {
        const json = this.toJSON();
        let result = new InboxCountsCriteria();
        result.init(json);
        return result;
    }
}

export interface IInboxCountsCriteria {
    archived?: boolean;
    userId?: number | undefined;
    idpersonne?: number | undefined;
}

export class EditInstituteManagementDto implements IEditInstituteManagementDto {
    idinstituteManagement?: number;
    nom?: string | undefined;
    email?: string | undefined;

    constructor(data?: IEditInstituteManagementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idinstituteManagement = _data["idinstituteManagement"];
            this.nom = _data["nom"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): EditInstituteManagementDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditInstituteManagementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idinstituteManagement"] = this.idinstituteManagement;
        data["nom"] = this.nom;
        data["email"] = this.email;
        return data;
    }

    clone(): EditInstituteManagementDto {
        const json = this.toJSON();
        let result = new EditInstituteManagementDto();
        result.init(json);
        return result;
    }
}

export interface IEditInstituteManagementDto {
    idinstituteManagement?: number;
    nom?: string | undefined;
    email?: string | undefined;
}

export class SearchQueryOfInstituteManagementSearchCriteria implements ISearchQueryOfInstituteManagementSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: InstituteManagementSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfInstituteManagementSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? InstituteManagementSearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfInstituteManagementSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfInstituteManagementSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfInstituteManagementSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfInstituteManagementSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfInstituteManagementSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: InstituteManagementSearchCriteria | undefined;
}

export class InstituteManagementSearchCriteria extends PaginatedSearchable implements IInstituteManagementSearchCriteria {

    constructor(data?: IInstituteManagementSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): InstituteManagementSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new InstituteManagementSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): InstituteManagementSearchCriteria {
        const json = this.toJSON();
        let result = new InstituteManagementSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface IInstituteManagementSearchCriteria extends IPaginatedSearchable {
}

export class PaginatedResultsOfInstituteManagementGridDto implements IPaginatedResultsOfInstituteManagementGridDto {
    totalCount?: number;
    results?: InstituteManagementGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfInstituteManagementGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(InstituteManagementGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfInstituteManagementGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfInstituteManagementGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfInstituteManagementGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfInstituteManagementGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfInstituteManagementGridDto {
    totalCount?: number;
    results?: InstituteManagementGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class InstituteManagementGridDto implements IInstituteManagementGridDto {
    idinstituteManagement?: number;
    nom?: string | undefined;
    email?: string | undefined;

    constructor(data?: IInstituteManagementGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idinstituteManagement = _data["idinstituteManagement"];
            this.nom = _data["nom"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): InstituteManagementGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstituteManagementGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idinstituteManagement"] = this.idinstituteManagement;
        data["nom"] = this.nom;
        data["email"] = this.email;
        return data;
    }

    clone(): InstituteManagementGridDto {
        const json = this.toJSON();
        let result = new InstituteManagementGridDto();
        result.init(json);
        return result;
    }
}

export interface IInstituteManagementGridDto {
    idinstituteManagement?: number;
    nom?: string | undefined;
    email?: string | undefined;
}

export class NavFavouriteDto implements INavFavouriteDto {
    idnavFavourite?: number;
    label?: string | undefined;
    url?: string | undefined;

    constructor(data?: INavFavouriteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idnavFavourite = _data["idnavFavourite"];
            this.label = _data["label"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): NavFavouriteDto {
        data = typeof data === 'object' ? data : {};
        let result = new NavFavouriteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idnavFavourite"] = this.idnavFavourite;
        data["label"] = this.label;
        data["url"] = this.url;
        return data;
    }

    clone(): NavFavouriteDto {
        const json = this.toJSON();
        let result = new NavFavouriteDto();
        result.init(json);
        return result;
    }
}

export interface INavFavouriteDto {
    idnavFavourite?: number;
    label?: string | undefined;
    url?: string | undefined;
}

export class NotificationPreferenceDto implements INotificationPreferenceDto {
    iduserNotificationPreference?: number;
    iduser?: number;
    idnotificationType?: number;
    notificationTypeCode?: string | undefined;
    notificationTypeLibelle?: string | undefined;
    emailEnabled?: boolean;
    pushEnabled?: boolean;

    constructor(data?: INotificationPreferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iduserNotificationPreference = _data["iduserNotificationPreference"];
            this.iduser = _data["iduser"];
            this.idnotificationType = _data["idnotificationType"];
            this.notificationTypeCode = _data["notificationTypeCode"];
            this.notificationTypeLibelle = _data["notificationTypeLibelle"];
            this.emailEnabled = _data["emailEnabled"];
            this.pushEnabled = _data["pushEnabled"];
        }
    }

    static fromJS(data: any): NotificationPreferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationPreferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iduserNotificationPreference"] = this.iduserNotificationPreference;
        data["iduser"] = this.iduser;
        data["idnotificationType"] = this.idnotificationType;
        data["notificationTypeCode"] = this.notificationTypeCode;
        data["notificationTypeLibelle"] = this.notificationTypeLibelle;
        data["emailEnabled"] = this.emailEnabled;
        data["pushEnabled"] = this.pushEnabled;
        return data;
    }

    clone(): NotificationPreferenceDto {
        const json = this.toJSON();
        let result = new NotificationPreferenceDto();
        result.init(json);
        return result;
    }
}

export interface INotificationPreferenceDto {
    iduserNotificationPreference?: number;
    iduser?: number;
    idnotificationType?: number;
    notificationTypeCode?: string | undefined;
    notificationTypeLibelle?: string | undefined;
    emailEnabled?: boolean;
    pushEnabled?: boolean;
}

export class EditOtherPartnerDto implements IEditOtherPartnerDto {
    idotherPartner?: number;
    nom?: string | undefined;
    email?: string | undefined;

    constructor(data?: IEditOtherPartnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idotherPartner = _data["idotherPartner"];
            this.nom = _data["nom"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): EditOtherPartnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditOtherPartnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idotherPartner"] = this.idotherPartner;
        data["nom"] = this.nom;
        data["email"] = this.email;
        return data;
    }

    clone(): EditOtherPartnerDto {
        const json = this.toJSON();
        let result = new EditOtherPartnerDto();
        result.init(json);
        return result;
    }
}

export interface IEditOtherPartnerDto {
    idotherPartner?: number;
    nom?: string | undefined;
    email?: string | undefined;
}

export class SearchQueryOfOtherPartnerSearchCriteria implements ISearchQueryOfOtherPartnerSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: OtherPartnerSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfOtherPartnerSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? OtherPartnerSearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfOtherPartnerSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfOtherPartnerSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfOtherPartnerSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfOtherPartnerSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfOtherPartnerSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: OtherPartnerSearchCriteria | undefined;
}

export class OtherPartnerSearchCriteria extends PaginatedSearchable implements IOtherPartnerSearchCriteria {

    constructor(data?: IOtherPartnerSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OtherPartnerSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new OtherPartnerSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): OtherPartnerSearchCriteria {
        const json = this.toJSON();
        let result = new OtherPartnerSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface IOtherPartnerSearchCriteria extends IPaginatedSearchable {
}

export class PaginatedResultsOfOtherPartnerGridDto implements IPaginatedResultsOfOtherPartnerGridDto {
    totalCount?: number;
    results?: OtherPartnerGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfOtherPartnerGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(OtherPartnerGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfOtherPartnerGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfOtherPartnerGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfOtherPartnerGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfOtherPartnerGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfOtherPartnerGridDto {
    totalCount?: number;
    results?: OtherPartnerGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class OtherPartnerGridDto implements IOtherPartnerGridDto {
    idotherPartner?: number;
    nom?: string | undefined;
    email?: string | undefined;

    constructor(data?: IOtherPartnerGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idotherPartner = _data["idotherPartner"];
            this.nom = _data["nom"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): OtherPartnerGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtherPartnerGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idotherPartner"] = this.idotherPartner;
        data["nom"] = this.nom;
        data["email"] = this.email;
        return data;
    }

    clone(): OtherPartnerGridDto {
        const json = this.toJSON();
        let result = new OtherPartnerGridDto();
        result.init(json);
        return result;
    }
}

export interface IOtherPartnerGridDto {
    idotherPartner?: number;
    nom?: string | undefined;
    email?: string | undefined;
}

export class FcbCodePostalDto implements IFcbCodePostalDto {
    idcodePostal?: number;
    codePostal?: string | undefined;
    codePays?: string | undefined;
    commune?: string | undefined;
    localite?: string | undefined;
    modificationDate?: Date | undefined;
    creationDate?: Date | undefined;
    creationUser?: number;
    modificationUser?: number | undefined;
    actif?: boolean | undefined;

    constructor(data?: IFcbCodePostalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idcodePostal = _data["idcodePostal"];
            this.codePostal = _data["codePostal"];
            this.codePays = _data["codePays"];
            this.commune = _data["commune"];
            this.localite = _data["localite"];
            this.modificationDate = _data["modificationDate"] ? new Date(_data["modificationDate"].toString()) : <any>undefined;
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.creationUser = _data["creationUser"];
            this.modificationUser = _data["modificationUser"];
            this.actif = _data["actif"];
        }
    }

    static fromJS(data: any): FcbCodePostalDto {
        data = typeof data === 'object' ? data : {};
        let result = new FcbCodePostalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idcodePostal"] = this.idcodePostal;
        data["codePostal"] = this.codePostal;
        data["codePays"] = this.codePays;
        data["commune"] = this.commune;
        data["localite"] = this.localite;
        data["modificationDate"] = this.modificationDate ? this.modificationDate.toISOString() : <any>undefined;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["creationUser"] = this.creationUser;
        data["modificationUser"] = this.modificationUser;
        data["actif"] = this.actif;
        return data;
    }

    clone(): FcbCodePostalDto {
        const json = this.toJSON();
        let result = new FcbCodePostalDto();
        result.init(json);
        return result;
    }
}

export interface IFcbCodePostalDto {
    idcodePostal?: number;
    codePostal?: string | undefined;
    codePays?: string | undefined;
    commune?: string | undefined;
    localite?: string | undefined;
    modificationDate?: Date | undefined;
    creationDate?: Date | undefined;
    creationUser?: number;
    modificationUser?: number | undefined;
    actif?: boolean | undefined;
}

export class EditReponseTypeDto implements IEditReponseTypeDto {
    idreponseType?: number;
    titre?: string | undefined;
    body?: string | undefined;
    categorie?: string | undefined;
    creationUserName?: string | undefined;
    creationDate?: Date;
    actif?: boolean | undefined;

    constructor(data?: IEditReponseTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idreponseType = _data["idreponseType"];
            this.titre = _data["titre"];
            this.body = _data["body"];
            this.categorie = _data["categorie"];
            this.creationUserName = _data["creationUserName"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.actif = _data["actif"];
        }
    }

    static fromJS(data: any): EditReponseTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditReponseTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idreponseType"] = this.idreponseType;
        data["titre"] = this.titre;
        data["body"] = this.body;
        data["categorie"] = this.categorie;
        data["creationUserName"] = this.creationUserName;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["actif"] = this.actif;
        return data;
    }

    clone(): EditReponseTypeDto {
        const json = this.toJSON();
        let result = new EditReponseTypeDto();
        result.init(json);
        return result;
    }
}

export interface IEditReponseTypeDto {
    idreponseType?: number;
    titre?: string | undefined;
    body?: string | undefined;
    categorie?: string | undefined;
    creationUserName?: string | undefined;
    creationDate?: Date;
    actif?: boolean | undefined;
}

export class EditMultipleReponseTypeDto implements IEditMultipleReponseTypeDto {
    idsreponseType?: number[] | undefined;
    categorie?: string | undefined;

    constructor(data?: IEditMultipleReponseTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["idsreponseType"])) {
                this.idsreponseType = [] as any;
                for (let item of _data["idsreponseType"])
                    this.idsreponseType!.push(item);
            }
            this.categorie = _data["categorie"];
        }
    }

    static fromJS(data: any): EditMultipleReponseTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditMultipleReponseTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.idsreponseType)) {
            data["idsreponseType"] = [];
            for (let item of this.idsreponseType)
                data["idsreponseType"].push(item);
        }
        data["categorie"] = this.categorie;
        return data;
    }

    clone(): EditMultipleReponseTypeDto {
        const json = this.toJSON();
        let result = new EditMultipleReponseTypeDto();
        result.init(json);
        return result;
    }
}

export interface IEditMultipleReponseTypeDto {
    idsreponseType?: number[] | undefined;
    categorie?: string | undefined;
}

export class SearchQueryOfReponseTypeSearchCriteria implements ISearchQueryOfReponseTypeSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: ReponseTypeSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfReponseTypeSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? ReponseTypeSearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfReponseTypeSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfReponseTypeSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfReponseTypeSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfReponseTypeSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfReponseTypeSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: ReponseTypeSearchCriteria | undefined;
}

export class ReponseTypeSearchCriteria extends PaginatedSearchable implements IReponseTypeSearchCriteria {

    constructor(data?: IReponseTypeSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ReponseTypeSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new ReponseTypeSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ReponseTypeSearchCriteria {
        const json = this.toJSON();
        let result = new ReponseTypeSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface IReponseTypeSearchCriteria extends IPaginatedSearchable {
}

export class PaginatedResultsOfReponseTypeGridDto implements IPaginatedResultsOfReponseTypeGridDto {
    totalCount?: number;
    results?: ReponseTypeGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfReponseTypeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ReponseTypeGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfReponseTypeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfReponseTypeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfReponseTypeGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfReponseTypeGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfReponseTypeGridDto {
    totalCount?: number;
    results?: ReponseTypeGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class ReponseTypeGridDto implements IReponseTypeGridDto {
    idreponseType?: number;
    titre?: string | undefined;
    body?: string | undefined;
    creationUserName?: string | undefined;
    creationDate?: Date;
    categorie?: string | undefined;
    actif?: boolean | undefined;

    constructor(data?: IReponseTypeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idreponseType = _data["idreponseType"];
            this.titre = _data["titre"];
            this.body = _data["body"];
            this.creationUserName = _data["creationUserName"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.categorie = _data["categorie"];
            this.actif = _data["actif"];
        }
    }

    static fromJS(data: any): ReponseTypeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReponseTypeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idreponseType"] = this.idreponseType;
        data["titre"] = this.titre;
        data["body"] = this.body;
        data["creationUserName"] = this.creationUserName;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["categorie"] = this.categorie;
        data["actif"] = this.actif;
        return data;
    }

    clone(): ReponseTypeGridDto {
        const json = this.toJSON();
        let result = new ReponseTypeGridDto();
        result.init(json);
        return result;
    }
}

export interface IReponseTypeGridDto {
    idreponseType?: number;
    titre?: string | undefined;
    body?: string | undefined;
    creationUserName?: string | undefined;
    creationDate?: Date;
    categorie?: string | undefined;
    actif?: boolean | undefined;
}

export class EditRequestObjectDto implements IEditRequestObjectDto {
    idrequestObject?: number;
    libelle?: string | undefined;
    actif?: boolean;
    idtypeSuivi?: number | undefined;
    idsousTypeSuivi?: number | undefined;
    recipientGroup?: string | undefined;

    constructor(data?: IEditRequestObjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idrequestObject = _data["idrequestObject"];
            this.libelle = _data["libelle"];
            this.actif = _data["actif"];
            this.idtypeSuivi = _data["idtypeSuivi"];
            this.idsousTypeSuivi = _data["idsousTypeSuivi"];
            this.recipientGroup = _data["recipientGroup"];
        }
    }

    static fromJS(data: any): EditRequestObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditRequestObjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idrequestObject"] = this.idrequestObject;
        data["libelle"] = this.libelle;
        data["actif"] = this.actif;
        data["idtypeSuivi"] = this.idtypeSuivi;
        data["idsousTypeSuivi"] = this.idsousTypeSuivi;
        data["recipientGroup"] = this.recipientGroup;
        return data;
    }

    clone(): EditRequestObjectDto {
        const json = this.toJSON();
        let result = new EditRequestObjectDto();
        result.init(json);
        return result;
    }
}

export interface IEditRequestObjectDto {
    idrequestObject?: number;
    libelle?: string | undefined;
    actif?: boolean;
    idtypeSuivi?: number | undefined;
    idsousTypeSuivi?: number | undefined;
    recipientGroup?: string | undefined;
}

export class SearchQueryOfRequestObjectSearchCriteria implements ISearchQueryOfRequestObjectSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: RequestObjectSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfRequestObjectSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? RequestObjectSearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfRequestObjectSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfRequestObjectSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfRequestObjectSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfRequestObjectSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfRequestObjectSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: RequestObjectSearchCriteria | undefined;
}

export class RequestObjectSearchCriteria extends PaginatedSearchable implements IRequestObjectSearchCriteria {

    constructor(data?: IRequestObjectSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): RequestObjectSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new RequestObjectSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): RequestObjectSearchCriteria {
        const json = this.toJSON();
        let result = new RequestObjectSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface IRequestObjectSearchCriteria extends IPaginatedSearchable {
}

export class PaginatedResultsOfRequestObjectGridDto implements IPaginatedResultsOfRequestObjectGridDto {
    totalCount?: number;
    results?: RequestObjectGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfRequestObjectGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(RequestObjectGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfRequestObjectGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfRequestObjectGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfRequestObjectGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfRequestObjectGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfRequestObjectGridDto {
    totalCount?: number;
    results?: RequestObjectGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class RequestObjectGridDto implements IRequestObjectGridDto {
    idrequestObject?: number;
    libelle?: string | undefined;
    actif?: boolean;

    constructor(data?: IRequestObjectGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idrequestObject = _data["idrequestObject"];
            this.libelle = _data["libelle"];
            this.actif = _data["actif"];
        }
    }

    static fromJS(data: any): RequestObjectGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestObjectGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idrequestObject"] = this.idrequestObject;
        data["libelle"] = this.libelle;
        data["actif"] = this.actif;
        return data;
    }

    clone(): RequestObjectGridDto {
        const json = this.toJSON();
        let result = new RequestObjectGridDto();
        result.init(json);
        return result;
    }
}

export interface IRequestObjectGridDto {
    idrequestObject?: number;
    libelle?: string | undefined;
    actif?: boolean;
}

export class EditSuiviDto implements IEditSuiviDto {
    idsuivi?: number;
    idrealisateurSuivi?: number | undefined;
    idapprenant?: number | undefined;
    idformateur?: number | undefined;
    idrepresentant?: number | undefined;
    idchefEntreprise?: number | undefined;
    idtuteur?: number | undefined;
    idcontact?: number | undefined;
    idinstituteManagement?: number | undefined;
    idmode?: number | undefined;
    idreponseType?: number | undefined;
    contenu?: string | undefined;
    idservice?: number | undefined;
    idcentre?: number | undefined;
    idrequestObject?: number | undefined;
    idotherPartner?: number | undefined;
    recipientGroup?: RecipientGroup;
    idstade?: number | undefined;
    idmetier?: number | undefined;
    titre?: string | undefined;
    notifyBeneficiary?: boolean;
    action?: SuiviActionDto | undefined;
    idsobserver?: number[] | undefined;
    notifyRecipientGroup?: boolean;
    idcodePostal?: number | undefined;
    idcompletedAction?: number | undefined;
    idpersonne?: number;
    telephoneBeneficiary?: string | undefined;
    service?: string | undefined;
    centre?: string | undefined;
    instituteManagement?: string | undefined;
    otherPartner?: string | undefined;
    currentStackIndex?: number;
    oid?: string | undefined;
    forme?: Forme | undefined;
    availableFormes?: BeneficiarySearchFormDto[] | undefined;

    constructor(data?: IEditSuiviDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idsuivi = _data["idsuivi"];
            this.idrealisateurSuivi = _data["idrealisateurSuivi"];
            this.idapprenant = _data["idapprenant"];
            this.idformateur = _data["idformateur"];
            this.idrepresentant = _data["idrepresentant"];
            this.idchefEntreprise = _data["idchefEntreprise"];
            this.idtuteur = _data["idtuteur"];
            this.idcontact = _data["idcontact"];
            this.idinstituteManagement = _data["idinstituteManagement"];
            this.idmode = _data["idmode"];
            this.idreponseType = _data["idreponseType"];
            this.contenu = _data["contenu"];
            this.idservice = _data["idservice"];
            this.idcentre = _data["idcentre"];
            this.idrequestObject = _data["idrequestObject"];
            this.idotherPartner = _data["idotherPartner"];
            this.recipientGroup = _data["recipientGroup"];
            this.idstade = _data["idstade"];
            this.idmetier = _data["idmetier"];
            this.titre = _data["titre"];
            this.notifyBeneficiary = _data["notifyBeneficiary"];
            this.action = _data["action"] ? SuiviActionDto.fromJS(_data["action"]) : <any>undefined;
            if (Array.isArray(_data["idsobserver"])) {
                this.idsobserver = [] as any;
                for (let item of _data["idsobserver"])
                    this.idsobserver!.push(item);
            }
            this.notifyRecipientGroup = _data["notifyRecipientGroup"];
            this.idcodePostal = _data["idcodePostal"];
            this.idcompletedAction = _data["idcompletedAction"];
            this.idpersonne = _data["idpersonne"];
            this.telephoneBeneficiary = _data["telephoneBeneficiary"];
            this.service = _data["service"];
            this.centre = _data["centre"];
            this.instituteManagement = _data["instituteManagement"];
            this.otherPartner = _data["otherPartner"];
            this.currentStackIndex = _data["currentStackIndex"];
            this.oid = _data["oid"];
            this.forme = _data["forme"];
            if (Array.isArray(_data["availableFormes"])) {
                this.availableFormes = [] as any;
                for (let item of _data["availableFormes"])
                    this.availableFormes!.push(BeneficiarySearchFormDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditSuiviDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditSuiviDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idsuivi"] = this.idsuivi;
        data["idrealisateurSuivi"] = this.idrealisateurSuivi;
        data["idapprenant"] = this.idapprenant;
        data["idformateur"] = this.idformateur;
        data["idrepresentant"] = this.idrepresentant;
        data["idchefEntreprise"] = this.idchefEntreprise;
        data["idtuteur"] = this.idtuteur;
        data["idcontact"] = this.idcontact;
        data["idinstituteManagement"] = this.idinstituteManagement;
        data["idmode"] = this.idmode;
        data["idreponseType"] = this.idreponseType;
        data["contenu"] = this.contenu;
        data["idservice"] = this.idservice;
        data["idcentre"] = this.idcentre;
        data["idrequestObject"] = this.idrequestObject;
        data["idotherPartner"] = this.idotherPartner;
        data["recipientGroup"] = this.recipientGroup;
        data["idstade"] = this.idstade;
        data["idmetier"] = this.idmetier;
        data["titre"] = this.titre;
        data["notifyBeneficiary"] = this.notifyBeneficiary;
        data["action"] = this.action ? this.action.toJSON() : <any>undefined;
        if (Array.isArray(this.idsobserver)) {
            data["idsobserver"] = [];
            for (let item of this.idsobserver)
                data["idsobserver"].push(item);
        }
        data["notifyRecipientGroup"] = this.notifyRecipientGroup;
        data["idcodePostal"] = this.idcodePostal;
        data["idcompletedAction"] = this.idcompletedAction;
        data["idpersonne"] = this.idpersonne;
        data["telephoneBeneficiary"] = this.telephoneBeneficiary;
        data["service"] = this.service;
        data["centre"] = this.centre;
        data["instituteManagement"] = this.instituteManagement;
        data["otherPartner"] = this.otherPartner;
        data["currentStackIndex"] = this.currentStackIndex;
        data["oid"] = this.oid;
        data["forme"] = this.forme;
        if (Array.isArray(this.availableFormes)) {
            data["availableFormes"] = [];
            for (let item of this.availableFormes)
                data["availableFormes"].push(item.toJSON());
        }
        return data;
    }

    clone(): EditSuiviDto {
        const json = this.toJSON();
        let result = new EditSuiviDto();
        result.init(json);
        return result;
    }
}

export interface IEditSuiviDto {
    idsuivi?: number;
    idrealisateurSuivi?: number | undefined;
    idapprenant?: number | undefined;
    idformateur?: number | undefined;
    idrepresentant?: number | undefined;
    idchefEntreprise?: number | undefined;
    idtuteur?: number | undefined;
    idcontact?: number | undefined;
    idinstituteManagement?: number | undefined;
    idmode?: number | undefined;
    idreponseType?: number | undefined;
    contenu?: string | undefined;
    idservice?: number | undefined;
    idcentre?: number | undefined;
    idrequestObject?: number | undefined;
    idotherPartner?: number | undefined;
    recipientGroup?: RecipientGroup;
    idstade?: number | undefined;
    idmetier?: number | undefined;
    titre?: string | undefined;
    notifyBeneficiary?: boolean;
    action?: SuiviActionDto | undefined;
    idsobserver?: number[] | undefined;
    notifyRecipientGroup?: boolean;
    idcodePostal?: number | undefined;
    idcompletedAction?: number | undefined;
    idpersonne?: number;
    telephoneBeneficiary?: string | undefined;
    service?: string | undefined;
    centre?: string | undefined;
    instituteManagement?: string | undefined;
    otherPartner?: string | undefined;
    currentStackIndex?: number;
    oid?: string | undefined;
    forme?: Forme | undefined;
    availableFormes?: BeneficiarySearchFormDto[] | undefined;
}

export enum RecipientGroup {
    Center = "Center",
    Service = "Service",
    Institute = "Institute",
    Other = "Other",
}

export class SuiviActionDto implements ISuiviActionDto {
    idsuiviAction?: number;
    idsuivi?: number | undefined;
    dateEcheance?: Date | undefined;
    idtypeSuiviAction?: number | undefined;
    idcollaborateur?: number | undefined;
    dateRealisation?: Date | undefined;
    remarque?: string | undefined;
    idpriorite?: number | undefined;
    idsobserver?: number[] | undefined;

    constructor(data?: ISuiviActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idsuiviAction = _data["idsuiviAction"];
            this.idsuivi = _data["idsuivi"];
            this.dateEcheance = _data["dateEcheance"] ? new Date(_data["dateEcheance"].toString()) : <any>undefined;
            this.idtypeSuiviAction = _data["idtypeSuiviAction"];
            this.idcollaborateur = _data["idcollaborateur"];
            this.dateRealisation = _data["dateRealisation"] ? new Date(_data["dateRealisation"].toString()) : <any>undefined;
            this.remarque = _data["remarque"];
            this.idpriorite = _data["idpriorite"];
            if (Array.isArray(_data["idsobserver"])) {
                this.idsobserver = [] as any;
                for (let item of _data["idsobserver"])
                    this.idsobserver!.push(item);
            }
        }
    }

    static fromJS(data: any): SuiviActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SuiviActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idsuiviAction"] = this.idsuiviAction;
        data["idsuivi"] = this.idsuivi;
        data["dateEcheance"] = this.dateEcheance ? formatDate(this.dateEcheance) : <any>undefined;
        data["idtypeSuiviAction"] = this.idtypeSuiviAction;
        data["idcollaborateur"] = this.idcollaborateur;
        data["dateRealisation"] = this.dateRealisation ? this.dateRealisation.toISOString() : <any>undefined;
        data["remarque"] = this.remarque;
        data["idpriorite"] = this.idpriorite;
        if (Array.isArray(this.idsobserver)) {
            data["idsobserver"] = [];
            for (let item of this.idsobserver)
                data["idsobserver"].push(item);
        }
        return data;
    }

    clone(): SuiviActionDto {
        const json = this.toJSON();
        let result = new SuiviActionDto();
        result.init(json);
        return result;
    }
}

export interface ISuiviActionDto {
    idsuiviAction?: number;
    idsuivi?: number | undefined;
    dateEcheance?: Date | undefined;
    idtypeSuiviAction?: number | undefined;
    idcollaborateur?: number | undefined;
    dateRealisation?: Date | undefined;
    remarque?: string | undefined;
    idpriorite?: number | undefined;
    idsobserver?: number[] | undefined;
}

export class SearchQueryOfSuiviSearchCriteria implements ISearchQueryOfSuiviSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: SuiviSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfSuiviSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? SuiviSearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfSuiviSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfSuiviSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfSuiviSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfSuiviSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfSuiviSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: SuiviSearchCriteria | undefined;
}

export class SuiviSearchCriteria extends PaginatedSearchable implements ISuiviSearchCriteria {
    recent?: boolean;
    realisateur?: number;

    constructor(data?: ISuiviSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.recent = _data["recent"];
            this.realisateur = _data["realisateur"];
        }
    }

    static override fromJS(data: any): SuiviSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SuiviSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recent"] = this.recent;
        data["realisateur"] = this.realisateur;
        super.toJSON(data);
        return data;
    }

    clone(): SuiviSearchCriteria {
        const json = this.toJSON();
        let result = new SuiviSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISuiviSearchCriteria extends IPaginatedSearchable {
    recent?: boolean;
    realisateur?: number;
}

export class PaginatedResultsOfSuiviGridDto implements IPaginatedResultsOfSuiviGridDto {
    totalCount?: number;
    results?: SuiviGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfSuiviGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SuiviGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfSuiviGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfSuiviGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfSuiviGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfSuiviGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfSuiviGridDto {
    totalCount?: number;
    results?: SuiviGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class SuiviGridDto implements ISuiviGridDto {
    idsuivi?: number;
    demande?: string | undefined;
    expediteur?: string | undefined;
    titre?: string | undefined;
    action?: string | undefined;
    responsable?: string | undefined;
    echeance?: Date | undefined;
    creationDate?: Date;
    dateSuivi?: Date | undefined;
    idpersonne?: number | undefined;
    beneficiary?: string | undefined;
    contenu?: string | undefined;
    contentHidingMode?: string | undefined;

    constructor(data?: ISuiviGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idsuivi = _data["idsuivi"];
            this.demande = _data["demande"];
            this.expediteur = _data["expediteur"];
            this.titre = _data["titre"];
            this.action = _data["action"];
            this.responsable = _data["responsable"];
            this.echeance = _data["echeance"] ? new Date(_data["echeance"].toString()) : <any>undefined;
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.dateSuivi = _data["dateSuivi"] ? new Date(_data["dateSuivi"].toString()) : <any>undefined;
            this.idpersonne = _data["idpersonne"];
            this.beneficiary = _data["beneficiary"];
            this.contenu = _data["contenu"];
            this.contentHidingMode = _data["contentHidingMode"];
        }
    }

    static fromJS(data: any): SuiviGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new SuiviGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idsuivi"] = this.idsuivi;
        data["demande"] = this.demande;
        data["expediteur"] = this.expediteur;
        data["titre"] = this.titre;
        data["action"] = this.action;
        data["responsable"] = this.responsable;
        data["echeance"] = this.echeance ? this.echeance.toISOString() : <any>undefined;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["dateSuivi"] = this.dateSuivi ? this.dateSuivi.toISOString() : <any>undefined;
        data["idpersonne"] = this.idpersonne;
        data["beneficiary"] = this.beneficiary;
        data["contenu"] = this.contenu;
        data["contentHidingMode"] = this.contentHidingMode;
        return data;
    }

    clone(): SuiviGridDto {
        const json = this.toJSON();
        let result = new SuiviGridDto();
        result.init(json);
        return result;
    }
}

export interface ISuiviGridDto {
    idsuivi?: number;
    demande?: string | undefined;
    expediteur?: string | undefined;
    titre?: string | undefined;
    action?: string | undefined;
    responsable?: string | undefined;
    echeance?: Date | undefined;
    creationDate?: Date;
    dateSuivi?: Date | undefined;
    idpersonne?: number | undefined;
    beneficiary?: string | undefined;
    contenu?: string | undefined;
    contentHidingMode?: string | undefined;
}

export class SearchQueryOfSuiviStatisticsSearchCriteria implements ISearchQueryOfSuiviStatisticsSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: SuiviStatisticsSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfSuiviStatisticsSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? SuiviStatisticsSearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfSuiviStatisticsSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfSuiviStatisticsSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfSuiviStatisticsSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfSuiviStatisticsSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfSuiviStatisticsSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: SuiviStatisticsSearchCriteria | undefined;
}

export class SuiviStatisticsSearchCriteria extends PaginatedSearchable implements ISuiviStatisticsSearchCriteria {
    titles?: string[] | undefined;

    constructor(data?: ISuiviStatisticsSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(item);
            }
        }
    }

    static override fromJS(data: any): SuiviStatisticsSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SuiviStatisticsSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): SuiviStatisticsSearchCriteria {
        const json = this.toJSON();
        let result = new SuiviStatisticsSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISuiviStatisticsSearchCriteria extends IPaginatedSearchable {
    titles?: string[] | undefined;
}

export class PaginatedResultsOfSuiviStatisticsGridDto implements IPaginatedResultsOfSuiviStatisticsGridDto {
    totalCount?: number;
    results?: SuiviStatisticsGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfSuiviStatisticsGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SuiviStatisticsGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfSuiviStatisticsGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfSuiviStatisticsGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfSuiviStatisticsGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfSuiviStatisticsGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfSuiviStatisticsGridDto {
    totalCount?: number;
    results?: SuiviStatisticsGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class SuiviStatisticsGridDto implements ISuiviStatisticsGridDto {
    idmode?: number | undefined;
    mode?: string | undefined;
    sentFromSmile?: boolean;
    recipientGroup?: RecipientGroup;
    idrequestObject?: number | undefined;
    requestObject?: string | undefined;
    idmetier?: number | undefined;
    metier?: string | undefined;
    idcompletedAction?: number | undefined;
    completedAction?: string | undefined;
    month?: string | undefined;
    monthOrder?: string | undefined;
    year?: number;
    count?: number;
    countProspects?: number;

    constructor(data?: ISuiviStatisticsGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idmode = _data["idmode"];
            this.mode = _data["mode"];
            this.sentFromSmile = _data["sentFromSmile"];
            this.recipientGroup = _data["recipientGroup"];
            this.idrequestObject = _data["idrequestObject"];
            this.requestObject = _data["requestObject"];
            this.idmetier = _data["idmetier"];
            this.metier = _data["metier"];
            this.idcompletedAction = _data["idcompletedAction"];
            this.completedAction = _data["completedAction"];
            this.month = _data["month"];
            this.monthOrder = _data["monthOrder"];
            this.year = _data["year"];
            this.count = _data["count"];
            this.countProspects = _data["countProspects"];
        }
    }

    static fromJS(data: any): SuiviStatisticsGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new SuiviStatisticsGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idmode"] = this.idmode;
        data["mode"] = this.mode;
        data["sentFromSmile"] = this.sentFromSmile;
        data["recipientGroup"] = this.recipientGroup;
        data["idrequestObject"] = this.idrequestObject;
        data["requestObject"] = this.requestObject;
        data["idmetier"] = this.idmetier;
        data["metier"] = this.metier;
        data["idcompletedAction"] = this.idcompletedAction;
        data["completedAction"] = this.completedAction;
        data["month"] = this.month;
        data["monthOrder"] = this.monthOrder;
        data["year"] = this.year;
        data["count"] = this.count;
        data["countProspects"] = this.countProspects;
        return data;
    }

    clone(): SuiviStatisticsGridDto {
        const json = this.toJSON();
        let result = new SuiviStatisticsGridDto();
        result.init(json);
        return result;
    }
}

export interface ISuiviStatisticsGridDto {
    idmode?: number | undefined;
    mode?: string | undefined;
    sentFromSmile?: boolean;
    recipientGroup?: RecipientGroup;
    idrequestObject?: number | undefined;
    requestObject?: string | undefined;
    idmetier?: number | undefined;
    metier?: string | undefined;
    idcompletedAction?: number | undefined;
    completedAction?: string | undefined;
    month?: string | undefined;
    monthOrder?: string | undefined;
    year?: number;
    count?: number;
    countProspects?: number;
}

export class SystemInfoDto implements ISystemInfoDto {
    applicationName?: string | undefined;
    applicationVersion?: string | undefined;
    environment?: string | undefined;
    database?: string | undefined;

    constructor(data?: ISystemInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationName = _data["applicationName"];
            this.applicationVersion = _data["applicationVersion"];
            this.environment = _data["environment"];
            this.database = _data["database"];
        }
    }

    static fromJS(data: any): SystemInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationName"] = this.applicationName;
        data["applicationVersion"] = this.applicationVersion;
        data["environment"] = this.environment;
        data["database"] = this.database;
        return data;
    }

    clone(): SystemInfoDto {
        const json = this.toJSON();
        let result = new SystemInfoDto();
        result.init(json);
        return result;
    }
}

export interface ISystemInfoDto {
    applicationName?: string | undefined;
    applicationVersion?: string | undefined;
    environment?: string | undefined;
    database?: string | undefined;
}

export class ExposedTypes implements IExposedTypes {
    actionCode?: ActionCode;
    errorDetails?: ErrorDetails | undefined;
    errorResult?: ResultError | undefined;
    resultErrors?: ResultError[] | undefined;

    constructor(data?: IExposedTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionCode = _data["actionCode"];
            this.errorDetails = _data["errorDetails"] ? ErrorDetails.fromJS(_data["errorDetails"]) : <any>undefined;
            this.errorResult = _data["errorResult"] ? ResultError.fromJS(_data["errorResult"]) : <any>undefined;
            if (Array.isArray(_data["resultErrors"])) {
                this.resultErrors = [] as any;
                for (let item of _data["resultErrors"])
                    this.resultErrors!.push(ResultError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExposedTypes {
        data = typeof data === 'object' ? data : {};
        let result = new ExposedTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionCode"] = this.actionCode;
        data["errorDetails"] = this.errorDetails ? this.errorDetails.toJSON() : <any>undefined;
        data["errorResult"] = this.errorResult ? this.errorResult.toJSON() : <any>undefined;
        if (Array.isArray(this.resultErrors)) {
            data["resultErrors"] = [];
            for (let item of this.resultErrors)
                data["resultErrors"].push(item.toJSON());
        }
        return data;
    }

    clone(): ExposedTypes {
        const json = this.toJSON();
        let result = new ExposedTypes();
        result.init(json);
        return result;
    }
}

export interface IExposedTypes {
    actionCode?: ActionCode;
    errorDetails?: ErrorDetails | undefined;
    errorResult?: ResultError | undefined;
    resultErrors?: ResultError[] | undefined;
}

export enum ActionCode {
    DeleteActionGroup = "DeleteActionGroup",
    EditDataTranslations = "EditDataTranslations",
    EditRoles = "EditRoles",
    EditUser = "EditUser",
    EditTranslations = "EditTranslations",
    EditAction = "EditAction",
    EditActionGroup = "EditActionGroup",
    ViewData = "ViewData",
    ViewUserActions = "ViewUserActions",
    ManageJobs = "ManageJobs",
    EditReponseType = "EditReponseType",
    EditCompletedAction = "EditCompletedAction",
    EditRequestObject = "EditRequestObject",
    EditOtherPartner = "EditOtherPartner",
    EditInstituteManagement = "EditInstituteManagement",
    EditWorkRule = "EditWorkRule",
    EditBeneficiaryPerson = "EditBeneficiaryPerson",
    ViewUser = "ViewUser",
    EditSuivi = "EditSuivi",
    ViewBeneficiaryCompany = "ViewBeneficiaryCompany",
    ViewSuivi = "ViewSuivi",
    ExportSuivi = "ExportSuivi",
    ChatBot = "ChatBot",
}

export class ErrorDetails implements IErrorDetails {
    statusCode?: number;
    message?: string | undefined;
    stackTrace?: string | undefined;
    exceptionType?: string | undefined;
    errorCode?: string | undefined;

    constructor(data?: IErrorDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.stackTrace = _data["stackTrace"];
            this.exceptionType = _data["exceptionType"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): ErrorDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["stackTrace"] = this.stackTrace;
        data["exceptionType"] = this.exceptionType;
        data["errorCode"] = this.errorCode;
        return data;
    }

    clone(): ErrorDetails {
        const json = this.toJSON();
        let result = new ErrorDetails();
        result.init(json);
        return result;
    }
}

export interface IErrorDetails {
    statusCode?: number;
    message?: string | undefined;
    stackTrace?: string | undefined;
    exceptionType?: string | undefined;
    errorCode?: string | undefined;
}

export abstract class ValueObject implements IValueObject {

    constructor(data?: IValueObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ValueObject {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ValueObject' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ValueObject {
        throw new Error("The abstract class 'ValueObject' cannot be instantiated.");
    }
}

export interface IValueObject {
}

export class ResultError extends ValueObject implements IResultError {
    propertyName?: string | undefined;
    hasPropertyName?: boolean;
    errorCode?: string | undefined;
    errorMessage?: string | undefined;
    errorLevel?: ResultErrorLevel;
    invalidValue?: any | undefined;

    constructor(data?: IResultError) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.hasPropertyName = _data["hasPropertyName"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.errorLevel = _data["errorLevel"];
            this.invalidValue = _data["invalidValue"];
        }
    }

    static override fromJS(data: any): ResultError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultError();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["hasPropertyName"] = this.hasPropertyName;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["errorLevel"] = this.errorLevel;
        data["invalidValue"] = this.invalidValue;
        super.toJSON(data);
        return data;
    }

    clone(): ResultError {
        const json = this.toJSON();
        let result = new ResultError();
        result.init(json);
        return result;
    }
}

export interface IResultError extends IValueObject {
    propertyName?: string | undefined;
    hasPropertyName?: boolean;
    errorCode?: string | undefined;
    errorMessage?: string | undefined;
    errorLevel?: ResultErrorLevel;
    invalidValue?: any | undefined;
}

export enum ResultErrorLevel {
    None = "None",
    Info = "Info",
    Warning = "Warning",
    NotFound = "NotFound",
    Error = "Error",
}

export class FrontendSettings implements IFrontendSettings {
    azureClientId?: string | undefined;
    azureAuthority?: string | undefined;
    azureApiScope?: string | undefined;

    constructor(data?: IFrontendSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.azureClientId = _data["azureClientId"];
            this.azureAuthority = _data["azureAuthority"];
            this.azureApiScope = _data["azureApiScope"];
        }
    }

    static fromJS(data: any): FrontendSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FrontendSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["azureClientId"] = this.azureClientId;
        data["azureAuthority"] = this.azureAuthority;
        data["azureApiScope"] = this.azureApiScope;
        return data;
    }

    clone(): FrontendSettings {
        const json = this.toJSON();
        let result = new FrontendSettings();
        result.init(json);
        return result;
    }
}

export interface IFrontendSettings {
    azureClientId?: string | undefined;
    azureAuthority?: string | undefined;
    azureApiScope?: string | undefined;
}

export class EditUserDto implements IEditUserDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    login?: string | undefined;
    iduser?: number;
    roles?: number[] | undefined;
    isActive?: boolean;
    fullName?: string | undefined;
    fonction?: string | undefined;
    gsm?: string | undefined;
    email?: string | undefined;
    roleName?: UserRoles;

    constructor(data?: IEditUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.login = _data["login"];
            this.iduser = _data["iduser"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.fonction = _data["fonction"];
            this.gsm = _data["gsm"];
            this.email = _data["email"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): EditUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["login"] = this.login;
        data["iduser"] = this.iduser;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["fonction"] = this.fonction;
        data["gsm"] = this.gsm;
        data["email"] = this.email;
        data["roleName"] = this.roleName;
        return data;
    }

    clone(): EditUserDto {
        const json = this.toJSON();
        let result = new EditUserDto();
        result.init(json);
        return result;
    }
}

export interface IEditUserDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    login?: string | undefined;
    iduser?: number;
    roles?: number[] | undefined;
    isActive?: boolean;
    fullName?: string | undefined;
    fonction?: string | undefined;
    gsm?: string | undefined;
    email?: string | undefined;
    roleName?: UserRoles;
}

export enum UserRoles {
    SuperAdmin = "SuperAdmin",
    User = "User",
    Viewer = "Viewer",
}

export class UserSecteurDto implements IUserSecteurDto {
    codesecteur?: string | undefined;
    description?: string | undefined;

    constructor(data?: IUserSecteurDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codesecteur = _data["codesecteur"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UserSecteurDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSecteurDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codesecteur"] = this.codesecteur;
        data["description"] = this.description;
        return data;
    }

    clone(): UserSecteurDto {
        const json = this.toJSON();
        let result = new UserSecteurDto();
        result.init(json);
        return result;
    }
}

export interface IUserSecteurDto {
    codesecteur?: string | undefined;
    description?: string | undefined;
}

export class UserMetierDto implements IUserMetierDto {
    idmetier?: number;
    nom?: string | undefined;
    code?: string | undefined;
    stade?: string | undefined;
    selected?: boolean;

    constructor(data?: IUserMetierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idmetier = _data["idmetier"];
            this.nom = _data["nom"];
            this.code = _data["code"];
            this.stade = _data["stade"];
            this.selected = _data["selected"];
        }
    }

    static fromJS(data: any): UserMetierDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserMetierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idmetier"] = this.idmetier;
        data["nom"] = this.nom;
        data["code"] = this.code;
        data["stade"] = this.stade;
        data["selected"] = this.selected;
        return data;
    }

    clone(): UserMetierDto {
        const json = this.toJSON();
        let result = new UserMetierDto();
        result.init(json);
        return result;
    }
}

export interface IUserMetierDto {
    idmetier?: number;
    nom?: string | undefined;
    code?: string | undefined;
    stade?: string | undefined;
    selected?: boolean;
}

export class MetierLocaliteDto implements IMetierLocaliteDto {
    idcodePostal?: number;
    codePostal?: string | undefined;
    localite?: string | undefined;
    selected?: boolean;

    constructor(data?: IMetierLocaliteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idcodePostal = _data["idcodePostal"];
            this.codePostal = _data["codePostal"];
            this.localite = _data["localite"];
            this.selected = _data["selected"];
        }
    }

    static fromJS(data: any): MetierLocaliteDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetierLocaliteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idcodePostal"] = this.idcodePostal;
        data["codePostal"] = this.codePostal;
        data["localite"] = this.localite;
        data["selected"] = this.selected;
        return data;
    }

    clone(): MetierLocaliteDto {
        const json = this.toJSON();
        let result = new MetierLocaliteDto();
        result.init(json);
        return result;
    }
}

export interface IMetierLocaliteDto {
    idcodePostal?: number;
    codePostal?: string | undefined;
    localite?: string | undefined;
    selected?: boolean;
}

export class UserApprenantDto implements IUserApprenantDto {
    idpersonne?: number;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
    idapprenant?: number;

    constructor(data?: IUserApprenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idpersonne = _data["idpersonne"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : <any>undefined;
            this.idapprenant = _data["idapprenant"];
        }
    }

    static fromJS(data: any): UserApprenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserApprenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idpersonne"] = this.idpersonne;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : <any>undefined;
        data["idapprenant"] = this.idapprenant;
        return data;
    }

    clone(): UserApprenantDto {
        const json = this.toJSON();
        let result = new UserApprenantDto();
        result.init(json);
        return result;
    }
}

export interface IUserApprenantDto {
    idpersonne?: number;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
    idapprenant?: number;
}

export class UserSiegeSocialDto implements IUserSiegeSocialDto {
    idsiegeSocial?: number;
    denominationSociale?: string | undefined;
    numeroBce?: string | undefined;

    constructor(data?: IUserSiegeSocialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idsiegeSocial = _data["idsiegeSocial"];
            this.denominationSociale = _data["denominationSociale"];
            this.numeroBce = _data["numeroBce"];
        }
    }

    static fromJS(data: any): UserSiegeSocialDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSiegeSocialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idsiegeSocial"] = this.idsiegeSocial;
        data["denominationSociale"] = this.denominationSociale;
        data["numeroBce"] = this.numeroBce;
        return data;
    }

    clone(): UserSiegeSocialDto {
        const json = this.toJSON();
        let result = new UserSiegeSocialDto();
        result.init(json);
        return result;
    }
}

export interface IUserSiegeSocialDto {
    idsiegeSocial?: number;
    denominationSociale?: string | undefined;
    numeroBce?: string | undefined;
}

export class UserProfileDto implements IUserProfileDto {
    userId?: number;
    login?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    actions?: ActionCode[] | undefined;
    navFavourites?: NavFavouriteDto[] | undefined;
    isAdmin?: boolean;

    constructor(data?: IUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.login = _data["login"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(item);
            }
            if (Array.isArray(_data["navFavourites"])) {
                this.navFavourites = [] as any;
                for (let item of _data["navFavourites"])
                    this.navFavourites!.push(NavFavouriteDto.fromJS(item));
            }
            this.isAdmin = _data["isAdmin"];
        }
    }

    static fromJS(data: any): UserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["login"] = this.login;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item);
        }
        if (Array.isArray(this.navFavourites)) {
            data["navFavourites"] = [];
            for (let item of this.navFavourites)
                data["navFavourites"].push(item.toJSON());
        }
        data["isAdmin"] = this.isAdmin;
        return data;
    }

    clone(): UserProfileDto {
        const json = this.toJSON();
        let result = new UserProfileDto();
        result.init(json);
        return result;
    }
}

export interface IUserProfileDto {
    userId?: number;
    login?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    actions?: ActionCode[] | undefined;
    navFavourites?: NavFavouriteDto[] | undefined;
    isAdmin?: boolean;
}

export class DisplayNameDto implements IDisplayNameDto {
    id?: number;
    text?: string | undefined;

    constructor(data?: IDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): DisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }

    clone(): DisplayNameDto {
        const json = this.toJSON();
        let result = new DisplayNameDto();
        result.init(json);
        return result;
    }
}

export interface IDisplayNameDto {
    id?: number;
    text?: string | undefined;
}

export class AvailabilityDto implements IAvailabilityDto {
    idavailability?: number;
    label?: string | undefined;
    code?: string | undefined;
    defaultAvailability?: boolean | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;

    constructor(data?: IAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idavailability = _data["idavailability"];
            this.label = _data["label"];
            this.code = _data["code"];
            this.defaultAvailability = _data["defaultAvailability"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
        }
    }

    static fromJS(data: any): AvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idavailability"] = this.idavailability;
        data["label"] = this.label;
        data["code"] = this.code;
        data["defaultAvailability"] = this.defaultAvailability;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        return data;
    }

    clone(): AvailabilityDto {
        const json = this.toJSON();
        let result = new AvailabilityDto();
        result.init(json);
        return result;
    }
}

export interface IAvailabilityDto {
    idavailability?: number;
    label?: string | undefined;
    code?: string | undefined;
    defaultAvailability?: boolean | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
}

export class UserAvailabilityDto implements IUserAvailabilityDto {
    iduserAvailability?: number;
    iduser?: number;
    idavailability?: number;
    jour?: Date;

    constructor(data?: IUserAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iduserAvailability = _data["iduserAvailability"];
            this.iduser = _data["iduser"];
            this.idavailability = _data["idavailability"];
            this.jour = _data["jour"] ? new Date(_data["jour"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserAvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iduserAvailability"] = this.iduserAvailability;
        data["iduser"] = this.iduser;
        data["idavailability"] = this.idavailability;
        data["jour"] = this.jour ? formatDate(this.jour) : <any>undefined;
        return data;
    }

    clone(): UserAvailabilityDto {
        const json = this.toJSON();
        let result = new UserAvailabilityDto();
        result.init(json);
        return result;
    }
}

export interface IUserAvailabilityDto {
    iduserAvailability?: number;
    iduser?: number;
    idavailability?: number;
    jour?: Date;
}

export class SearchQueryOfUserSearchCriteria implements ISearchQueryOfUserSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: UserSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfUserSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? UserSearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfUserSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfUserSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfUserSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfUserSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfUserSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: UserSearchCriteria | undefined;
}

export class UserSearchCriteria extends PaginatedSearchable implements IUserSearchCriteria {
    activeOnly?: boolean;
    recipientGroup?: RecipientGroup | undefined;
    idcodePostal?: number | undefined;
    idinstituteManagement?: number | undefined;
    idotherPartner?: number | undefined;
    idcentre?: number | undefined;
    withAzureData?: boolean;
    fullNameFilter?: string | undefined;

    constructor(data?: IUserSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activeOnly = _data["activeOnly"];
            this.recipientGroup = _data["recipientGroup"];
            this.idcodePostal = _data["idcodePostal"];
            this.idinstituteManagement = _data["idinstituteManagement"];
            this.idotherPartner = _data["idotherPartner"];
            this.idcentre = _data["idcentre"];
            this.withAzureData = _data["withAzureData"];
            this.fullNameFilter = _data["fullNameFilter"];
        }
    }

    static override fromJS(data: any): UserSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new UserSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeOnly"] = this.activeOnly;
        data["recipientGroup"] = this.recipientGroup;
        data["idcodePostal"] = this.idcodePostal;
        data["idinstituteManagement"] = this.idinstituteManagement;
        data["idotherPartner"] = this.idotherPartner;
        data["idcentre"] = this.idcentre;
        data["withAzureData"] = this.withAzureData;
        data["fullNameFilter"] = this.fullNameFilter;
        super.toJSON(data);
        return data;
    }

    clone(): UserSearchCriteria {
        const json = this.toJSON();
        let result = new UserSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface IUserSearchCriteria extends IPaginatedSearchable {
    activeOnly?: boolean;
    recipientGroup?: RecipientGroup | undefined;
    idcodePostal?: number | undefined;
    idinstituteManagement?: number | undefined;
    idotherPartner?: number | undefined;
    idcentre?: number | undefined;
    withAzureData?: boolean;
    fullNameFilter?: string | undefined;
}

export class PaginatedResultsOfUserGridDto implements IPaginatedResultsOfUserGridDto {
    totalCount?: number;
    results?: UserGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfUserGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfUserGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfUserGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfUserGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfUserGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfUserGridDto {
    totalCount?: number;
    results?: UserGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class UserGridDto implements IUserGridDto {
    iduser?: number;
    login?: string | undefined;
    isActive?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    group?: string | undefined;
    fonction?: string | undefined;
    gsm?: string | undefined;
    email?: string | undefined;
    idpersonne?: number | undefined;
    iduserWalter?: number | undefined;

    constructor(data?: IUserGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iduser = _data["iduser"];
            this.login = _data["login"];
            this.isActive = _data["isActive"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.group = _data["group"];
            this.fonction = _data["fonction"];
            this.gsm = _data["gsm"];
            this.email = _data["email"];
            this.idpersonne = _data["idpersonne"];
            this.iduserWalter = _data["iduserWalter"];
        }
    }

    static fromJS(data: any): UserGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iduser"] = this.iduser;
        data["login"] = this.login;
        data["isActive"] = this.isActive;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["group"] = this.group;
        data["fonction"] = this.fonction;
        data["gsm"] = this.gsm;
        data["email"] = this.email;
        data["idpersonne"] = this.idpersonne;
        data["iduserWalter"] = this.iduserWalter;
        return data;
    }

    clone(): UserGridDto {
        const json = this.toJSON();
        let result = new UserGridDto();
        result.init(json);
        return result;
    }
}

export interface IUserGridDto {
    iduser?: number;
    login?: string | undefined;
    isActive?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    group?: string | undefined;
    fonction?: string | undefined;
    gsm?: string | undefined;
    email?: string | undefined;
    idpersonne?: number | undefined;
    iduserWalter?: number | undefined;
}

export class EditWorkRuleDto implements IEditWorkRuleDto {
    idworkRule?: number;
    idrequestObject?: number;
    recipientGroup?: string | undefined;
    idcodePostal?: number | undefined;
    idstade?: number | undefined;
    idsmetier?: number[] | undefined;
    idcompletedAction?: number | undefined;
    idrecipient?: number;
    notifyBeneficiary?: boolean | undefined;
    idsObserver?: number[] | undefined;
    idreponseType?: number | undefined;
    reponseTypeCreate?: EditReponseTypeDto | undefined;
    idsignature?: number | undefined;
    category?: string | undefined;
    actif?: boolean;
    idinstituteManagement?: number | undefined;
    idotherPartner?: number | undefined;
    notifyRecipientGroup?: boolean | undefined;

    constructor(data?: IEditWorkRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idworkRule = _data["idworkRule"];
            this.idrequestObject = _data["idrequestObject"];
            this.recipientGroup = _data["recipientGroup"];
            this.idcodePostal = _data["idcodePostal"];
            this.idstade = _data["idstade"];
            if (Array.isArray(_data["idsmetier"])) {
                this.idsmetier = [] as any;
                for (let item of _data["idsmetier"])
                    this.idsmetier!.push(item);
            }
            this.idcompletedAction = _data["idcompletedAction"];
            this.idrecipient = _data["idrecipient"];
            this.notifyBeneficiary = _data["notifyBeneficiary"];
            if (Array.isArray(_data["idsObserver"])) {
                this.idsObserver = [] as any;
                for (let item of _data["idsObserver"])
                    this.idsObserver!.push(item);
            }
            this.idreponseType = _data["idreponseType"];
            this.reponseTypeCreate = _data["reponseTypeCreate"] ? EditReponseTypeDto.fromJS(_data["reponseTypeCreate"]) : <any>undefined;
            this.idsignature = _data["idsignature"];
            this.category = _data["category"];
            this.actif = _data["actif"];
            this.idinstituteManagement = _data["idinstituteManagement"];
            this.idotherPartner = _data["idotherPartner"];
            this.notifyRecipientGroup = _data["notifyRecipientGroup"];
        }
    }

    static fromJS(data: any): EditWorkRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditWorkRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idworkRule"] = this.idworkRule;
        data["idrequestObject"] = this.idrequestObject;
        data["recipientGroup"] = this.recipientGroup;
        data["idcodePostal"] = this.idcodePostal;
        data["idstade"] = this.idstade;
        if (Array.isArray(this.idsmetier)) {
            data["idsmetier"] = [];
            for (let item of this.idsmetier)
                data["idsmetier"].push(item);
        }
        data["idcompletedAction"] = this.idcompletedAction;
        data["idrecipient"] = this.idrecipient;
        data["notifyBeneficiary"] = this.notifyBeneficiary;
        if (Array.isArray(this.idsObserver)) {
            data["idsObserver"] = [];
            for (let item of this.idsObserver)
                data["idsObserver"].push(item);
        }
        data["idreponseType"] = this.idreponseType;
        data["reponseTypeCreate"] = this.reponseTypeCreate ? this.reponseTypeCreate.toJSON() : <any>undefined;
        data["idsignature"] = this.idsignature;
        data["category"] = this.category;
        data["actif"] = this.actif;
        data["idinstituteManagement"] = this.idinstituteManagement;
        data["idotherPartner"] = this.idotherPartner;
        data["notifyRecipientGroup"] = this.notifyRecipientGroup;
        return data;
    }

    clone(): EditWorkRuleDto {
        const json = this.toJSON();
        let result = new EditWorkRuleDto();
        result.init(json);
        return result;
    }
}

export interface IEditWorkRuleDto {
    idworkRule?: number;
    idrequestObject?: number;
    recipientGroup?: string | undefined;
    idcodePostal?: number | undefined;
    idstade?: number | undefined;
    idsmetier?: number[] | undefined;
    idcompletedAction?: number | undefined;
    idrecipient?: number;
    notifyBeneficiary?: boolean | undefined;
    idsObserver?: number[] | undefined;
    idreponseType?: number | undefined;
    reponseTypeCreate?: EditReponseTypeDto | undefined;
    idsignature?: number | undefined;
    category?: string | undefined;
    actif?: boolean;
    idinstituteManagement?: number | undefined;
    idotherPartner?: number | undefined;
    notifyRecipientGroup?: boolean | undefined;
}

export class SuiviWorkRuleDto implements ISuiviWorkRuleDto {
    idworkRule?: number | undefined;
    idrecipient?: number | undefined;
    titre?: string | undefined;
    body?: string | undefined;
    notifyBeneficiary?: boolean | undefined;
    notifyRecipientGroup?: boolean | undefined;
    idsobserver?: number[] | undefined;
    idcodePostal?: number | undefined;
    idcentre?: number | undefined;
    idreponseType?: number | undefined;
    idservice?: number | undefined;
    service?: string | undefined;
    centre?: string | undefined;
    instituteManagement?: string | undefined;
    otherPartner?: string | undefined;

    constructor(data?: ISuiviWorkRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idworkRule = _data["idworkRule"];
            this.idrecipient = _data["idrecipient"];
            this.titre = _data["titre"];
            this.body = _data["body"];
            this.notifyBeneficiary = _data["notifyBeneficiary"];
            this.notifyRecipientGroup = _data["notifyRecipientGroup"];
            if (Array.isArray(_data["idsobserver"])) {
                this.idsobserver = [] as any;
                for (let item of _data["idsobserver"])
                    this.idsobserver!.push(item);
            }
            this.idcodePostal = _data["idcodePostal"];
            this.idcentre = _data["idcentre"];
            this.idreponseType = _data["idreponseType"];
            this.idservice = _data["idservice"];
            this.service = _data["service"];
            this.centre = _data["centre"];
            this.instituteManagement = _data["instituteManagement"];
            this.otherPartner = _data["otherPartner"];
        }
    }

    static fromJS(data: any): SuiviWorkRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SuiviWorkRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idworkRule"] = this.idworkRule;
        data["idrecipient"] = this.idrecipient;
        data["titre"] = this.titre;
        data["body"] = this.body;
        data["notifyBeneficiary"] = this.notifyBeneficiary;
        data["notifyRecipientGroup"] = this.notifyRecipientGroup;
        if (Array.isArray(this.idsobserver)) {
            data["idsobserver"] = [];
            for (let item of this.idsobserver)
                data["idsobserver"].push(item);
        }
        data["idcodePostal"] = this.idcodePostal;
        data["idcentre"] = this.idcentre;
        data["idreponseType"] = this.idreponseType;
        data["idservice"] = this.idservice;
        data["service"] = this.service;
        data["centre"] = this.centre;
        data["instituteManagement"] = this.instituteManagement;
        data["otherPartner"] = this.otherPartner;
        return data;
    }

    clone(): SuiviWorkRuleDto {
        const json = this.toJSON();
        let result = new SuiviWorkRuleDto();
        result.init(json);
        return result;
    }
}

export interface ISuiviWorkRuleDto {
    idworkRule?: number | undefined;
    idrecipient?: number | undefined;
    titre?: string | undefined;
    body?: string | undefined;
    notifyBeneficiary?: boolean | undefined;
    notifyRecipientGroup?: boolean | undefined;
    idsobserver?: number[] | undefined;
    idcodePostal?: number | undefined;
    idcentre?: number | undefined;
    idreponseType?: number | undefined;
    idservice?: number | undefined;
    service?: string | undefined;
    centre?: string | undefined;
    instituteManagement?: string | undefined;
    otherPartner?: string | undefined;
}

export class EditMultipleWorkRuleDto implements IEditMultipleWorkRuleDto {
    idsworkRule?: number[] | undefined;
    idrequestObject?: number | undefined;
    recipientGroup?: string | undefined;
    idcodePostal?: number | undefined;
    idinstituteManagement?: number | undefined;
    idotherPartner?: number | undefined;
    idsmetier?: number[] | undefined;
    idrecipient?: number | undefined;
    category?: string | undefined;

    constructor(data?: IEditMultipleWorkRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["idsworkRule"])) {
                this.idsworkRule = [] as any;
                for (let item of _data["idsworkRule"])
                    this.idsworkRule!.push(item);
            }
            this.idrequestObject = _data["idrequestObject"];
            this.recipientGroup = _data["recipientGroup"];
            this.idcodePostal = _data["idcodePostal"];
            this.idinstituteManagement = _data["idinstituteManagement"];
            this.idotherPartner = _data["idotherPartner"];
            if (Array.isArray(_data["idsmetier"])) {
                this.idsmetier = [] as any;
                for (let item of _data["idsmetier"])
                    this.idsmetier!.push(item);
            }
            this.idrecipient = _data["idrecipient"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): EditMultipleWorkRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditMultipleWorkRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.idsworkRule)) {
            data["idsworkRule"] = [];
            for (let item of this.idsworkRule)
                data["idsworkRule"].push(item);
        }
        data["idrequestObject"] = this.idrequestObject;
        data["recipientGroup"] = this.recipientGroup;
        data["idcodePostal"] = this.idcodePostal;
        data["idinstituteManagement"] = this.idinstituteManagement;
        data["idotherPartner"] = this.idotherPartner;
        if (Array.isArray(this.idsmetier)) {
            data["idsmetier"] = [];
            for (let item of this.idsmetier)
                data["idsmetier"].push(item);
        }
        data["idrecipient"] = this.idrecipient;
        data["category"] = this.category;
        return data;
    }

    clone(): EditMultipleWorkRuleDto {
        const json = this.toJSON();
        let result = new EditMultipleWorkRuleDto();
        result.init(json);
        return result;
    }
}

export interface IEditMultipleWorkRuleDto {
    idsworkRule?: number[] | undefined;
    idrequestObject?: number | undefined;
    recipientGroup?: string | undefined;
    idcodePostal?: number | undefined;
    idinstituteManagement?: number | undefined;
    idotherPartner?: number | undefined;
    idsmetier?: number[] | undefined;
    idrecipient?: number | undefined;
    category?: string | undefined;
}

export class SearchQueryOfWorkRuleSearchCriteria implements ISearchQueryOfWorkRuleSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: WorkRuleSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfWorkRuleSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? WorkRuleSearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfWorkRuleSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfWorkRuleSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfWorkRuleSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfWorkRuleSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfWorkRuleSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: WorkRuleSearchCriteria | undefined;
}

export class WorkRuleSearchCriteria extends PaginatedSearchable implements IWorkRuleSearchCriteria {

    constructor(data?: IWorkRuleSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): WorkRuleSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRuleSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): WorkRuleSearchCriteria {
        const json = this.toJSON();
        let result = new WorkRuleSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface IWorkRuleSearchCriteria extends IPaginatedSearchable {
}

export class PaginatedResultsOfWorkRuleGridDto implements IPaginatedResultsOfWorkRuleGridDto {
    totalCount?: number;
    results?: WorkRuleGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfWorkRuleGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(WorkRuleGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfWorkRuleGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfWorkRuleGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfWorkRuleGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfWorkRuleGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfWorkRuleGridDto {
    totalCount?: number;
    results?: WorkRuleGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class WorkRuleGridDto implements IWorkRuleGridDto {
    idworkRule?: number;
    requestObject?: string | undefined;
    recipientGroup?: string | undefined;
    localite?: string | undefined;
    metiers?: string | undefined;
    recipient?: string | undefined;
    creationUser?: string | undefined;
    category?: string | undefined;
    creationDate?: Date;
    codesMetiers?: string[] | undefined;

    constructor(data?: IWorkRuleGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idworkRule = _data["idworkRule"];
            this.requestObject = _data["requestObject"];
            this.recipientGroup = _data["recipientGroup"];
            this.localite = _data["localite"];
            this.metiers = _data["metiers"];
            this.recipient = _data["recipient"];
            this.creationUser = _data["creationUser"];
            this.category = _data["category"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["codesMetiers"])) {
                this.codesMetiers = [] as any;
                for (let item of _data["codesMetiers"])
                    this.codesMetiers!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkRuleGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRuleGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idworkRule"] = this.idworkRule;
        data["requestObject"] = this.requestObject;
        data["recipientGroup"] = this.recipientGroup;
        data["localite"] = this.localite;
        data["metiers"] = this.metiers;
        data["recipient"] = this.recipient;
        data["creationUser"] = this.creationUser;
        data["category"] = this.category;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        if (Array.isArray(this.codesMetiers)) {
            data["codesMetiers"] = [];
            for (let item of this.codesMetiers)
                data["codesMetiers"].push(item);
        }
        return data;
    }

    clone(): WorkRuleGridDto {
        const json = this.toJSON();
        let result = new WorkRuleGridDto();
        result.init(json);
        return result;
    }
}

export interface IWorkRuleGridDto {
    idworkRule?: number;
    requestObject?: string | undefined;
    recipientGroup?: string | undefined;
    localite?: string | undefined;
    metiers?: string | undefined;
    recipient?: string | undefined;
    creationUser?: string | undefined;
    category?: string | undefined;
    creationDate?: Date;
    codesMetiers?: string[] | undefined;
}

export class HealthCheckViewModel implements IHealthCheckViewModel {
    globalStatus?: string | undefined;
    checkTime?: Date;
    worstExecutionTime?: string | undefined;
    totalExecutionTime?: string | undefined;
    entries?: HealthCheckEntryViewModel[] | undefined;

    constructor(data?: IHealthCheckViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.globalStatus = _data["globalStatus"];
            this.checkTime = _data["checkTime"] ? new Date(_data["checkTime"].toString()) : <any>undefined;
            this.worstExecutionTime = _data["worstExecutionTime"];
            this.totalExecutionTime = _data["totalExecutionTime"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(HealthCheckEntryViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HealthCheckViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["globalStatus"] = this.globalStatus;
        data["checkTime"] = this.checkTime ? this.checkTime.toISOString() : <any>undefined;
        data["worstExecutionTime"] = this.worstExecutionTime;
        data["totalExecutionTime"] = this.totalExecutionTime;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data;
    }

    clone(): HealthCheckViewModel {
        const json = this.toJSON();
        let result = new HealthCheckViewModel();
        result.init(json);
        return result;
    }
}

export interface IHealthCheckViewModel {
    globalStatus?: string | undefined;
    checkTime?: Date;
    worstExecutionTime?: string | undefined;
    totalExecutionTime?: string | undefined;
    entries?: HealthCheckEntryViewModel[] | undefined;
}

export class HealthCheckEntryViewModel implements IHealthCheckEntryViewModel {
    name?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    statusDescription?: string | undefined;
    executionTime?: string | undefined;
    context?: { [key: string]: string[]; } | undefined;

    constructor(data?: IHealthCheckEntryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.statusDescription = _data["statusDescription"];
            this.executionTime = _data["executionTime"];
            if (_data["context"]) {
                this.context = {} as any;
                for (let key in _data["context"]) {
                    if (_data["context"].hasOwnProperty(key))
                        (<any>this.context)![key] = _data["context"][key] !== undefined ? _data["context"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HealthCheckEntryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckEntryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["statusDescription"] = this.statusDescription;
        data["executionTime"] = this.executionTime;
        if (this.context) {
            data["context"] = {};
            for (let key in this.context) {
                if (this.context.hasOwnProperty(key))
                    (<any>data["context"])[key] = (<any>this.context)[key];
            }
        }
        return data;
    }

    clone(): HealthCheckEntryViewModel {
        const json = this.toJSON();
        let result = new HealthCheckEntryViewModel();
        result.init(json);
        return result;
    }
}

export interface IHealthCheckEntryViewModel {
    name?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    statusDescription?: string | undefined;
    executionTime?: string | undefined;
    context?: { [key: string]: string[]; } | undefined;
}

export class ClientApiKey implements IClientApiKey {
    clientName?: string | undefined;
    clientId?: string | undefined;
    apiKey?: string | undefined;
    hashedApiKey?: string | undefined;

    constructor(data?: IClientApiKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientName = _data["clientName"];
            this.clientId = _data["clientId"];
            this.apiKey = _data["apiKey"];
            this.hashedApiKey = _data["hashedApiKey"];
        }
    }

    static fromJS(data: any): ClientApiKey {
        data = typeof data === 'object' ? data : {};
        let result = new ClientApiKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientName"] = this.clientName;
        data["clientId"] = this.clientId;
        data["apiKey"] = this.apiKey;
        data["hashedApiKey"] = this.hashedApiKey;
        return data;
    }

    clone(): ClientApiKey {
        const json = this.toJSON();
        let result = new ClientApiKey();
        result.init(json);
        return result;
    }
}

export interface IClientApiKey {
    clientName?: string | undefined;
    clientId?: string | undefined;
    apiKey?: string | undefined;
    hashedApiKey?: string | undefined;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

export const BASE_PATH = "http://localhost".replace(/\/+$/, "");

export interface Middleware {
  pre?(context: RequestInit): Promise<RequestInit | void>;

  post?(response: Response): Promise<Response | void>;
}

export interface Configuration {
  basePath?: string; // override base path
  apiKey?: string; // parameter for apiKey security
  apiKeyPromise?: () => Promise<string>;
  headers?: HTTPHeaders; //header params we want to use on every request
  credentials?: RequestCredentials; //value for the credentials param we want to use on each request
  middlewares?: Middleware[];
}

export type Json = any;
export type HTTPMethod =
  | "GET"
  | "POST"
  | "PUT"
  | "PATCH"
  | "DELETE"
  | "OPTIONS";
export type HTTPHeaders = { [key: string]: string };